var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import require$$0, { memo, useState } from "react";
const root$H = "_root_1h0vh_1";
const classes$D = {
  root: root$H
};
const storybrainResets = "_storybrainResets_1wrjq_1";
const resets = {
  storybrainResets
};
const ptContribution$1 = "_ptContribution_uhs2b_1";
const ptResultDamageTaken$1 = "_ptResultDamageTaken_uhs2b_16";
const ptResultDamageDone$1 = "_ptResultDamageDone_uhs2b_28";
const ptResultMissionLose$1 = "_ptResultMissionLose_uhs2b_40";
const ptResultMissionWin$1 = "_ptResultMissionWin_uhs2b_52";
const cContentAreaModifier$1 = "_cContentAreaModifier_uhs2b_64";
const ptBulletItemContent$2 = "_ptBulletItemContent_uhs2b_69";
const ptBulletItemContent2$1 = "_ptBulletItemContent2_uhs2b_79";
const ptBulletItemContent3$1 = "_ptBulletItemContent3_uhs2b_89";
const ptBulletItemContent4$1 = "_ptBulletItemContent4_uhs2b_99";
const ptBulletItemContent5 = "_ptBulletItemContent5_uhs2b_109";
const ptBulletItemContent6 = "_ptBulletItemContent6_uhs2b_119";
const ptBulletItemContent7 = "_ptBulletItemContent7_uhs2b_129";
const ptBulletItemContent8 = "_ptBulletItemContent8_uhs2b_139";
const ptDropFirearmStatCurr$1 = "_ptDropFirearmStatCurr_uhs2b_149";
const ptDropFirearmStatMax$1 = "_ptDropFirearmStatMax_uhs2b_161";
const ptDropFirearmName$2 = "_ptDropFirearmName_uhs2b_173";
const ptDropFirearmStatCurr2 = "_ptDropFirearmStatCurr2_uhs2b_183";
const ptDropFirearmStatMax2 = "_ptDropFirearmStatMax2_uhs2b_195";
const ptDropFirearmName2$1 = "_ptDropFirearmName2_uhs2b_207";
const ptDropFirearmStatCurr3 = "_ptDropFirearmStatCurr3_uhs2b_217";
const ptDropFirearmStatMax3 = "_ptDropFirearmStatMax3_uhs2b_229";
const icon$w = "_icon_uhs2b_241";
const ptDropFirearmRate$1 = "_ptDropFirearmRate_uhs2b_246";
const ptDropFirearmType$1 = "_ptDropFirearmType_uhs2b_265";
const ptDropFirearmName3$1 = "_ptDropFirearmName3_uhs2b_276";
const ptDropFirearmStatCurr4 = "_ptDropFirearmStatCurr4_uhs2b_286";
const ptDropFirearmStatMax4 = "_ptDropFirearmStatMax4_uhs2b_298";
const icon2$a = "_icon2_uhs2b_310";
const ptItemText$2 = "_ptItemText_uhs2b_315";
const icon3$6 = "_icon3_uhs2b_329";
const ptItemText2$1 = "_ptItemText2_uhs2b_334";
const icon4$5 = "_icon4_uhs2b_348";
const ptItemText3$1 = "_ptItemText3_uhs2b_353";
const icon5$4 = "_icon5_uhs2b_367";
const ptNation = "_ptNation_uhs2b_372";
const rectangle$5 = "_rectangle_uhs2b_386";
const ptGradeName$2 = "_ptGradeName_uhs2b_392";
const ptGradeValue$2 = "_ptGradeValue_uhs2b_409";
const ptGradeName2$1 = "_ptGradeName2_uhs2b_426";
const ptGradeValue2$1 = "_ptGradeValue2_uhs2b_443";
const ptGradeName3 = "_ptGradeName3_uhs2b_460";
const ptGradeValue3 = "_ptGradeValue3_uhs2b_477";
const icon6$4 = "_icon6_uhs2b_494";
const ptValue$2 = "_ptValue_uhs2b_499";
const ptMax$2 = "_ptMax_uhs2b_513";
const icon7$4 = "_icon7_uhs2b_527";
const ptValue2$1 = "_ptValue2_uhs2b_532";
const ptMax2$1 = "_ptMax2_uhs2b_546";
const icon8$4 = "_icon8_uhs2b_560";
const ptValue3$1 = "_ptValue3_uhs2b_565";
const ptMax3 = "_ptMax3_uhs2b_579";
const ptGrade$1 = "_ptGrade_uhs2b_392";
const ptGrade2$1 = "_ptGrade2_uhs2b_608";
const icon9$3 = "_icon9_uhs2b_626";
const ptExpValue = "_ptExpValue_uhs2b_631";
const ptMax4 = "_ptMax4_uhs2b_645";
const ptLevelValue$1 = "_ptLevelValue_uhs2b_659";
const icon10$3 = "_icon10_uhs2b_677";
const ptAgentName$1 = "_ptAgentName_uhs2b_682";
const union$7 = "_union_uhs2b_695";
const throwable_Info$2 = "_throwable_Info_uhs2b_704";
const throwable_Info2$2 = "_throwable_Info2_uhs2b_713";
const bulletProof_Info$2 = "_bulletProof_Info_uhs2b_722";
const firearm_Info$2 = "_firearm_Info_uhs2b_731";
const icon11$3 = "_icon11_uhs2b_740";
const deco_Line$2 = "_deco_Line_uhs2b_745";
const image_AgentPotrait$2 = "_image_AgentPotrait_uhs2b_754";
const rectangle2$2 = "_rectangle2_uhs2b_760";
const icon12$3 = "_icon12_uhs2b_766";
const union2$1 = "_union2_uhs2b_771";
const throwable_Info3$1 = "_throwable_Info3_uhs2b_780";
const throwable_Info4$1 = "_throwable_Info4_uhs2b_789";
const bulletProof_Info2$1 = "_bulletProof_Info2_uhs2b_798";
const firearm_Info2$1 = "_firearm_Info2_uhs2b_807";
const icon13$3 = "_icon13_uhs2b_816";
const deco_Line2$1 = "_deco_Line2_uhs2b_821";
const image_AgentPotrait2$1 = "_image_AgentPotrait2_uhs2b_830";
const rectangle3$2 = "_rectangle3_uhs2b_836";
const icon14$3 = "_icon14_uhs2b_842";
const union3$1 = "_union3_uhs2b_847";
const throwable_Info5$1 = "_throwable_Info5_uhs2b_856";
const throwable_Info6$1 = "_throwable_Info6_uhs2b_865";
const bulletProof_Info3$1 = "_bulletProof_Info3_uhs2b_874";
const firearm_Info3$1 = "_firearm_Info3_uhs2b_883";
const icon15$3 = "_icon15_uhs2b_892";
const deco_Line3$1 = "_deco_Line3_uhs2b_897";
const image_AgentPotrait3$1 = "_image_AgentPotrait3_uhs2b_906";
const rectangle4$1 = "_rectangle4_uhs2b_912";
const icon16$2 = "_icon16_uhs2b_918";
const ptTotalValue$1 = "_ptTotalValue_uhs2b_923";
const bulletItem___HGAP1_instance = "_bulletItem___HGAP1_instance_uhs2b_935";
const ptBulletItemContent9 = "_ptBulletItemContent9_uhs2b_941";
const button_Equipments_2 = "_button_Equipments_2_uhs2b_951";
const ptDropFirearmRate2 = "_ptDropFirearmRate2_uhs2b_956";
const ptDropFirearmType2 = "_ptDropFirearmType2_uhs2b_975";
const ptDropFirearmName4 = "_ptDropFirearmName4_uhs2b_986";
const button_Equipments_1 = "_button_Equipments_1_uhs2b_996";
const aC_state_instance = "_aC_state_instance_uhs2b_1001";
const aC_state_instance2 = "_aC_state_instance2_uhs2b_1006";
const aC_state_instance3 = "_aC_state_instance3_uhs2b_1011";
const aC_state_instance4 = "_aC_state_instance4_uhs2b_1016";
const agentCard___PR_Instance = "_agentCard___PR_Instance_uhs2b_1021";
const union4 = "_union4_uhs2b_1027";
const throwable_Info7 = "_throwable_Info7_uhs2b_1036";
const throwable_Info8 = "_throwable_Info8_uhs2b_1045";
const bulletProof_Info4 = "_bulletProof_Info4_uhs2b_1054";
const firearm_Info4 = "_firearm_Info4_uhs2b_1063";
const icon17$1 = "_icon17_uhs2b_1072";
const ptFirearmGrade$1 = "_ptFirearmGrade_uhs2b_1077";
const ptFirearmType$1 = "_ptFirearmType_uhs2b_1097";
const ptFirearmName$1 = "_ptFirearmName_uhs2b_1108";
const deco_Line4 = "_deco_Line4_uhs2b_1120";
const ptGradeBg$1 = "_ptGradeBg_uhs2b_1129";
const ptGradeFg$1 = "_ptGradeFg_uhs2b_1143";
const image_AgentPotrait4 = "_image_AgentPotrait4_uhs2b_1157";
const ptLifeValue$1 = "_ptLifeValue_uhs2b_1163";
const ptOverallValue$1 = "_ptOverallValue_uhs2b_1179";
const ptPhysicalValue$1 = "_ptPhysicalValue_uhs2b_1195";
const rectangle5$1 = "_rectangle5_uhs2b_1211";
const ptPerkpoint$1 = "_ptPerkpoint_uhs2b_1217";
const icon18$1 = "_icon18_uhs2b_1228";
const ptName$1 = "_ptName_uhs2b_1233";
const ptAge$1 = "_ptAge_uhs2b_682";
const ptLevel$1 = "_ptLevel_uhs2b_659";
const aC_state$5 = "_aC_state_uhs2b_1001";
const root$G = "_root_uhs2b_1282";
const dummyBG = "_dummyBG_uhs2b_1292";
const mercenariesOverview = "_mercenariesOverview_uhs2b_1307";
const common = "_common_uhs2b_1319";
const icon_Result = "_icon_Result_uhs2b_1331";
const contentArea = "_contentArea_uhs2b_1347";
const icon_Equipment$2 = "_icon_Equipment_uhs2b_1363";
const bookmark_Stauts = "_bookmark_Stauts_uhs2b_1379";
const button_Equipments = "_button_Equipments_uhs2b_951";
const agentState$1 = "_agentState_uhs2b_1411";
const iconDoing$1 = "_iconDoing_uhs2b_1427";
const throwable_Info9 = "_throwable_Info9_uhs2b_1443";
const bulletProof_Info5 = "_bulletProof_Info5_uhs2b_1459";
const firearm_Info5 = "_firearm_Info5_uhs2b_1475";
const button_Dropdown_Rearrange$1 = "_button_Dropdown_Rearrange_uhs2b_1491";
const button_TabMenu = "_button_TabMenu_uhs2b_1507";
const button_CheckBox_AgentCard = "_button_CheckBox_AgentCard_uhs2b_1523";
const aC_mouse = "_aC_mouse_uhs2b_1539";
const aC_state2 = "_aC_state2_uhs2b_1555";
const button_Radio_OnOff = "_button_Radio_OnOff_uhs2b_1571";
const button_Radio = "_button_Radio_uhs2b_1571";
const button_Toggle_Order = "_button_Toggle_Order_uhs2b_1603";
const button_Toggle = "_button_Toggle_uhs2b_1603";
const icon_Fold = "_icon_Fold_uhs2b_1631";
const icon_Order = "_icon_Order_uhs2b_1647";
const classes$C = {
  ptContribution: ptContribution$1,
  ptResultDamageTaken: ptResultDamageTaken$1,
  ptResultDamageDone: ptResultDamageDone$1,
  ptResultMissionLose: ptResultMissionLose$1,
  ptResultMissionWin: ptResultMissionWin$1,
  cContentAreaModifier: cContentAreaModifier$1,
  ptBulletItemContent: ptBulletItemContent$2,
  ptBulletItemContent2: ptBulletItemContent2$1,
  ptBulletItemContent3: ptBulletItemContent3$1,
  ptBulletItemContent4: ptBulletItemContent4$1,
  ptBulletItemContent5,
  ptBulletItemContent6,
  ptBulletItemContent7,
  ptBulletItemContent8,
  ptDropFirearmStatCurr: ptDropFirearmStatCurr$1,
  ptDropFirearmStatMax: ptDropFirearmStatMax$1,
  ptDropFirearmName: ptDropFirearmName$2,
  ptDropFirearmStatCurr2,
  ptDropFirearmStatMax2,
  ptDropFirearmName2: ptDropFirearmName2$1,
  ptDropFirearmStatCurr3,
  ptDropFirearmStatMax3,
  icon: icon$w,
  ptDropFirearmRate: ptDropFirearmRate$1,
  ptDropFirearmType: ptDropFirearmType$1,
  ptDropFirearmName3: ptDropFirearmName3$1,
  ptDropFirearmStatCurr4,
  ptDropFirearmStatMax4,
  icon2: icon2$a,
  ptItemText: ptItemText$2,
  icon3: icon3$6,
  ptItemText2: ptItemText2$1,
  icon4: icon4$5,
  ptItemText3: ptItemText3$1,
  icon5: icon5$4,
  ptNation,
  rectangle: rectangle$5,
  ptGradeName: ptGradeName$2,
  ptGradeValue: ptGradeValue$2,
  ptGradeName2: ptGradeName2$1,
  ptGradeValue2: ptGradeValue2$1,
  ptGradeName3,
  ptGradeValue3,
  icon6: icon6$4,
  ptValue: ptValue$2,
  ptMax: ptMax$2,
  icon7: icon7$4,
  ptValue2: ptValue2$1,
  ptMax2: ptMax2$1,
  icon8: icon8$4,
  ptValue3: ptValue3$1,
  ptMax3,
  ptGrade: ptGrade$1,
  ptGrade2: ptGrade2$1,
  icon9: icon9$3,
  ptExpValue,
  ptMax4,
  ptLevelValue: ptLevelValue$1,
  icon10: icon10$3,
  ptAgentName: ptAgentName$1,
  union: union$7,
  throwable_Info: throwable_Info$2,
  throwable_Info2: throwable_Info2$2,
  bulletProof_Info: bulletProof_Info$2,
  firearm_Info: firearm_Info$2,
  icon11: icon11$3,
  deco_Line: deco_Line$2,
  image_AgentPotrait: image_AgentPotrait$2,
  rectangle2: rectangle2$2,
  icon12: icon12$3,
  union2: union2$1,
  throwable_Info3: throwable_Info3$1,
  throwable_Info4: throwable_Info4$1,
  bulletProof_Info2: bulletProof_Info2$1,
  firearm_Info2: firearm_Info2$1,
  icon13: icon13$3,
  deco_Line2: deco_Line2$1,
  image_AgentPotrait2: image_AgentPotrait2$1,
  rectangle3: rectangle3$2,
  icon14: icon14$3,
  union3: union3$1,
  throwable_Info5: throwable_Info5$1,
  throwable_Info6: throwable_Info6$1,
  bulletProof_Info3: bulletProof_Info3$1,
  firearm_Info3: firearm_Info3$1,
  icon15: icon15$3,
  deco_Line3: deco_Line3$1,
  image_AgentPotrait3: image_AgentPotrait3$1,
  rectangle4: rectangle4$1,
  icon16: icon16$2,
  ptTotalValue: ptTotalValue$1,
  bulletItem___HGAP1_instance,
  ptBulletItemContent9,
  button_Equipments_2,
  ptDropFirearmRate2,
  ptDropFirearmType2,
  ptDropFirearmName4,
  button_Equipments_1,
  aC_state_instance,
  aC_state_instance2,
  aC_state_instance3,
  aC_state_instance4,
  agentCard___PR_Instance,
  union4,
  throwable_Info7,
  throwable_Info8,
  bulletProof_Info4,
  firearm_Info4,
  icon17: icon17$1,
  ptFirearmGrade: ptFirearmGrade$1,
  ptFirearmType: ptFirearmType$1,
  ptFirearmName: ptFirearmName$1,
  deco_Line4,
  ptGradeBg: ptGradeBg$1,
  ptGradeFg: ptGradeFg$1,
  image_AgentPotrait4,
  ptLifeValue: ptLifeValue$1,
  ptOverallValue: ptOverallValue$1,
  ptPhysicalValue: ptPhysicalValue$1,
  rectangle5: rectangle5$1,
  ptPerkpoint: ptPerkpoint$1,
  icon18: icon18$1,
  ptName: ptName$1,
  ptAge: ptAge$1,
  ptLevel: ptLevel$1,
  aC_state: aC_state$5,
  root: root$G,
  dummyBG,
  mercenariesOverview,
  common,
  icon_Result,
  contentArea,
  icon_Equipment: icon_Equipment$2,
  bookmark_Stauts,
  button_Equipments,
  agentState: agentState$1,
  iconDoing: iconDoing$1,
  throwable_Info9,
  bulletProof_Info5,
  firearm_Info5,
  button_Dropdown_Rearrange: button_Dropdown_Rearrange$1,
  button_TabMenu,
  button_CheckBox_AgentCard,
  aC_mouse,
  aC_state2,
  button_Radio_OnOff,
  button_Radio,
  button_Toggle_Order,
  button_Toggle,
  icon_Fold,
  icon_Order
};
const root$F = "_root_1jiik_1";
const rectangle$4 = "_rectangle_1jiik_9";
const icon$v = "_icon_1jiik_17";
const deco$3 = "_deco_1jiik_21";
const icon2$9 = "_icon2_1jiik_29";
const classes$B = {
  root: root$F,
  rectangle: rectangle$4,
  icon: icon$v,
  deco: deco$3,
  icon2: icon2$9
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level2, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item2) {
            return String(item2);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level2], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name2, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name2;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame3 = componentFrameCache.get(fn);
          if (frame3 !== void 0) {
            return frame3;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name2 = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          $$typeof: REACT_ELEMENT_TYPE,
          type,
          key,
          ref,
          props,
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name2 = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name2) {
              return "\n\nCheck the render method of `" + name2 + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name2 = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name2, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactJsxRuntime_production_min();
  } else {
    module.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);
const Fragment = jsxRuntime.exports.Fragment;
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const DecoIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 10 920",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    width: 10,
    height: 920,
    fill: "#B57700"
  }), /* @__PURE__ */ jsx("path", {
    d: "M5 0C5 351.801 5 568.199 5 920",
    stroke: "#A06900",
    strokeWidth: 2
  })]
}));
const Memo$18 = memo(DecoIcon);
const RectangleIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 1522 920",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0H1507C1515.28 0 1522 6.71573 1522 15V905C1522 913.284 1515.28 920 1507 920H15C6.71572 920 0 913.284 0 905V0Z",
    fill: "#BC7F08",
    stroke: "#D69A27",
    strokeWidth: 2
  })
}));
const Memo$17 = memo(RectangleIcon);
const AgentDetailBg = memo(function AgentDetailBg2(props = {}) {
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes$B.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$B.rectangle,
      children: /* @__PURE__ */ jsx(Memo$17, {
        className: classes$B.icon
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$B.deco,
      children: /* @__PURE__ */ jsx(Memo$18, {
        className: classes$B.icon2
      })
    })]
  });
});
const root$E = "_root_3rnos_1";
const title___BOLD4$1 = "_title___BOLD4_3rnos_8";
const dotLine = "_dotLine_3rnos_19";
const icon$u = "_icon_3rnos_26";
const value___HGAP2_ = "_value___HGAP2__3rnos_30";
const ptValue$1 = "_ptValue_3rnos_37";
const ptMax$1 = "_ptMax_3rnos_50";
const classes$A = {
  root: root$E,
  title___BOLD4: title___BOLD4$1,
  dotLine,
  icon: icon$u,
  value___HGAP2_,
  ptValue: ptValue$1,
  ptMax: ptMax$1
};
const DotlineIcon$1 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 186 1.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0H186",
    stroke: "#C8AB46",
    strokeWidth: 1.5,
    strokeDasharray: "2 2 2 2"
  })
}));
const Memo$16 = memo(DotlineIcon$1);
const AgentCardItem___HGAP14_ = memo(function AgentCardItem___HGAP14_2(props = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$A.root}`,
    children: [((_b = props.text) == null ? void 0 : _b.title___BOLD4) != null ? (_c = props.text) == null ? void 0 : _c.title___BOLD4 : /* @__PURE__ */ jsx("div", {
      className: classes$A.title___BOLD4,
      children: "\uACBD\uD5D8\uCE58"
    }), /* @__PURE__ */ jsx("div", {
      className: classes$A.dotLine,
      children: ((_d = props.swap) == null ? void 0 : _d.dotLine) || /* @__PURE__ */ jsx(Memo$16, {
        className: classes$A.icon
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$A.value___HGAP2_,
      children: [((_e = props.text) == null ? void 0 : _e.ptValue) != null ? (_f = props.text) == null ? void 0 : _f.ptValue : /* @__PURE__ */ jsx("div", {
        className: classes$A.ptValue,
        children: "40"
      }), ((_g = props.text) == null ? void 0 : _g.ptMax) != null ? (_h = props.text) == null ? void 0 : _h.ptMax : /* @__PURE__ */ jsx("div", {
        className: classes$A.ptMax,
        children: "/100"
      })]
    })]
  });
});
const root$D = "_root_1gaar_1";
const classes$z = {
  root: root$D
};
const Button_Dropdown_Property1Defau = memo(function Button_Dropdown_Property1Defau2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("button", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$z.root}`
  });
});
const root$C = "_root_15hxm_1";
const vector$5 = "_vector_15hxm_7";
const icon$t = "_icon_15hxm_15";
const classes$y = {
  root: root$C,
  vector: vector$5,
  icon: icon$t
};
const VectorIcon$5 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M14 0L7 -6.11959e-07L7 11L14 2.12281L14 0Z",
    fill: "#654B23"
  }), /* @__PURE__ */ jsx("path", {
    d: "M9.61651e-07 -1.22392e-06L7 -6.11959e-07L7 11L7.76069e-07 2.12281L9.61651e-07 -1.22392e-06Z",
    fill: "#654B23"
  })]
}));
const Memo$15 = memo(VectorIcon$5);
const FoldIcon_Property1Unfold = memo(function FoldIcon_Property1Unfold2(props = {}) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$y.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$y.vector,
      children: /* @__PURE__ */ jsx(Memo$15, {
        className: classes$y.icon
      })
    })
  });
});
const root$B = "_root_mep7d_1";
const union$6 = "_union_mep7d_7";
const icon$s = "_icon_mep7d_16";
const classes$x = {
  root: root$B,
  union: union$6,
  icon: icon$s
};
const UnionIcon$4 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45912 7.57895L0 14.3158C2.05508 15.4079 3.58178 15.7192 6.79874 16L8.00711 10.3511L12.6919 9.8001L12.8314 9.71311C13.6574 9.19789 14.913 7.73761 14.9074 5.59635H23L23 0L5.5 0.5L5.20755 3.78947C4.33962 3.78947 2.89308 3.1345 2.31447 2.66667L1.44654 3.50877C2.20271 4.85385 3.06869 5.45318 3.66181 5.86367C3.74946 5.92433 3.83116 5.98087 3.90566 6.03509L2.45912 7.57895ZM12.1707 8.44763L8.31734 8.9008L8.38994 8.5614C8.61319 7.80327 9.02487 7.21054 9.45621 6.77378C9.88454 7.26414 10.4255 7.8548 10.8364 8.24235L11.8479 7.56775C11.4597 7.20163 11.0519 6.55532 10.749 5.89157L13.4597 5.69913C13.4276 7.12102 12.6499 8.07994 12.1707 8.44763Z",
    fill: "#3E1F0D"
  })
}));
const Memo$14 = memo(UnionIcon$4);
const Icon_Equipment_Property1Firear2 = memo(function Icon_Equipment_Property1Firear22(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$x.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$x.union,
      children: /* @__PURE__ */ jsx(Memo$14, {
        className: classes$x.icon
      })
    })
  });
});
const BgIcon$4 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.00002L21.5 7.74979V19.2502L11.5 25L1.5 19.2502V7.74979L11.5 2.00002Z",
    fill: "#341D10"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 0.26973L23 6.88197V20.118L11.5 26.7303L0 20.118V6.88197L11.5 0.26973ZM21.5 7.74978L11.5 2L1.5 7.74978V19.2502L11.5 25L21.5 19.2502V7.74978Z",
    fill: "#E57710"
  })]
}));
const Memo$13 = memo(BgIcon$4);
const button_Dropdown = "_button_Dropdown_1966w_1";
const icon_Equipment$1 = "_icon_Equipment_1966w_14";
const root$A = "_root_1966w_18";
const foldArrow = "_foldArrow_1966w_31";
const equipmentInfo___HGAP5_ = "_equipmentInfo___HGAP5__1966w_43";
const line$3 = "_line_1966w_57";
const firearm___HGAP4_ = "_firearm___HGAP4__1966w_67";
const firearm_Grade$1 = "_firearm_Grade_1966w_78";
const bg$7 = "_bg_1966w_89";
const icon$r = "_icon_1966w_14";
const ptDropFirearmRate = "_ptDropFirearmRate_1966w_103";
const firearm_Type$1 = "_firearm_Type_1966w_122";
const ptDropFirearmType = "_ptDropFirearmType_1966w_130";
const frame191 = "_frame191_1966w_141";
const ptDropFirearmName$1 = "_ptDropFirearmName_1966w_152";
const durability___HGAP2_$1 = "_durability___HGAP2__1966w_162";
const ptDropFirearmStatCurr = "_ptDropFirearmStatCurr_1966w_170";
const ptDropFirearmStatMax = "_ptDropFirearmStatMax_1966w_182";
const classes$w = {
  button_Dropdown,
  icon_Equipment: icon_Equipment$1,
  root: root$A,
  foldArrow,
  equipmentInfo___HGAP5_,
  line: line$3,
  firearm___HGAP4_,
  firearm_Grade: firearm_Grade$1,
  bg: bg$7,
  icon: icon$r,
  ptDropFirearmRate,
  firearm_Type: firearm_Type$1,
  ptDropFirearmType,
  frame191,
  ptDropFirearmName: ptDropFirearmName$1,
  durability___HGAP2_: durability___HGAP2_$1,
  ptDropFirearmStatCurr,
  ptDropFirearmStatMax
};
const Button_Equipments_varFoldnessF = memo(function Button_Equipments_varFoldnessF2(props = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$w.root}`,
    onClick: props.onClick,
    children: [/* @__PURE__ */ jsx(Button_Dropdown_Property1Defau, {
      className: classes$w.button_Dropdown
    }), /* @__PURE__ */ jsx("div", {
      className: classes$w.foldArrow,
      children: /* @__PURE__ */ jsx(FoldIcon_Property1Unfold, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$w.equipmentInfo___HGAP5_,
      children: [((_b = props.swap) == null ? void 0 : _b.icon_Equipment) || /* @__PURE__ */ jsx(Icon_Equipment_Property1Firear2, {
        className: classes$w.icon_Equipment
      }), !((_c = props.hide) == null ? void 0 : _c.line) && /* @__PURE__ */ jsx("div", {
        className: classes$w.line
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$w.firearm___HGAP4_,
        children: [!((_d = props.hide) == null ? void 0 : _d.firearm_Grade) && /* @__PURE__ */ jsxs("div", {
          className: classes$w.firearm_Grade,
          children: [/* @__PURE__ */ jsx("div", {
            className: classes$w.bg,
            children: /* @__PURE__ */ jsx(Memo$13, {
              className: classes$w.icon
            })
          }), ((_e = props.text) == null ? void 0 : _e.ptDropFirearmRate) != null ? (_f = props.text) == null ? void 0 : _f.ptDropFirearmRate : /* @__PURE__ */ jsx("div", {
            className: classes$w.ptDropFirearmRate,
            children: "2"
          })]
        }), !((_g = props.hide) == null ? void 0 : _g.firearm_Type) && /* @__PURE__ */ jsx("div", {
          className: classes$w.firearm_Type,
          children: ((_h = props.text) == null ? void 0 : _h.ptDropFirearmType) != null ? (_i = props.text) == null ? void 0 : _i.ptDropFirearmType : /* @__PURE__ */ jsx("div", {
            className: classes$w.ptDropFirearmType,
            children: "SMG"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: classes$w.frame191,
          children: ((_j = props.text) == null ? void 0 : _j.ptDropFirearmName) != null ? (_k = props.text) == null ? void 0 : _k.ptDropFirearmName : /* @__PURE__ */ jsx("div", {
            className: classes$w.ptDropFirearmName,
            children: "PARKER-HALE M82"
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$w.durability___HGAP2_,
          children: [((_l = props.text) == null ? void 0 : _l.ptDropFirearmStatCurr) != null ? (_m = props.text) == null ? void 0 : _m.ptDropFirearmStatCurr : /* @__PURE__ */ jsx("div", {
            className: classes$w.ptDropFirearmStatCurr
          }), ((_n = props.text) == null ? void 0 : _n.ptDropFirearmStatMax) != null ? (_o = props.text) == null ? void 0 : _o.ptDropFirearmStatMax : /* @__PURE__ */ jsx("div", {
            className: classes$w.ptDropFirearmStatMax
          })]
        })]
      })]
    })]
  });
});
const BulletIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 15 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("circle", {
    cx: 8,
    cy: 10,
    r: 2,
    fill: "#3E1F0D"
  })
}));
const Memo$12 = memo(BulletIcon);
const root$z = "_root_1fadw_1";
const bulletAnchor = "_bulletAnchor_1fadw_6";
const bullet = "_bullet_1fadw_6";
const icon$q = "_icon_1fadw_19";
const item = "_item_1fadw_23";
const ptBulletItemContent$1 = "_ptBulletItemContent_1fadw_29";
const classes$v = {
  root: root$z,
  bulletAnchor,
  bullet,
  icon: icon$q,
  item,
  ptBulletItemContent: ptBulletItemContent$1
};
const BulletItem___HGAP1_ = memo(function BulletItem___HGAP1_2(props = {}) {
  var _a, _b, _c;
  const {
    ty,
    k,
    tooltipHandlers
  } = props;
  const {
    onTooltipShow = () => {
    },
    onTooltipHide = () => {
    },
    onTooltipMove = () => {
    },
    lookup = () => {
    }
  } = tooltipHandlers != null ? tooltipHandlers : {};
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$v.root}`,
    onMouseOver: () => onTooltipShow(lookup(ty, {
      key: k
    })),
    onMouseOut: onTooltipHide,
    onMouseMove: onTooltipMove,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$v.bulletAnchor,
      children: /* @__PURE__ */ jsx("div", {
        className: classes$v.bullet,
        children: /* @__PURE__ */ jsx(Memo$12, {
          className: classes$v.icon
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$v.item,
      children: ((_b = props.text) == null ? void 0 : _b.ptBulletItemContent) != null ? (_c = props.text) == null ? void 0 : _c.ptBulletItemContent : /* @__PURE__ */ jsx("div", {
        className: classes$v.ptBulletItemContent,
        children: "Adaptability"
      })
    })]
  });
});
const ptBulletItemContent = "_ptBulletItemContent_pgk82_1";
const ptBulletItemContent2 = "_ptBulletItemContent2_pgk82_10";
const ptBulletItemContent3 = "_ptBulletItemContent3_pgk82_19";
const ptBulletItemContent4 = "_ptBulletItemContent4_pgk82_28";
const root$y = "_root_pgk82_37";
const traitsList___VGAP8_ = "_traitsList___VGAP8__pgk82_47";
const classes$u = {
  ptBulletItemContent,
  ptBulletItemContent2,
  ptBulletItemContent3,
  ptBulletItemContent4,
  root: root$y,
  traitsList___VGAP8_
};
const ContentArea_varDefault = memo(function ContentArea_varDefault2(props) {
  var _a;
  const {
    ty,
    items
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$u.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$u.traitsList___VGAP8_,
      children: items.map((i) => /* @__PURE__ */ jsx(BulletItem___HGAP1_, {
        ty,
        k: i.key,
        tooltipHandlers: props.tooltipHandlers,
        text: {
          ptBulletItemContent: /* @__PURE__ */ jsx("div", {
            className: classes$u.ptBulletItemContent,
            children: i.name
          })
        }
      }, i.key))
    })
  });
});
const root$x = "_root_155ax_1";
const noData = "_noData_155ax_9";
const vector$4 = "_vector_155ax_17";
const icon$p = "_icon_155ax_25";
const noData___BOLD6 = "_noData___BOLD6_155ax_29";
const classes$t = {
  root: root$x,
  noData,
  vector: vector$4,
  icon: icon$p,
  noData___BOLD6
};
const VectorIcon$4 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 350 89",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 89L350 0",
    stroke: "#C56B39"
  })
}));
const Memo$11 = memo(VectorIcon$4);
const ContentArea_varNoData = memo(function ContentArea_varNoData2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$t.root}`,
    children: /* @__PURE__ */ jsxs("div", {
      className: classes$t.noData,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$t.vector,
        children: /* @__PURE__ */ jsx(Memo$11, {
          className: classes$t.icon
        })
      }), /* @__PURE__ */ jsx("div", {
        className: classes$t.noData___BOLD6,
        children: "\uB0B4\uC6A9 \uC5C6\uC74C"
      })]
    })
  });
});
const root$w = "_root_1ocgp_1";
const subtract$1 = "_subtract_1ocgp_7";
const icon$o = "_icon_1ocgp_16";
const classes$s = {
  root: root$w,
  subtract: subtract$1,
  icon: icon$o
};
const SubtractIcon$1 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 15 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M12.4359 5.77418L12.9487 0L10.5128 0.64516L10.3846 5.64515C9.75973 7.02873 8.32269 7.30882 7.49855 7.32206C6.67393 7.30821 5.23953 7.02716 4.61539 5.6452L4.48719 0.645207L2.05129 4.75645e-05L2.56411 5.77423C2.22223 6.76347 1.28205 8.74196 0 9.25809V11.8388H0.769222V13.3872H0V15.7096H0.769269V17.258H0V19.3226L1.53846 21L13.4615 21L15 19.3225V17.258H14.1027V15.7096H15V13.3871H14.1027V11.8388H15V9.25804C13.7179 8.74192 12.7778 6.76343 12.4359 5.77418Z",
    fill: "#3E1F0D"
  })
}));
const Memo$10 = memo(SubtractIcon$1);
const Icon_Equipment_Property1Bullet = memo(function Icon_Equipment_Property1Bullet2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$s.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$s.subtract,
      children: /* @__PURE__ */ jsx(Memo$10, {
        className: classes$s.icon
      })
    })
  });
});
const root$v = "_root_1d48b_1";
const vector$3 = "_vector_1d48b_7";
const icon$n = "_icon_1d48b_16";
const classes$r = {
  root: root$v,
  vector: vector$3,
  icon: icon$n
};
const VectorIcon$3 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 17 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.94939 11.8007C1.12585 8.72628 2.80931 6.47758 5.09114 5.66788V4.293H5.08707L2.99996 3.01834V0H11.679C13.5288 2.02023 15.5287 7.06881 16.2974 10.2976C15.9587 10.4218 15.7214 10.5742 15.1312 10.6944C14.4699 8.52388 12.4356 4.07054 11.2693 3.01834L9.21664 4.293H9.2106V5.7701C11.3565 6.65595 12.9143 8.84854 13.0846 11.8007H13.8939V14.5304H13.0846C12.8656 18.4206 10.2308 21 7.01801 21C3.80317 21 1.16845 18.4206 0.94939 14.5304H0.140056V11.8007H0.94939Z",
    fill: "#3E1F0D"
  })
}));
const Memo$$ = memo(VectorIcon$3);
const Icon_Equipment_Property1Grenad = memo(function Icon_Equipment_Property1Grenad2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$r.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$r.vector,
      children: /* @__PURE__ */ jsx(Memo$$, {
        className: classes$r.icon
      })
    })
  });
});
const root$u = "_root_1gxgd_1";
const union$5 = "_union_1gxgd_7";
const icon$m = "_icon_1gxgd_15";
const classes$q = {
  root: root$u,
  union: union$5,
  icon: icon$m
};
const UnionIcon$3 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7H0V18H13V7H11V4.5C11 2.01472 8.98528 0 6.5 0C4.01472 0 2 2.01472 2 4.5V7ZM4.5 7H8.5V4.5C8.5 3.39543 7.60457 2.5 6.5 2.5C5.39543 2.5 4.5 3.39543 4.5 4.5V7Z",
    fill: "#BF9018"
  })
}));
const Memo$_ = memo(UnionIcon$3);
const Icon_Equipment_Property1Locked = memo(function Icon_Equipment_Property1Locked2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$q.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$q.union,
      children: /* @__PURE__ */ jsx(Memo$_, {
        className: classes$q.icon
      })
    })
  });
});
const root$t = "_root_1qhde_1";
const subtract = "_subtract_1qhde_7";
const icon$l = "_icon_1qhde_15";
const classes$p = {
  root: root$t,
  subtract,
  icon: icon$l
};
const SubtractIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11111 0C0.945177 0 0 0.945177 0 2.11111V16.8889C0 18.0548 0.945177 19 2.11111 19H16.8889C18.0548 19 19 18.0548 19 16.8889V2.11111C19 0.945177 18.0548 0 16.8889 0H2.11111ZM7.38889 3.16667H11.6111V7.38889H15.8333V11.6111H11.6111V15.8333H7.38889V11.6111H3.16667V7.38889H7.38889V3.16667Z",
    fill: "#906A05"
  })
}));
const Memo$Z = memo(SubtractIcon);
const Icon_Result_Property1Damage = memo(function Icon_Result_Property1Damage2(props = {}) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$p.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$p.subtract,
      children: /* @__PURE__ */ jsx(Memo$Z, {
        className: classes$p.icon
      })
    })
  });
});
const root$s = "_root_13vy7_1";
const union$4 = "_union_13vy7_7";
const icon$k = "_icon_13vy7_15";
const classes$o = {
  root: root$s,
  union: union$4,
  icon: icon$k
};
const UnionIcon$2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 10.5C15.75 13.3995 13.3995 15.75 10.5 15.75C7.60051 15.75 5.25 13.3995 5.25 10.5C5.25 7.60051 7.60051 5.25 10.5 5.25C13.3995 5.25 15.75 7.60051 15.75 10.5ZM12.25 10.5C12.25 11.4665 11.4665 12.25 10.5 12.25C9.5335 12.25 8.75 11.4665 8.75 10.5C8.75 9.5335 9.5335 8.75 10.5 8.75C11.4665 8.75 12.25 9.5335 12.25 10.5Z",
    fill: "#906A05"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM17.5 10.5C17.5 14.366 14.366 17.5 10.5 17.5C6.63401 17.5 3.5 14.366 3.5 10.5C3.5 6.63401 6.63401 3.5 10.5 3.5C14.366 3.5 17.5 6.63401 17.5 10.5Z",
    fill: "#906A05"
  })]
}));
const Memo$Y = memo(UnionIcon$2);
const Icon_Result_Property1Mission = memo(function Icon_Result_Property1Mission2(props = {}) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$o.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$o.union,
      children: /* @__PURE__ */ jsx(Memo$Y, {
        className: classes$o.icon
      })
    })
  });
});
const BgIcon$3 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M145 24H0V0H145V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M145 24V0H153V16.3636L145 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H148",
    stroke: "#D1A563"
  })]
}));
const Memo$X = memo(BgIcon$3);
const root$r = "_root_1f254_1";
const bg$6 = "_bg_1f254_10";
const icon$j = "_icon_1f254_18";
const textArea = "_textArea_1f254_22";
const title___HGAP6_ = "_title___HGAP6__1f254_30";
const deco$2 = "_deco_1f254_36";
const title___BOLD4_$2 = "_title___BOLD4__1f254_43";
const classes$n = {
  root: root$r,
  bg: bg$6,
  icon: icon$j,
  textArea,
  title___HGAP6_,
  deco: deco$2,
  title___BOLD4_: title___BOLD4_$2
};
const ItemTitle = memo(function ItemTitle2(props = {}) {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$n.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$n.bg,
      children: ((_b = props.swap) == null ? void 0 : _b.bg) || /* @__PURE__ */ jsx(Memo$X, {
        className: classes$n.icon
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$n.textArea,
      children: /* @__PURE__ */ jsxs("div", {
        className: classes$n.title___HGAP6_,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$n.deco
        }), ((_c = props.text) == null ? void 0 : _c.title___BOLD4_) != null ? (_d = props.text) == null ? void 0 : _d.title___BOLD4_ : /* @__PURE__ */ jsx("div", {
          className: classes$n.title___BOLD4_,
          children: "\uAD6D\uC801"
        })]
      })
    })]
  });
});
const itemTitle$1 = "_itemTitle_r74w3_1";
const title___BOLD4_$1 = "_title___BOLD4__r74w3_7";
const root$q = "_root_r74w3_17";
const textLine___VGAP9_$1 = "_textLine___VGAP9__r74w3_25";
const icon$i = "_icon_r74w3_32";
const ptItemText$1 = "_ptItemText_r74w3_36";
const classes$m = {
  itemTitle: itemTitle$1,
  title___BOLD4_: title___BOLD4_$1,
  root: root$q,
  textLine___VGAP9_: textLine___VGAP9_$1,
  icon: icon$i,
  ptItemText: ptItemText$1
};
const Textline___vgap9_Icon$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_274_13670)",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 1H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 10H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 19H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 28H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 37H153",
      stroke: "#E4CB71"
    })]
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_13670",
      children: /* @__PURE__ */ jsx("rect", {
        width: 153,
        height: 38,
        fill: "white"
      })
    })
  })]
}));
const Memo$W = memo(Textline___vgap9_Icon$1);
const ItemBox = memo(function ItemBox2(props = {}) {
  var _a, _b, _c, _d, _e;
  const {
    ty,
    k,
    tooltipHandlers
  } = props;
  const {
    onTooltipShow = () => {
    },
    onTooltipHide = () => {
    },
    onTooltipMove = () => {
    },
    lookup = () => {
    }
  } = tooltipHandlers != null ? tooltipHandlers : {};
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$m.root}`,
    onMouseOver: () => onTooltipShow(lookup(ty, {
      key: k
    })),
    onMouseOut: onTooltipHide,
    onMouseMove: onTooltipMove,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$m.textLine___VGAP9_,
      children: ((_b = props.swap) == null ? void 0 : _b.textLine___VGAP9_) || /* @__PURE__ */ jsx(Memo$W, {
        className: classes$m.icon
      })
    }), ((_c = props.text) == null ? void 0 : _c.ptItemText) != null ? (_d = props.text) == null ? void 0 : _d.ptItemText : /* @__PURE__ */ jsx("div", {
      className: classes$m.ptItemText,
      children: "United States"
    }), /* @__PURE__ */ jsx(ItemTitle, {
      className: classes$m.itemTitle,
      text: {
        title___BOLD4_: ((_e = props.text) == null ? void 0 : _e.title___BOLD4_) || /* @__PURE__ */ jsx("div", {
          className: classes$m.title___BOLD4_,
          children: "\uAD6D\uC801"
        })
      }
    })]
  });
});
const root$p = "_root_ir4h5_1";
const statGrade___VGAP11_ = "_statGrade___VGAP11__ir4h5_7";
const ptGradeName$1 = "_ptGradeName_ir4h5_14";
const statGrade = "_statGrade_ir4h5_7";
const frame197 = "_frame197_ir4h5_34";
const ptGradeValue$1 = "_ptGradeValue_ir4h5_39";
const frame198 = "_frame198_ir4h5_52";
const classes$l = {
  root: root$p,
  statGrade___VGAP11_,
  ptGradeName: ptGradeName$1,
  statGrade,
  frame197,
  ptGradeValue: ptGradeValue$1,
  frame198
};
const StatGrade = memo(function StatGrade2(props = {}) {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$l.root}`,
    children: /* @__PURE__ */ jsxs("div", {
      className: classes$l.statGrade___VGAP11_,
      children: [((_a = props.text) == null ? void 0 : _a.ptGradeName) != null ? (_b = props.text) == null ? void 0 : _b.ptGradeName : /* @__PURE__ */ jsx("div", {
        className: classes$l.ptGradeName,
        children: "\uC131\uC7A5 \uD55C\uACC4"
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$l.statGrade,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$l.frame197,
          children: ((_c = props.text) == null ? void 0 : _c.ptGradeValue) != null ? (_d = props.text) == null ? void 0 : _d.ptGradeValue : /* @__PURE__ */ jsx("div", {
            className: classes$l.ptGradeValue,
            children: "A"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: classes$l.frame198
        })]
      })]
    })
  });
});
const itemTitle = "_itemTitle_5h2uw_1";
const icon$h = "_icon_5h2uw_8";
const title___BOLD4_ = "_title___BOLD4__5h2uw_13";
const itemTitle2 = "_itemTitle2_5h2uw_24";
const icon2$8 = "_icon2_5h2uw_30";
const title___BOLD4_2 = "_title___BOLD4_2_5h2uw_35";
const cContentAreaModifier = "_cContentAreaModifier_5h2uw_46";
const itemTitle3 = "_itemTitle3_5h2uw_51";
const icon3$5 = "_icon3_5h2uw_57";
const title___BOLD4_3 = "_title___BOLD4_3_5h2uw_62";
const cContentAreaTraits = "_cContentAreaTraits_5h2uw_73";
const itemTitle4 = "_itemTitle4_5h2uw_78";
const icon4$4 = "_icon4_5h2uw_84";
const title___BOLD4_4 = "_title___BOLD4_4_5h2uw_89";
const cDropThrowableSlotB = "_cDropThrowableSlotB_5h2uw_100";
const icon_Equipment = "_icon_Equipment_5h2uw_105";
const ptDropFirearmName = "_ptDropFirearmName_5h2uw_109";
const cDropThrowableSlotA = "_cDropThrowableSlotA_5h2uw_120";
const icon_Equipment2 = "_icon_Equipment2_5h2uw_125";
const ptDropFirearmName2 = "_ptDropFirearmName2_5h2uw_129";
const cDropVest = "_cDropVest_5h2uw_139";
const icon_Equipment3 = "_icon_Equipment3_5h2uw_144";
const ptDropFirearmName3 = "_ptDropFirearmName3_5h2uw_148";
const cDropFirearm = "_cDropFirearm_5h2uw_158";
const itemTitle5 = "_itemTitle5_5h2uw_163";
const icon5$3 = "_icon5_5h2uw_169";
const title___BOLD4_5 = "_title___BOLD4_5_5h2uw_174";
const profileItem_Age = "_profileItem_Age_5h2uw_185";
const icon6$3 = "_icon6_5h2uw_192";
const ptItemText = "_ptItemText_5h2uw_197";
const title___BOLD4_6 = "_title___BOLD4_6_5h2uw_211";
const profileItem_Background = "_profileItem_Background_5h2uw_222";
const icon7$3 = "_icon7_5h2uw_229";
const ptItemText2 = "_ptItemText2_5h2uw_234";
const title___BOLD4_7 = "_title___BOLD4_7_5h2uw_248";
const profileItem_Language = "_profileItem_Language_5h2uw_259";
const icon8$3 = "_icon8_5h2uw_266";
const ptItemText3 = "_ptItemText3_5h2uw_271";
const title___BOLD4_8 = "_title___BOLD4_8_5h2uw_285";
const profileItem_Nation = "_profileItem_Nation_5h2uw_296";
const icon9$2 = "_icon9_5h2uw_303";
const agentState = "_agentState_5h2uw_308";
const ptGradeName = "_ptGradeName_5h2uw_316";
const ptGradeValue = "_ptGradeValue_5h2uw_333";
const ptGradeName2 = "_ptGradeName2_5h2uw_350";
const ptGradeValue2 = "_ptGradeValue2_5h2uw_367";
const cLife___HGAP14_ = "_cLife___HGAP14__5h2uw_384";
const title___BOLD4 = "_title___BOLD4_5h2uw_13";
const icon10$2 = "_icon10_5h2uw_401";
const ptValue = "_ptValue_5h2uw_406";
const cOverall___HGAP14_ = "_cOverall___HGAP14__5h2uw_420";
const title___BOLD42 = "_title___BOLD42_5h2uw_425";
const icon11$2 = "_icon11_5h2uw_437";
const ptValue2 = "_ptValue2_5h2uw_442";
const ptMax = "_ptMax_5h2uw_456";
const cPhysical___HGAP14_ = "_cPhysical___HGAP14__5h2uw_470";
const title___BOLD43 = "_title___BOLD43_5h2uw_475";
const icon12$2 = "_icon12_5h2uw_487";
const ptValue3 = "_ptValue3_5h2uw_492";
const ptMax2 = "_ptMax2_5h2uw_506";
const cExp___HGAP14_ = "_cExp___HGAP14__5h2uw_520";
const root$o = "_root_5h2uw_528";
const contributionInfo = "_contributionInfo_5h2uw_540";
const ptContribution = "_ptContribution_5h2uw_552";
const resultsInfo = "_resultsInfo_5h2uw_567";
const result_Damage = "_result_Damage_5h2uw_579";
const resultBar = "_resultBar_5h2uw_591";
const bar = "_bar_5h2uw_603";
const positiveBar = "_positiveBar_5h2uw_615";
const rectangle2$1 = "_rectangle2_5h2uw_621";
const negativeBar = "_negativeBar_5h2uw_627";
const rectangle3$1 = "_rectangle3_5h2uw_633";
const negativeValue___HGAP9 = "_negativeValue___HGAP9_5h2uw_639";
const text_Type___BOLD3 = "_text_Type___BOLD3_5h2uw_652";
const ptResultDamageTaken = "_ptResultDamageTaken_5h2uw_663";
const positiveValue___HGAP9_ = "_positiveValue___HGAP9__5h2uw_675";
const text_Type___BOLD32 = "_text_Type___BOLD32_5h2uw_688";
const ptResultDamageDone = "_ptResultDamageDone_5h2uw_699";
const itemTitle___HGAP2_ = "_itemTitle___HGAP2__5h2uw_711";
const text_ResultType___BOLD4 = "_text_ResultType___BOLD4_5h2uw_724";
const result_Mission = "_result_Mission_5h2uw_735";
const resultBar2 = "_resultBar2_5h2uw_747";
const bar2 = "_bar2_5h2uw_759";
const positiveBar2 = "_positiveBar2_5h2uw_771";
const rectangle4 = "_rectangle4_5h2uw_777";
const negativeBar2 = "_negativeBar2_5h2uw_783";
const rectangle5 = "_rectangle5_5h2uw_791";
const negativeValue___HGAP9_ = "_negativeValue___HGAP9__5h2uw_799";
const text_Type___BOLD33 = "_text_Type___BOLD33_5h2uw_812";
const ptResultMissionLose = "_ptResultMissionLose_5h2uw_823";
const positiveValue___HGAP9_2 = "_positiveValue___HGAP9_2_5h2uw_835";
const text_Type___BOLD34 = "_text_Type___BOLD34_5h2uw_848";
const ptResultMissionWin = "_ptResultMissionWin_5h2uw_859";
const itemTitle___HGAP2_2 = "_itemTitle___HGAP2_2_5h2uw_871";
const text_ResultType___BOLD42 = "_text_ResultType___BOLD42_5h2uw_884";
const modifierInfo = "_modifierInfo_5h2uw_895";
const textLine___VGAP9_ = "_textLine___VGAP9__5h2uw_907";
const icon13$2 = "_icon13_5h2uw_915";
const traitsInfo = "_traitsInfo_5h2uw_920";
const textLine___VGAP9_2 = "_textLine___VGAP9_2_5h2uw_932";
const icon14$2 = "_icon14_5h2uw_940";
const equipmentInfo = "_equipmentInfo_5h2uw_945";
const firearmInfo = "_firearmInfo_5h2uw_957";
const firearmView = "_firearmView_5h2uw_969";
const bg$5 = "_bg_5h2uw_982";
const icon15$2 = "_icon15_5h2uw_991";
const image_Firearm$1 = "_image_Firearm_5h2uw_996";
const icon16$1 = "_icon16_5h2uw_1005";
const baseInfo___HGAP12_ = "_baseInfo___HGAP12__5h2uw_1010";
const profile = "_profile_5h2uw_185";
const agentStatus = "_agentStatus_5h2uw_1034";
const remainingTime = "_remainingTime_5h2uw_1046";
const bg2$2 = "_bg2_5h2uw_1058";
const progressBar$1 = "_progressBar_5h2uw_1068";
const bg3$2 = "_bg3_5h2uw_1080";
const progress$1 = "_progress_5h2uw_1068";
const _2DaysLeft = "__2DaysLeft_5h2uw_1098";
const status$1 = "_status_5h2uw_1117";
const bg4$1 = "_bg4_5h2uw_1129";
const title___BOLD3 = "_title___BOLD3_5h2uw_1139";
const agentPortrait = "_agentPortrait_5h2uw_1159";
const bg5 = "_bg5_5h2uw_1171";
const portrait$1 = "_portrait_5h2uw_1180";
const frame$1 = "_frame_5h2uw_1192";
const image_Portrait = "_image_Portrait_5h2uw_1205";
const rectangle$3 = "_rectangle_5h2uw_621";
const line$2 = "_line_5h2uw_1236";
const icon17 = "_icon17_5h2uw_1244";
const levelGrade = "_levelGrade_5h2uw_1249";
const grade___HGAP13_ = "_grade___HGAP13__5h2uw_1259";
const vector129 = "_vector129_5h2uw_1275";
const icon18 = "_icon18_5h2uw_1283";
const vector128 = "_vector128_5h2uw_1288";
const icon19 = "_icon19_5h2uw_1296";
const stat = "_stat_5h2uw_1117";
const body___VGAP11_ = "_body___VGAP11__5h2uw_1313";
const head___VGAP5_ = "_head___VGAP5__5h2uw_1325";
const grade___BOLD4 = "_grade___BOLD4_5h2uw_1342";
const grade$1 = "_grade_5h2uw_1259";
const ptGrade = "_ptGrade_5h2uw_316";
const head___VGAP4_ = "_head___VGAP4__5h2uw_1380";
const level___BOLD4 = "_level___BOLD4_5h2uw_1397";
const grade2 = "_grade2_5h2uw_1409";
const ptGrade2 = "_ptGrade2_5h2uw_1419";
const level$1 = "_level_5h2uw_1249";
const body = "_body_5h2uw_1313";
const progressBar2 = "_progressBar2_5h2uw_1462";
const frame2 = "_frame2_5h2uw_1474";
const bg6 = "_bg6_5h2uw_1483";
const progress2 = "_progress2_5h2uw_1492";
const shadow$1 = "_shadow_5h2uw_1501";
const head___VGAP3_ = "_head___VGAP3__5h2uw_1511";
const level___BOLD42 = "_level___BOLD42_5h2uw_1528";
const grade3 = "_grade3_5h2uw_1540";
const ptLevelValue = "_ptLevelValue_5h2uw_1550";
const classes_detailoverview = {
  itemTitle,
  icon: icon$h,
  title___BOLD4_,
  itemTitle2,
  icon2: icon2$8,
  title___BOLD4_2,
  cContentAreaModifier,
  itemTitle3,
  icon3: icon3$5,
  title___BOLD4_3,
  cContentAreaTraits,
  itemTitle4,
  icon4: icon4$4,
  title___BOLD4_4,
  cDropThrowableSlotB,
  icon_Equipment,
  ptDropFirearmName,
  cDropThrowableSlotA,
  icon_Equipment2,
  ptDropFirearmName2,
  cDropVest,
  icon_Equipment3,
  ptDropFirearmName3,
  cDropFirearm,
  itemTitle5,
  icon5: icon5$3,
  title___BOLD4_5,
  profileItem_Age,
  icon6: icon6$3,
  ptItemText,
  title___BOLD4_6,
  profileItem_Background,
  icon7: icon7$3,
  ptItemText2,
  title___BOLD4_7,
  profileItem_Language,
  icon8: icon8$3,
  ptItemText3,
  title___BOLD4_8,
  profileItem_Nation,
  icon9: icon9$2,
  agentState,
  ptGradeName,
  ptGradeValue,
  ptGradeName2,
  ptGradeValue2,
  cLife___HGAP14_,
  title___BOLD4,
  icon10: icon10$2,
  ptValue,
  cOverall___HGAP14_,
  title___BOLD42,
  icon11: icon11$2,
  ptValue2,
  ptMax,
  cPhysical___HGAP14_,
  title___BOLD43,
  icon12: icon12$2,
  ptValue3,
  ptMax2,
  cExp___HGAP14_,
  root: root$o,
  contributionInfo,
  ptContribution,
  resultsInfo,
  result_Damage,
  resultBar,
  bar,
  positiveBar,
  rectangle2: rectangle2$1,
  negativeBar,
  rectangle3: rectangle3$1,
  negativeValue___HGAP9,
  text_Type___BOLD3,
  ptResultDamageTaken,
  positiveValue___HGAP9_,
  text_Type___BOLD32,
  ptResultDamageDone,
  itemTitle___HGAP2_,
  text_ResultType___BOLD4,
  result_Mission,
  resultBar2,
  bar2,
  positiveBar2,
  rectangle4,
  negativeBar2,
  rectangle5,
  negativeValue___HGAP9_,
  text_Type___BOLD33,
  ptResultMissionLose,
  positiveValue___HGAP9_2,
  text_Type___BOLD34,
  ptResultMissionWin,
  itemTitle___HGAP2_2,
  text_ResultType___BOLD42,
  modifierInfo,
  textLine___VGAP9_,
  icon13: icon13$2,
  traitsInfo,
  textLine___VGAP9_2,
  icon14: icon14$2,
  equipmentInfo,
  firearmInfo,
  firearmView,
  bg: bg$5,
  icon15: icon15$2,
  image_Firearm: image_Firearm$1,
  icon16: icon16$1,
  baseInfo___HGAP12_,
  profile,
  agentStatus,
  remainingTime,
  bg2: bg2$2,
  progressBar: progressBar$1,
  bg3: bg3$2,
  progress: progress$1,
  _2DaysLeft,
  status: status$1,
  bg4: bg4$1,
  title___BOLD3,
  agentPortrait,
  bg5,
  portrait: portrait$1,
  frame: frame$1,
  image_Portrait,
  rectangle: rectangle$3,
  line: line$2,
  icon17,
  levelGrade,
  grade___HGAP13_,
  vector129,
  icon18,
  vector128,
  icon19,
  stat,
  body___VGAP11_,
  head___VGAP5_,
  grade___BOLD4,
  grade: grade$1,
  ptGrade,
  head___VGAP4_,
  level___BOLD4,
  grade2,
  ptGrade2,
  level: level$1,
  body,
  progressBar2,
  frame2,
  bg6,
  progress2,
  shadow: shadow$1,
  head___VGAP3_,
  level___BOLD42,
  grade3,
  ptLevelValue
};
const BgIcon2$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 708 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M700 24H4.76837e-06V0H700V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M700 24V0H708V16.3636L700 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H703",
    stroke: "#D1A563"
  })]
}));
const Memo$V = memo(BgIcon2$1);
const BgIcon3 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 350 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M342 24H6.67572e-06V0H342V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M342 24V0H350V16.3636L342 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H345",
    stroke: "#D1A563"
  })]
}));
const Memo$U = memo(BgIcon3);
const BgIcon4 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 350 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M342 24H6.67572e-06V0H342V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M342 24V0H350V16.3636L342 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H345",
    stroke: "#D1A563"
  })]
}));
const Memo$T = memo(BgIcon4);
const BgIcon5 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 340 110",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    width: 340,
    height: 110,
    fill: "#F8DF89"
  }), /* @__PURE__ */ jsx("rect", {
    x: 11,
    y: 20,
    width: 318,
    height: 80,
    fill: "#F1D77B"
  }), /* @__PURE__ */ jsx("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.596 9V19.6769L318.512 19.6769V9L317.252 9V19.6769H307.169V9L305.909 9V19.6769H295.825V9L294.565 9V19.6769L284.482 19.6769V9L283.222 9V19.6769L273.139 19.6769V9L271.878 9V19.6769H261.795V9L260.535 9V19.6769L250.451 19.6769V9L249.191 9V19.6769L239.108 19.6769V9L237.848 9V19.6769H227.764V9L226.504 9V19.6769H216.421V9L215.161 9V19.6769L205.078 19.6769V9L203.817 9V19.6769L193.734 19.6768V9L192.474 9V19.6768H182.391V9L181.13 9V19.6768L171.047 19.6768V9L169.787 9V19.6768L159.704 19.6768V9L158.443 9V19.6768L148.36 19.6768V9L147.1 9V19.6768H137.017V9L135.756 9V19.6768L125.673 19.6768V9L124.413 9V19.6768L114.33 19.6768V9L113.069 9V19.6768H102.986V9L101.726 9V19.6768H91.6426V9L90.3822 9V19.6768L80.2991 19.6768V9L79.0387 9V19.6768L68.9556 19.6768V9L67.6953 9V19.6768H57.6121V9L56.3518 9V19.6768L46.2687 19.6768V9L45.0083 9V19.6768L34.9252 19.6768V9L33.6648 9L33.6648 19.6768L23.5817 19.6768V9L22.3213 9L22.3213 19.6768H12.2382L12.2382 9L10.9778 9L10.9778 19.6768L0.894695 19.6768L0.894703 9L-0.365685 9L-0.365692 19.6768L-10.4488 19.6768L-10.4488 9L-11.7092 9L-11.7092 19.6768H-21.7923L-21.7923 9L-23.0527 9L-23.0527 19.6768L-33.1357 19.6768L-33.1357 9L-34.3961 9L-34.3961 19.6768L-47 19.6768V20.9329L-34.3961 20.9329L-34.3961 30.9817H-47V32.2378H-34.3961L-34.3961 42.2866H-47V43.5427H-34.3961L-34.3961 53.5915H-47V54.8476H-34.3961L-34.3961 64.8963H-47V66.1524H-34.3961L-34.3961 76.2012H-47V77.4573H-34.3961L-34.3961 87.5061H-47V88.7622H-34.3961L-34.3961 98.811H-47V100.067H-34.3961L-34.3961 109.677H-47V110.933H-34.3961L-34.3961 120.982H-47V122.238H-34.3961L-34.3961 132.287H-47V133.543H-34.3961L-34.3961 143.591H-47V144.848H-34.3961L-34.3961 154.896H-47V156.152H-34.3961L-34.3961 166.201H-47V167.457H-34.3961L-34.3961 177.506H-47V178.762H-34.3961L-34.3961 188.811H-47V190.067H-34.3961L-34.3961 202H-33.1357L-33.1357 190.067H-23.0527L-23.0527 202H-21.7923L-21.7923 190.067H-11.7092L-11.7092 202H-10.4488L-10.4488 190.067H-0.365723L-0.36573 202H0.894657L0.894665 190.067H10.9778L10.9778 202H12.2381L12.2382 190.067H22.3213L22.3213 202H23.5816V190.067H33.6647L33.6647 202H34.9251V190.067H45.0082V202H46.2686V190.067H56.3517V202H57.6121V190.067H67.6952V202H68.9556V190.067H79.0387V202H80.2991V190.067H90.3822V202H91.6426V190.067H101.726V202H102.986V190.067H113.069V202H114.33V190.067L124.413 190.067V202H125.673V190.067H135.756V202H137.017V190.067H147.1V202H148.36V190.067H158.443V202H159.704V190.067H169.787V202H171.047V190.067H181.13V202H182.391V190.067H192.474V202H193.734V190.067H203.817V202H205.077V190.067H215.161V202H216.421V190.067H226.504V202H227.764V190.067L237.848 190.067V202H239.108V190.067H249.191V202H250.451V190.067H260.535V202H261.795V190.067H271.878V202H273.138V190.067H283.222V202H284.482V190.067H294.565V202H295.825V190.067H305.909V202H307.169V190.067H317.252V202H318.512V190.067H328.595V202H329.856V190.067H339.939V202H341.199V190.067H351.282V202H352.543V190.067H362.626V202H363.886V190.067H373.969V202H375.23V190.067H385.313V202H386.573V190.067H396.656V202H397.917V190.067H408V188.811H397.917V178.762H408V177.506H397.917V167.457H408V166.201H397.917V156.152H408V154.896H397.917L397.917 144.848H408V143.592H397.917V133.543H408V132.287H397.917V122.238H408V120.982H397.917V110.933L408 110.933V109.677H397.917L397.917 100.067H408V98.811H397.917V88.7622H408V87.5061H397.917V77.4574H408V76.2013H397.917V66.1525H408V64.8964H397.917L397.917 54.8476H408V53.5915H397.917V43.5427H408V42.2866H397.917V32.2378H408V30.9817H397.917V20.933L408 20.933V19.6769L397.917 19.6769V9L396.656 9V19.6769H386.573V9L385.313 9V19.6769L375.23 19.6769V9H373.969V19.6769L363.886 19.6769V9H362.626V19.6769L352.543 19.6769V9H351.283V19.6769H341.199V9H339.939V19.6769L329.856 19.6769V9H328.596ZM396.656 100.067H386.573L386.573 109.677H396.656L396.656 100.067ZM396.656 110.933H386.573V120.982H396.656V110.933ZM385.313 100.067H375.23L375.23 109.677H385.313L385.313 100.067ZM385.313 110.933H375.23V120.982H385.313V110.933ZM373.969 100.067H363.886L363.886 109.677H373.969L373.969 100.067ZM373.969 110.933H363.886V120.982H373.969V110.933ZM362.626 100.067H352.543L352.543 109.677H362.626L362.626 100.067ZM362.626 110.933H352.543V120.982H362.626V110.933ZM351.282 100.067L341.199 100.067L341.199 109.677H351.283L351.282 100.067ZM351.283 110.933H341.199V120.982H351.283V110.933ZM339.939 100.067H329.856L329.856 109.677H339.939L339.939 100.067ZM339.939 110.933H329.856V120.982L339.939 120.982V110.933ZM328.595 100.067H318.512L318.512 109.677L328.596 109.677L328.595 100.067ZM328.596 110.933L318.512 110.933V120.982H328.596V110.933ZM317.252 109.677L317.252 100.067H307.169L307.169 109.677H317.252ZM307.169 110.933V120.982H317.252V110.933H307.169ZM305.909 100.067H295.825L295.825 109.677H305.909L305.909 100.067ZM305.909 110.933H295.825V120.982H305.909V110.933ZM294.565 109.677L294.565 100.067H284.482L284.482 109.677H294.565ZM284.482 110.933V120.982H294.565V110.933H284.482ZM283.222 100.067H273.138L273.139 109.677H283.222L283.222 100.067ZM283.222 110.933H273.139V120.982H283.222V110.933ZM271.878 100.067H261.795L261.795 109.677H271.878L271.878 100.067ZM271.878 110.933H261.795V120.982H271.878V110.933ZM260.535 100.067H250.451L250.451 109.677H260.535L260.535 100.067ZM260.535 110.933H250.451V120.982H260.535V110.933ZM249.191 109.677L249.191 100.067H239.108L239.108 109.677L249.191 109.677ZM237.848 100.067L227.764 100.067L227.764 109.677H237.848L237.848 100.067ZM237.848 110.933H227.764V120.982H237.848V110.933ZM226.504 109.677L226.504 100.067H216.421L216.421 109.677H226.504ZM215.161 100.067H205.077L205.078 109.677H215.161L215.161 100.067ZM215.161 110.933L205.078 110.933V120.982L215.161 120.982V110.933ZM203.817 109.677L203.817 100.067H193.734L193.734 109.677H203.817ZM192.474 109.677L192.474 100.067H182.391L182.391 109.677H192.474ZM181.13 109.677L181.13 100.067H171.047L171.047 109.677H181.13ZM169.787 109.677L169.787 100.067H159.704L159.704 109.677H169.787ZM158.443 109.677L158.443 100.067H148.36L148.36 109.677H158.443ZM147.1 109.677L147.1 100.067H137.017L137.017 109.677H147.1ZM135.756 109.677L135.756 100.067H125.673L125.673 109.677L135.756 109.677ZM124.413 109.677L124.413 100.067L114.33 100.067L114.33 109.677H124.413ZM113.069 109.677L113.069 100.067H102.986L102.986 109.677H113.069ZM101.726 109.677L101.726 100.067H91.6426L91.6426 109.677H101.726ZM90.3822 109.677L90.3822 100.067H80.2991L80.2991 109.677H90.3822ZM79.0387 109.677L79.0387 100.067H68.9556L68.9556 109.677H79.0387ZM67.6953 109.677L67.6952 100.067H57.6121L57.6121 109.677H67.6953ZM56.3518 109.677L56.3517 100.067H46.2686L46.2687 109.677H56.3518ZM45.0083 109.677L45.0082 100.067H34.9251L34.9252 109.677L45.0083 109.677ZM33.6648 109.677L33.6647 100.067H23.5816L23.5817 109.677H33.6648ZM22.3213 109.677L22.3213 100.067H12.2382L12.2382 109.677H22.3213ZM10.9778 109.677L10.9778 100.067L0.894665 100.067L0.894695 109.677H10.9778ZM-0.365692 109.677L-0.365723 100.067H-10.4488L-10.4488 109.677H-0.365692ZM-11.7092 109.677L-11.7092 100.067H-21.7923L-21.7923 109.677H-11.7092ZM-23.0527 109.677L-23.0527 100.067H-33.1357L-33.1357 109.677H-23.0527ZM318.512 20.933L328.596 20.933V30.9817H318.512V20.933ZM318.512 32.2378H328.596V42.2866H318.512V32.2378ZM329.856 32.2378V42.2866H339.939V32.2378L329.856 32.2378ZM318.512 43.5427H328.596V53.5915L318.512 53.5915V43.5427ZM329.856 43.5427V53.5915H339.939V43.5427L329.856 43.5427ZM318.512 54.8476L328.596 54.8476L328.595 64.8964L318.512 64.8964L318.512 54.8476ZM329.856 54.8476L329.856 64.8964H339.939L339.939 54.8476H329.856ZM318.512 66.1525L328.595 66.1525V76.2013L318.512 76.2012V66.1525ZM329.856 66.1525V76.2013H339.939V66.1525H329.856ZM318.512 77.4573L328.595 77.4574V87.5061L318.512 87.5061V77.4573ZM329.856 77.4574V87.5061H339.939V77.4574H329.856ZM318.512 88.7622L328.595 88.7622V98.811H318.512V88.7622ZM329.856 88.7622V98.811H339.939V88.7622H329.856ZM351.282 98.811L341.199 98.811V88.7622H351.282V98.811ZM351.282 87.5061H341.199V77.4574H351.282V87.5061ZM351.282 76.2013H341.199V66.1525H351.282V76.2013ZM351.282 64.8964H341.199L341.199 54.8476H351.283L351.282 64.8964ZM351.283 53.5915H341.199V43.5427H351.283V53.5915ZM351.283 42.2866H341.199V32.2378H351.283V42.2866ZM351.283 30.9817H341.199V20.933H351.283V30.9817ZM329.856 20.933L339.939 20.933V30.9817L329.856 30.9817V20.933ZM352.543 30.9817V20.933L362.626 20.933V30.9817L352.543 30.9817ZM363.886 30.9817V20.933L373.969 20.933V30.9817H363.886ZM375.23 30.9817V20.933L385.313 20.933V30.9817H375.23ZM386.573 30.9817V20.933H396.656V30.9817L386.573 30.9817ZM386.573 32.2378L396.656 32.2378V42.2866L386.573 42.2866V32.2378ZM386.573 43.5427L396.656 43.5427V53.5915H386.573V43.5427ZM386.573 54.8476H396.656L396.656 64.8964H386.573L386.573 54.8476ZM386.573 66.1525H396.656V76.2013H386.573V66.1525ZM386.573 77.4574H396.656V87.5061H386.573V77.4574ZM386.573 88.7622H396.656V98.811H386.573V88.7622ZM385.313 88.7622V98.811H375.23V88.7622H385.313ZM373.969 88.7622V98.811H363.886V88.7622H373.969ZM362.626 88.7622V98.811H352.543V88.7622H362.626ZM362.626 87.5061H352.543V77.4574H362.626V87.5061ZM362.626 76.2013H352.543V66.1525H362.626V76.2013ZM362.626 64.8964H352.543L352.543 54.8476H362.626L362.626 64.8964ZM362.626 53.5915H352.543V43.5427H362.626V53.5915ZM362.626 42.2866L352.543 42.2866V32.2378L362.626 32.2378V42.2866ZM363.886 42.2866V32.2378H373.969V42.2866H363.886ZM375.23 42.2866V32.2378H385.313V42.2866H375.23ZM375.23 43.5427H385.313V53.5915L375.23 53.5915V43.5427ZM375.23 54.8476L385.313 54.8476L385.313 64.8964L375.23 64.8964L375.23 54.8476ZM375.23 66.1525L385.313 66.1525V76.2013H375.23V66.1525ZM375.23 77.4574H385.313V87.5061H375.23V77.4574ZM373.969 77.4574V87.5061H363.886V77.4574H373.969ZM373.969 76.2013H363.886V66.1525H373.969V76.2013ZM373.969 64.8964H363.886L363.886 54.8476H373.969L373.969 64.8964ZM373.969 53.5915H363.886V43.5427H373.969V53.5915ZM317.252 88.7622V98.811H307.169V88.7622H317.252ZM305.909 88.7622V98.811H295.825V88.7622H305.909ZM294.565 88.7622V98.811H284.482V88.7622H294.565ZM283.222 88.7622V98.811H273.138V88.7622H283.222ZM271.878 88.7622V98.811H261.795V88.7622H271.878ZM260.535 88.7622V98.811H250.451V88.7622H260.535ZM249.191 88.7622V98.811H239.108V88.7622H249.191ZM237.848 88.7622V98.811L227.764 98.811V88.7622H237.848ZM226.504 88.7622V98.811H216.421V88.7622H226.504ZM215.161 88.7622V98.811H205.077V88.7622L215.161 88.7622ZM203.817 88.7622V98.811H193.734V88.7622H203.817ZM192.474 88.7622V98.811H182.391V88.7622H192.474ZM181.13 88.7622V98.811H171.047V88.7622H181.13ZM169.787 88.7622V98.811H159.704V88.7622H169.787ZM158.443 88.7622V98.811H148.36V88.7622L158.443 88.7622ZM147.1 88.7622V98.811H137.017V88.7622H147.1ZM135.756 88.7622V98.811H125.673V88.7622H135.756ZM124.413 88.7622V98.811L114.33 98.811V88.7622H124.413ZM113.069 88.7622V98.811H102.986V88.7622H113.069ZM101.726 88.7622V98.811H91.6426V88.7622H101.726ZM90.3822 88.7622V98.811H80.2991V88.7622H90.3822ZM79.0387 88.7622V98.811H68.9556V88.7622H79.0387ZM67.6952 88.7622V98.811H57.6121V88.7622H67.6952ZM56.3517 88.7622V98.811H46.2686V88.7622H56.3517ZM45.0082 88.7622V98.811H34.9251V88.7622L45.0082 88.7622ZM33.6647 88.7622V98.811H23.5816L23.5816 88.7622H33.6647ZM22.3213 88.7622V98.811H12.2382L12.2382 88.7622H22.3213ZM10.9778 88.7622L10.9778 98.811L0.894665 98.811L0.894669 88.7622H10.9778ZM-0.365719 88.7622L-0.365723 98.811H-10.4488L-10.4488 88.7622H-0.365719ZM-11.7092 88.7622L-11.7092 98.811H-21.7923L-21.7923 88.7622L-11.7092 88.7622ZM-23.0527 88.7622L-23.0527 98.811H-33.1357L-33.1357 88.7622H-23.0527ZM-23.0527 87.5061H-33.1357L-33.1357 77.4573H-23.0527L-23.0527 87.5061ZM-23.0527 76.2012H-33.1357L-33.1357 66.1524H-23.0527L-23.0527 76.2012ZM-23.0527 64.8963H-33.1357L-33.1357 54.8476H-23.0527L-23.0527 64.8963ZM-23.0527 53.5915H-33.1357L-33.1357 43.5427H-23.0527L-23.0527 53.5915ZM-23.0527 42.2866L-33.1357 42.2866L-33.1357 32.2378L-23.0527 32.2378L-23.0527 42.2866ZM-23.0527 30.9817L-33.1357 30.9817L-33.1357 20.9329L-23.0527 20.9329L-23.0527 30.9817ZM-21.7923 30.9817L-21.7923 20.9329H-11.7092L-11.7092 30.9817H-21.7923ZM-10.4488 30.9817L-10.4488 20.9329L-0.365692 20.9329L-0.365696 30.9817L-10.4488 30.9817ZM0.894691 30.9817L0.894695 20.9329L10.9778 20.9329L10.9778 30.9817H0.894691ZM12.2382 30.9817L12.2382 20.9329H22.3213L22.3213 30.9817H12.2382ZM23.5817 30.9817L23.5817 20.9329L33.6648 20.9329L33.6648 30.9817L23.5817 30.9817ZM34.9252 30.9817L34.9252 20.9329L45.0083 20.9329L45.0083 30.9817H34.9252ZM46.2686 30.9817L46.2687 20.9329L56.3518 20.9329L56.3518 30.9817H46.2686ZM57.6121 30.9817L57.6121 20.9329H67.6953L67.6952 30.9817L57.6121 30.9817ZM68.9556 30.9817L68.9556 20.9329L79.0387 20.9329L79.0387 30.9817H68.9556ZM80.2991 30.9817L80.2991 20.9329L90.3822 20.9329L90.3822 30.9817L80.2991 30.9817ZM91.6426 30.9817L91.6426 20.9329H101.726L101.726 30.9817H91.6426ZM102.986 30.9817L102.986 20.9329H113.069L113.069 30.9817H102.986ZM114.33 30.9817V20.9329L124.413 20.9329V30.9817L114.33 30.9817ZM125.673 30.9817V20.9329L135.756 20.9329V30.9817H125.673ZM137.017 30.9817V20.9329H147.1V30.9817H137.017ZM148.36 30.9817V20.9329L158.443 20.9329V30.9817L148.36 30.9817ZM159.704 30.9817V20.9329L169.787 20.9329V30.9817H159.704ZM171.047 30.9817V20.9329L181.13 20.9329V30.9817L171.047 30.9817ZM182.391 30.9817V20.9329H192.474V30.9817H182.391ZM193.734 30.9817V20.9329L203.817 20.9329V30.9817H193.734ZM205.078 30.9817V20.9329L215.161 20.9329V30.9817L205.078 30.9817ZM216.421 30.9817V20.9329H226.504V30.9817H216.421ZM227.764 30.9817V20.933H237.848V30.9817H227.764ZM239.108 30.9817V20.933L249.191 20.933V30.9817L239.108 30.9817ZM250.451 30.9817V20.933L260.535 20.933V30.9817H250.451ZM261.795 30.9817V20.933H271.878V30.9817L261.795 30.9817ZM273.139 30.9817V20.933L283.222 20.933V30.9817H273.139ZM284.482 30.9817V20.933L294.565 20.933V30.9817H284.482ZM295.825 30.9817V20.933H305.909V30.9817L295.825 30.9817ZM307.169 30.9817V20.933H317.252V30.9817H307.169ZM307.169 32.2378H317.252V42.2866H307.169V32.2378ZM307.169 43.5427H317.252V53.5915H307.169V43.5427ZM307.169 54.8476H317.252L317.252 64.8964H307.169L307.169 54.8476ZM307.169 66.1525H317.252V76.2012H307.169V66.1525ZM307.169 77.4573H317.252V87.5061H307.169V77.4573ZM305.909 77.4573V87.5061H295.825V77.4573H305.909ZM294.565 77.4573V87.5061H284.482V77.4573H294.565ZM283.222 77.4573V87.5061H273.138L273.139 77.4573H283.222ZM271.878 77.4573V87.5061L261.795 87.5061L261.795 77.4573H271.878ZM260.535 77.4573V87.5061H250.451V77.4573H260.535ZM249.191 77.4573L249.191 87.5061H239.108L239.108 77.4573H249.191ZM237.848 77.4573L237.848 87.5061H227.764V77.4573H237.848ZM226.504 77.4573L226.504 87.5061H216.421L216.421 77.4573H226.504ZM215.161 77.4573L215.161 87.5061H205.077L205.077 77.4573L215.161 77.4573ZM203.817 77.4573L203.817 87.5061H193.734L193.734 77.4573H203.817ZM192.474 77.4573L192.474 87.5061H182.391L182.391 77.4573H192.474ZM181.13 77.4573L181.13 87.5061H171.047L171.047 77.4573H181.13ZM169.787 77.4573L169.787 87.5061H159.704L159.704 77.4573H169.787ZM158.443 77.4573L158.443 87.5061L148.36 87.5061L148.36 77.4573L158.443 77.4573ZM147.1 77.4573L147.1 87.5061H137.017L137.017 77.4573H147.1ZM135.756 77.4573L135.756 87.5061H125.673L125.673 77.4573H135.756ZM124.413 77.4573L124.413 87.5061H114.33V77.4573H124.413ZM113.069 77.4573V87.5061H102.986V77.4573H113.069ZM101.726 77.4573V87.5061L91.6426 87.5061V77.4573H101.726ZM90.3822 77.4573V87.5061H80.2991V77.4573H90.3822ZM79.0387 77.4573V87.5061H68.9556V77.4573H79.0387ZM67.6952 77.4573V87.5061H57.6121V77.4573H67.6952ZM56.3517 77.4573V87.5061H46.2686V77.4573H56.3517ZM45.0082 77.4573V87.5061H34.9251V77.4573L45.0082 77.4573ZM33.6648 77.4573L33.6647 87.5061H23.5816V77.4573H33.6648ZM22.3213 77.4573L22.3213 87.5061H12.2382L12.2382 77.4573H22.3213ZM10.9778 77.4573L10.9778 87.5061H0.894669L0.894672 77.4573H10.9778ZM-0.365715 77.4573L-0.365719 87.5061H-10.4488L-10.4488 77.4573H-0.365715ZM-11.7092 77.4573L-11.7092 87.5061L-21.7923 87.5061L-21.7923 77.4573L-11.7092 77.4573ZM-11.7092 76.2012L-21.7923 76.2012L-21.7923 66.1524L-11.7092 66.1524L-11.7092 76.2012ZM-11.7092 64.8963L-21.7923 64.8963L-21.7923 54.8476L-11.7092 54.8476L-11.7092 64.8963ZM-11.7092 53.5915L-21.7923 53.5915L-21.7923 43.5427H-11.7092L-11.7092 53.5915ZM-11.7092 42.2866H-21.7923L-21.7923 32.2378H-11.7092L-11.7092 42.2866ZM-10.4488 42.2866L-10.4488 32.2378L-0.365696 32.2378L-0.3657 42.2866H-10.4488ZM0.894688 42.2866L0.894691 32.2378H10.9778L10.9778 42.2866H0.894688ZM12.2382 42.2866L12.2382 32.2378H22.3213V42.2866H12.2382ZM23.5817 42.2866L23.5817 32.2378L33.6648 32.2378V42.2866L23.5817 42.2866ZM34.9252 42.2866V32.2378H45.0083V42.2866H34.9252ZM46.2686 42.2866V32.2378H56.3518V42.2866H46.2686ZM57.6121 42.2866V32.2378L67.6952 32.2378V42.2866L57.6121 42.2866ZM68.9556 42.2866V32.2378H79.0387V42.2866H68.9556ZM80.2991 42.2866V32.2378L90.3822 32.2378V42.2866H80.2991ZM91.6426 42.2866V32.2378H101.726V42.2866H91.6426ZM102.986 42.2866V32.2378H113.069V42.2866H102.986ZM114.33 42.2866V32.2378L124.413 32.2378L124.413 42.2866L114.33 42.2866ZM125.673 42.2866L125.673 32.2378H135.756L135.756 42.2866H125.673ZM137.017 42.2866L137.017 32.2378H147.1L147.1 42.2866H137.017ZM148.36 42.2866L148.36 32.2378L158.443 32.2378L158.443 42.2866L148.36 42.2866ZM159.704 42.2866L159.704 32.2378H169.787L169.787 42.2866H159.704ZM171.047 42.2866L171.047 32.2378L181.13 32.2378L181.13 42.2866H171.047ZM182.391 42.2866L182.391 32.2378H192.474L192.474 42.2866H182.391ZM193.734 42.2866L193.734 32.2378H203.817L203.817 42.2866H193.734ZM205.077 42.2866L205.078 32.2378L215.161 32.2378V42.2866L205.077 42.2866ZM216.421 42.2866L216.421 32.2378H226.504L226.504 42.2866H216.421ZM227.764 42.2866L227.764 32.2378H237.848V42.2866H227.764ZM239.108 42.2866L239.108 32.2378L249.191 32.2378L249.191 42.2866L239.108 42.2866ZM250.451 42.2866L250.451 32.2378H260.535L260.535 42.2866H250.451ZM261.795 42.2866V32.2378L271.878 32.2378L271.878 42.2866H261.795ZM273.139 42.2866V32.2378H283.222V42.2866H273.139ZM284.482 42.2866V32.2378H294.565V42.2866H284.482ZM295.825 42.2866V32.2378L305.909 32.2378V42.2866L295.825 42.2866ZM295.825 43.5427H305.909V53.5915H295.825V43.5427ZM295.825 54.8476H305.909L305.909 64.8964H295.825L295.825 54.8476ZM295.825 66.1525H305.909V76.2012H295.825V66.1525ZM294.565 66.1525V76.2012H284.482V66.1525H294.565ZM283.222 66.1525V76.2012H273.139V66.1525H283.222ZM271.878 66.1525V76.2012L261.795 76.2012V66.1525L271.878 66.1525ZM260.535 66.1525V76.2012H250.451V66.1525H260.535ZM249.191 66.1525V76.2012H239.108V66.1525H249.191ZM237.848 66.1525V76.2012H227.764V66.1525H237.848ZM226.504 66.1525V76.2012H216.421V66.1525H226.504ZM215.161 66.1525V76.2012H205.077V66.1525L215.161 66.1525ZM203.817 66.1525V76.2012H193.734V66.1525H203.817ZM192.474 66.1525V76.2012H182.391V66.1525H192.474ZM181.13 66.1525V76.2012H171.047V66.1525H181.13ZM169.787 66.1525V76.2012H159.704V66.1525H169.787ZM158.443 66.1525V76.2012L148.36 76.2012V66.1525L158.443 66.1525ZM147.1 66.1525V76.2012H137.017V66.1525H147.1ZM135.756 66.1525V76.2012H125.673V66.1525H135.756ZM124.413 66.1525V76.2012H114.33V66.1525H124.413ZM113.069 66.1525V76.2012H102.986V66.1525H113.069ZM101.726 66.1525V76.2012L91.6426 76.2012V66.1524L101.726 66.1525ZM90.3822 66.1524L90.3822 76.2012H80.2991L80.2991 66.1524H90.3822ZM79.0387 66.1524L79.0387 76.2012H68.9556L68.9556 66.1524H79.0387ZM67.6952 66.1524L67.6952 76.2012H57.6121L57.6121 66.1524H67.6952ZM56.3517 66.1524L56.3517 76.2012H46.2686L46.2686 66.1524H56.3517ZM45.0082 66.1524L45.0082 76.2012H34.9251L34.9251 66.1524L45.0082 66.1524ZM33.6648 66.1524V76.2012H23.5816L23.5817 66.1524H33.6648ZM22.3213 66.1524L22.3213 76.2012H12.2382L12.2382 66.1524H22.3213ZM10.9778 66.1524L10.9778 76.2012H0.894672L0.894676 66.1524H10.9778ZM-0.365711 66.1524L-0.365715 76.2012H-10.4488L-10.4488 66.1524H-0.365711ZM-0.365711 64.8963H-10.4488L-10.4488 54.8476H-0.365704L-0.365711 64.8963ZM-0.365704 53.5915H-10.4488L-10.4488 43.5427L-0.3657 43.5427L-0.365704 53.5915ZM0.894684 53.5915L0.894688 43.5427H10.9778L10.9778 53.5915H0.894684ZM12.2382 53.5915L12.2382 43.5427H22.3213L22.3213 53.5915H12.2382ZM23.5817 53.5915V43.5427L33.6648 43.5427L33.6648 53.5915H23.5817ZM34.9251 53.5915L34.9252 43.5427H45.0083L45.0082 53.5915L34.9251 53.5915ZM46.2686 53.5915L46.2686 43.5427H56.3518L56.3517 53.5915H46.2686ZM57.6121 53.5915L57.6121 43.5427H67.6952L67.6952 53.5915H57.6121ZM68.9556 53.5915L68.9556 43.5427H79.0387L79.0387 53.5915H68.9556ZM80.2991 53.5915L80.2991 43.5427L90.3822 43.5427V53.5915H80.2991ZM91.6426 53.5915L91.6426 43.5427H101.726L101.726 53.5915L91.6426 53.5915ZM102.986 53.5915L102.986 43.5427H113.069L113.069 53.5915H102.986ZM114.33 53.5915L114.33 43.5427H124.413V53.5915H114.33ZM125.673 53.5915V43.5427H135.756V53.5915H125.673ZM137.017 53.5915V43.5427H147.1V53.5915H137.017ZM148.36 53.5915V43.5427L158.443 43.5427V53.5915L148.36 53.5915ZM159.704 53.5915V43.5427H169.787V53.5915H159.704ZM171.047 53.5915V43.5427L181.13 43.5427V53.5915H171.047ZM182.391 53.5915V43.5427H192.474V53.5915H182.391ZM193.734 53.5915V43.5427H203.817V53.5915H193.734ZM205.077 53.5915V43.5427H215.161V53.5915L205.077 53.5915ZM216.421 53.5915V43.5427H226.504V53.5915H216.421ZM227.764 53.5915V43.5427H237.848V53.5915H227.764ZM239.108 53.5915V43.5427L249.191 43.5427V53.5915H239.108ZM250.451 53.5915V43.5427H260.535V53.5915H250.451ZM261.795 53.5915V43.5427L271.878 43.5427V53.5915L261.795 53.5915ZM273.139 53.5915V43.5427H283.222V53.5915H273.139ZM284.482 53.5915V43.5427H294.565V53.5915H284.482ZM284.482 54.8476H294.565L294.565 64.8964H284.482L284.482 54.8476ZM283.222 54.8476L283.222 64.8964H273.139V54.8476H283.222ZM271.878 54.8476V64.8964L261.795 64.8964V54.8476L271.878 54.8476ZM260.535 54.8476V64.8964H250.451V54.8476H260.535ZM249.191 54.8476V64.8964H239.108V54.8476H249.191ZM237.848 54.8476V64.8964H227.764V54.8476H237.848ZM226.504 54.8476V64.8964H216.421V54.8476H226.504ZM215.161 54.8476V64.8964L205.077 64.8964V54.8476L215.161 54.8476ZM203.817 54.8476V64.8964H193.734V54.8476H203.817ZM192.474 54.8476V64.8964H182.391V54.8476H192.474ZM181.13 54.8476V64.8964H171.047V54.8476H181.13ZM169.787 54.8476V64.8964H159.704V54.8476H169.787ZM158.443 54.8476V64.8964L148.36 64.8964V54.8476L158.443 54.8476ZM147.1 54.8476V64.8964H137.017V54.8476H147.1ZM135.756 54.8476V64.8964H125.673V54.8476H135.756ZM124.413 54.8476V64.8964H114.33V54.8476H124.413ZM113.069 54.8476V64.8964H102.986V54.8476H113.069ZM101.726 54.8476V64.8964L91.6426 64.8964V54.8476L101.726 54.8476ZM90.3822 54.8476V64.8964H80.2991V54.8476H90.3822ZM79.0387 54.8476V64.8964H68.9556V54.8476H79.0387ZM67.6952 54.8476V64.8964H57.6121V54.8476H67.6952ZM56.3517 54.8476V64.8964H46.2686V54.8476H56.3517ZM45.0082 54.8476V64.8964L34.9251 64.8963V54.8476L45.0082 54.8476ZM33.6648 54.8476L33.6648 64.8963H23.5817L23.5817 54.8476H33.6648ZM22.3213 54.8476V64.8963H12.2382L12.2382 54.8476H22.3213ZM10.9778 54.8476L10.9778 64.8963H0.894676L0.894684 54.8476H10.9778ZM318.512 122.238H328.596V132.287H318.512V122.238ZM329.856 122.238V132.287H339.939V122.238H329.856ZM318.512 133.543H328.596V143.591H318.512V133.543ZM329.856 133.543V143.591H339.939V133.543L329.856 133.543ZM318.512 144.848H328.596L328.595 154.896L318.512 154.896L318.512 144.848ZM329.856 144.848L329.856 154.896H339.939L339.939 144.848H329.856ZM318.512 156.152H328.595V166.201L318.512 166.201V156.152ZM329.856 156.152V166.201H339.939V156.152H329.856ZM318.512 167.457L328.595 167.457V177.506H318.512V167.457ZM329.856 167.457V177.506H339.939V167.457H329.856ZM318.512 178.762L328.595 178.762V188.811H318.512V178.762ZM329.856 178.762V188.811H339.939V178.762H329.856ZM351.282 188.811H341.199V178.762H351.282V188.811ZM351.282 177.506H341.199V167.457H351.282V177.506ZM351.282 166.201H341.199V156.152H351.282V166.201ZM351.282 154.896H341.199L341.199 144.848H351.283L351.282 154.896ZM351.283 143.591H341.199V133.543H351.283V143.591ZM351.283 132.287H341.199V122.238H351.283V132.287ZM386.573 122.238H396.656V132.287H386.573V122.238ZM386.573 133.543L396.656 133.543V143.592H386.573V133.543ZM386.573 144.848H396.656L396.656 154.896H386.573L386.573 144.848ZM386.573 156.152H396.656V166.201H386.573V156.152ZM386.573 167.457H396.656V177.506H386.573V167.457ZM386.573 178.762H396.656V188.811H386.573V178.762ZM385.313 178.762V188.811H375.23V178.762H385.313ZM373.969 178.762V188.811H363.886V178.762H373.969ZM362.626 178.762V188.811H352.543V178.762H362.626ZM362.626 177.506H352.543V167.457H362.626V177.506ZM362.626 166.201H352.543V156.152H362.626V166.201ZM362.626 154.896H352.543L352.543 144.848H362.626L362.626 154.896ZM362.626 143.591H352.543V133.543H362.626V143.591ZM362.626 132.287H352.543V122.238H362.626V132.287ZM363.886 132.287V122.238H373.969V132.287H363.886ZM375.23 132.287V122.238H385.313V132.287H375.23ZM375.23 133.543H385.313V143.592L375.23 143.591V133.543ZM375.23 144.848H385.313L385.313 154.896H375.23L375.23 144.848ZM375.23 156.152L385.313 156.152V166.201H375.23V156.152ZM375.23 167.457H385.313V177.506H375.23V167.457ZM373.969 167.457V177.506H363.886V167.457H373.969ZM373.969 166.201H363.886V156.152H373.969V166.201ZM373.969 154.896H363.886L363.886 144.848H373.969L373.969 154.896ZM373.969 143.591H363.886V133.543H373.969V143.591ZM317.252 178.762V188.811H307.169V178.762H317.252ZM305.909 178.762V188.811H295.825V178.762H305.909ZM294.565 178.762V188.811H284.482V178.762H294.565ZM283.222 178.762V188.811H273.138V178.762H283.222ZM271.878 178.762V188.811H261.795V178.762H271.878ZM260.535 178.762V188.811H250.451V178.762H260.535ZM249.191 178.762V188.811H239.108V178.762H249.191ZM237.848 178.762V188.811H227.764V178.762H237.848ZM226.504 178.762V188.811H216.421V178.762H226.504ZM215.161 178.762V188.811H205.077V178.762L215.161 178.762ZM203.817 178.762V188.811H193.734V178.762H203.817ZM192.474 178.762V188.811H182.391V178.762H192.474ZM181.13 178.762V188.811H171.047V178.762H181.13ZM169.787 178.762V188.811H159.704V178.762H169.787ZM158.443 178.762V188.811H148.36V178.762H158.443ZM147.1 178.762V188.811H137.017V178.762H147.1ZM135.756 178.762V188.811H125.673V178.762H135.756ZM124.413 178.762V188.811L114.33 188.811V178.762H124.413ZM113.069 178.762V188.811H102.986V178.762H113.069ZM101.726 178.762V188.811H91.6426V178.762H101.726ZM90.3822 178.762V188.811H80.2991V178.762H90.3822ZM79.0387 178.762V188.811H68.9556V178.762H79.0387ZM67.6952 178.762V188.811H57.6121V178.762H67.6952ZM56.3517 178.762V188.811H46.2686V178.762H56.3517ZM45.0082 178.762V188.811H34.9251V178.762H45.0082ZM33.6647 178.762V188.811H23.5816L23.5816 178.762H33.6647ZM22.3213 178.762V188.811H12.2382L12.2382 178.762H22.3213ZM10.9778 178.762L10.9778 188.811H0.894665L0.894669 178.762H10.9778ZM-0.365719 178.762L-0.365723 188.811H-10.4488L-10.4488 178.762H-0.365719ZM-11.7092 178.762L-11.7092 188.811H-21.7923L-21.7923 178.762L-11.7092 178.762ZM-23.0527 178.762L-23.0527 188.811H-33.1357L-33.1357 178.762H-23.0527ZM-23.0527 177.506H-33.1357L-33.1357 167.457H-23.0527L-23.0527 177.506ZM-23.0527 166.201H-33.1357L-33.1357 156.152H-23.0527L-23.0527 166.201ZM-23.0527 154.896H-33.1357L-33.1357 144.848H-23.0527L-23.0527 154.896ZM-23.0527 143.591H-33.1357L-33.1357 133.543H-23.0527L-23.0527 143.591ZM-23.0527 132.287H-33.1357L-33.1357 122.238H-23.0527L-23.0527 132.287ZM-23.0527 120.982H-33.1357L-33.1357 110.933H-23.0527L-23.0527 120.982ZM-21.7923 120.982L-21.7923 110.933H-11.7092L-11.7092 120.982H-21.7923ZM-10.4488 120.982L-10.4488 110.933H-0.365692L-0.365696 120.982H-10.4488ZM0.894691 120.982L0.894695 110.933L10.9778 110.933L10.9778 120.982H0.894691ZM12.2382 120.982L12.2382 110.933H22.3213L22.3213 120.982H12.2382ZM23.5817 120.982L23.5817 110.933H33.6648L33.6648 120.982L23.5817 120.982ZM34.9252 120.982L34.9252 110.933H45.0083L45.0083 120.982H34.9252ZM46.2686 120.982L46.2687 110.933H56.3518L56.3518 120.982H46.2686ZM57.6121 120.982L57.6121 110.933H67.6953L67.6952 120.982H57.6121ZM68.9556 120.982L68.9556 110.933H79.0387L79.0387 120.982H68.9556ZM80.2991 120.982L80.2991 110.933H90.3822L90.3822 120.982H80.2991ZM91.6426 120.982L91.6426 110.933H101.726L101.726 120.982H91.6426ZM102.986 120.982L102.986 110.933H113.069L113.069 120.982H102.986ZM114.33 120.982V110.933L124.413 110.933V120.982H114.33ZM125.673 120.982V110.933H135.756V120.982H125.673ZM137.017 120.982V110.933H147.1V120.982H137.017ZM148.36 120.982V110.933H158.443V120.982L148.36 120.982ZM159.704 120.982V110.933H169.787V120.982H159.704ZM171.047 120.982V110.933H181.13V120.982H171.047ZM182.391 120.982V110.933H192.474V120.982H182.391ZM193.734 120.982V110.933H203.817V120.982H193.734ZM216.421 120.982V110.933H226.504V120.982H216.421ZM239.108 120.982V110.933H249.191V120.982H239.108ZM307.169 122.238H317.252V132.287H307.169V122.238ZM307.169 133.543H317.252V143.591H307.169V133.543ZM307.169 144.848H317.252L317.252 154.896H307.169L307.169 144.848ZM307.169 156.152H317.252V166.201H307.169V156.152ZM307.169 167.457H317.252V177.506H307.169V167.457ZM305.909 167.457V177.506H295.825V167.457H305.909ZM294.565 167.457V177.506H284.482V167.457H294.565ZM283.222 167.457V177.506H273.138L273.139 167.457H283.222ZM271.878 167.457V177.506L261.795 177.506L261.795 167.457H271.878ZM260.535 167.457V177.506H250.451V167.457H260.535ZM249.191 167.457L249.191 177.506H239.108L239.108 167.457H249.191ZM237.848 167.457L237.848 177.506H227.764V167.457H237.848ZM226.504 167.457L226.504 177.506H216.421L216.421 167.457H226.504ZM215.161 167.457L215.161 177.506H205.077L205.077 167.457H215.161ZM203.817 167.457L203.817 177.506H193.734L193.734 167.457H203.817ZM192.474 167.457L192.474 177.506H182.391L182.391 167.457H192.474ZM181.13 167.457L181.13 177.506H171.047L171.047 167.457H181.13ZM169.787 167.457L169.787 177.506H159.704L159.704 167.457H169.787ZM158.443 167.457L158.443 177.506L148.36 177.506L148.36 167.457H158.443ZM147.1 167.457L147.1 177.506H137.017L137.017 167.457H147.1ZM135.756 167.457L135.756 177.506H125.673L125.673 167.457H135.756ZM124.413 167.457L124.413 177.506H114.33V167.457H124.413ZM113.069 167.457V177.506H102.986V167.457H113.069ZM101.726 167.457V177.506H91.6426V167.457H101.726ZM90.3822 167.457V177.506H80.2991V167.457H90.3822ZM79.0387 167.457V177.506H68.9556V167.457H79.0387ZM67.6952 167.457V177.506H57.6121V167.457H67.6952ZM56.3517 167.457V177.506H46.2686V167.457H56.3517ZM45.0082 167.457V177.506H34.9251V167.457L45.0082 167.457ZM33.6648 167.457L33.6647 177.506H23.5816V167.457H33.6648ZM22.3213 167.457L22.3213 177.506H12.2382L12.2382 167.457H22.3213ZM10.9778 167.457L10.9778 177.506H0.894669L0.894672 167.457H10.9778ZM-0.365715 167.457L-0.365719 177.506H-10.4488L-10.4488 167.457H-0.365715ZM-11.7092 167.457L-11.7092 177.506H-21.7923L-21.7923 167.457L-11.7092 167.457ZM-11.7092 166.201L-21.7923 166.201L-21.7923 156.152H-11.7092L-11.7092 166.201ZM-11.7092 154.896L-21.7923 154.896L-21.7923 144.848H-11.7092L-11.7092 154.896ZM-11.7092 143.591H-21.7923L-21.7923 133.543H-11.7092L-11.7092 143.591ZM-11.7092 132.287H-21.7923L-21.7923 122.238H-11.7092L-11.7092 132.287ZM-10.4488 132.287L-10.4488 122.238H-0.365696L-0.3657 132.287H-10.4488ZM0.894688 132.287L0.894691 122.238H10.9778L10.9778 132.287H0.894688ZM12.2382 132.287L12.2382 122.238H22.3213V132.287H12.2382ZM23.5817 132.287L23.5817 122.238L33.6648 122.238V132.287H23.5817ZM34.9252 132.287V122.238H45.0083V132.287H34.9252ZM46.2686 132.287V122.238H56.3518V132.287H46.2686ZM57.6121 132.287V122.238H67.6952V132.287L57.6121 132.287ZM68.9556 132.287V122.238H79.0387V132.287H68.9556ZM80.2991 132.287V122.238L90.3822 122.238V132.287H80.2991ZM91.6426 132.287V122.238H101.726V132.287H91.6426ZM102.986 132.287V122.238H113.069V132.287H102.986ZM114.33 132.287V122.238H124.413L124.413 132.287L114.33 132.287ZM125.673 132.287L125.673 122.238H135.756L135.756 132.287H125.673ZM137.017 132.287L137.017 122.238H147.1L147.1 132.287H137.017ZM148.36 132.287L148.36 122.238H158.443L158.443 132.287H148.36ZM159.704 132.287L159.704 122.238H169.787L169.787 132.287H159.704ZM171.047 132.287L171.047 122.238H181.13L181.13 132.287H171.047ZM182.391 132.287L182.391 122.238H192.474L192.474 132.287H182.391ZM193.734 132.287L193.734 122.238H203.817L203.817 132.287H193.734ZM205.077 132.287L205.078 122.238L215.161 122.238V132.287H205.077ZM216.421 132.287L216.421 122.238H226.504L226.504 132.287H216.421ZM227.764 132.287L227.764 122.238H237.848V132.287H227.764ZM239.108 132.287L239.108 122.238H249.191L249.191 132.287L239.108 132.287ZM250.451 132.287L250.451 122.238H260.535L260.535 132.287H250.451ZM261.795 132.287V122.238H271.878L271.878 132.287H261.795ZM273.139 132.287V122.238H283.222V132.287H273.139ZM284.482 132.287V122.238H294.565V132.287H284.482ZM295.825 132.287V122.238L305.909 122.238V132.287L295.825 132.287ZM295.825 133.543H305.909V143.591H295.825V133.543ZM295.825 144.848H305.909L305.909 154.896H295.825L295.825 144.848ZM295.825 156.152H305.909V166.201H295.825V156.152ZM294.565 156.152V166.201H284.482V156.152H294.565ZM283.222 156.152V166.201H273.139V156.152H283.222ZM271.878 156.152V166.201L261.795 166.201V156.152H271.878ZM260.535 156.152V166.201H250.451V156.152H260.535ZM249.191 156.152V166.201H239.108V156.152H249.191ZM237.848 156.152V166.201H227.764V156.152H237.848ZM226.504 156.152V166.201H216.421V156.152H226.504ZM215.161 156.152V166.201H205.077V156.152H215.161ZM203.817 156.152V166.201H193.734V156.152H203.817ZM192.474 156.152V166.201H182.391V156.152H192.474ZM181.13 156.152V166.201H171.047V156.152H181.13ZM169.787 156.152V166.201H159.704V156.152H169.787ZM158.443 156.152V166.201H148.36V156.152L158.443 156.152ZM147.1 156.152V166.201H137.017V156.152H147.1ZM135.756 156.152V166.201H125.673V156.152H135.756ZM124.413 156.152V166.201H114.33V156.152H124.413ZM113.069 156.152V166.201H102.986V156.152H113.069ZM101.726 156.152V166.201H91.6426V156.152H101.726ZM90.3822 156.152L90.3822 166.201H80.2991L80.2991 156.152H90.3822ZM79.0387 156.152L79.0387 166.201H68.9556L68.9556 156.152H79.0387ZM67.6952 156.152L67.6952 166.201H57.6121L57.6121 156.152H67.6952ZM56.3517 156.152L56.3517 166.201H46.2686L46.2686 156.152H56.3517ZM45.0082 156.152L45.0082 166.201H34.9251L34.9251 156.152L45.0082 156.152ZM33.6648 156.152V166.201H23.5816L23.5817 156.152H33.6648ZM22.3213 156.152L22.3213 166.201H12.2382L12.2382 156.152H22.3213ZM10.9778 156.152L10.9778 166.201H0.894672L0.894676 156.152H10.9778ZM-0.365711 156.152L-0.365715 166.201H-10.4488L-10.4488 156.152H-0.365711ZM-0.365711 154.896H-10.4488L-10.4488 144.848H-0.365704L-0.365711 154.896ZM-0.365704 143.591H-10.4488L-10.4488 133.543L-0.3657 133.543L-0.365704 143.591ZM0.894684 143.591L0.894688 133.543H10.9778L10.9778 143.591H0.894684ZM12.2382 143.591L12.2382 133.543H22.3213L22.3213 143.591H12.2382ZM23.5817 143.591V133.543H33.6648L33.6648 143.591H23.5817ZM34.9251 143.591L34.9252 133.543H45.0083L45.0082 143.591L34.9251 143.591ZM46.2686 143.591L46.2686 133.543H56.3518L56.3517 143.591H46.2686ZM57.6121 143.591L57.6121 133.543H67.6952L67.6952 143.591H57.6121ZM68.9556 143.591L68.9556 133.543H79.0387L79.0387 143.591H68.9556ZM80.2991 143.591L80.2991 133.543H90.3822V143.591H80.2991ZM91.6426 143.591L91.6426 133.543H101.726L101.726 143.591H91.6426ZM102.986 143.591L102.986 133.543H113.069L113.069 143.591H102.986ZM114.33 143.591L114.33 133.543H124.413V143.591H114.33ZM125.673 143.591V133.543H135.756V143.591H125.673ZM137.017 143.591V133.543H147.1V143.591H137.017ZM148.36 143.591V133.543L158.443 133.543V143.591L148.36 143.591ZM159.704 143.591V133.543H169.787V143.591H159.704ZM171.047 143.591V133.543L181.13 133.543V143.591H171.047ZM182.391 143.591V133.543H192.474V143.591H182.391ZM193.734 143.591V133.543H203.817V143.591H193.734ZM205.077 143.591V133.543H215.161V143.591H205.077ZM216.421 143.591V133.543H226.504V143.591H216.421ZM227.764 143.591V133.543H237.848V143.591H227.764ZM239.108 143.591V133.543H249.191V143.591H239.108ZM250.451 143.591V133.543H260.535V143.591H250.451ZM261.795 143.591V133.543H271.878V143.591H261.795ZM273.139 143.591V133.543H283.222V143.591H273.139ZM284.482 143.591V133.543H294.565V143.591H284.482ZM284.482 144.848H294.565L294.565 154.896H284.482L284.482 144.848ZM283.222 144.848L283.222 154.896H273.139V144.848H283.222ZM271.878 144.848V154.896H261.795V144.848L271.878 144.848ZM260.535 144.848V154.896H250.451V144.848H260.535ZM249.191 144.848V154.896H239.108V144.848H249.191ZM237.848 144.848V154.896H227.764V144.848H237.848ZM226.504 144.848V154.896H216.421V144.848H226.504ZM215.161 144.848V154.896H205.077V144.848H215.161ZM203.817 144.848V154.896H193.734V144.848H203.817ZM192.474 144.848V154.896H182.391V144.848H192.474ZM181.13 144.848V154.896H171.047V144.848H181.13ZM169.787 144.848V154.896H159.704V144.848H169.787ZM158.443 144.848V154.896H148.36V144.848H158.443ZM147.1 144.848V154.896H137.017V144.848H147.1ZM135.756 144.848V154.896H125.673V144.848H135.756ZM124.413 144.848V154.896H114.33V144.848H124.413ZM113.069 144.848V154.896H102.986V144.848H113.069ZM101.726 144.848V154.896L91.6426 154.896V144.848L101.726 144.848ZM90.3822 144.848V154.896H80.2991V144.848H90.3822ZM79.0387 144.848V154.896H68.9556V144.848H79.0387ZM67.6952 144.848V154.896H57.6121V144.848H67.6952ZM56.3517 144.848V154.896H46.2686V144.848H56.3517ZM45.0082 144.848V154.896H34.9251V144.848H45.0082ZM33.6648 144.848L33.6648 154.896H23.5817L23.5817 144.848H33.6648ZM22.3213 144.848V154.896H12.2382L12.2382 144.848H22.3213ZM10.9778 144.848L10.9778 154.896H0.894676L0.894684 144.848H10.9778Z",
    fill: "#A06C4F"
  }), /* @__PURE__ */ jsx("path", {
    d: "M318 89V92H319V89H322V88H319V85H318V88H315V89H318Z",
    fill: "#BCA359"
  }), /* @__PURE__ */ jsx("path", {
    d: "M22 89V92H23V89H26V88H23V85H22V88H19V89H22Z",
    fill: "#BCA359"
  }), /* @__PURE__ */ jsx("path", {
    d: "M318 32V35H319V32H322V31H319V28H318V31H315V32H318Z",
    fill: "#BCA359"
  }), /* @__PURE__ */ jsx("path", {
    d: "M22 32V35H23V32H26V31H23V28H22V31H19V32H22Z",
    fill: "#BCA359"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335 106H326V104H333V97H335V106Z",
    fill: "#BCA059"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 106H14V104H7V97H5V106Z",
    fill: "#BCA059"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335 14H326V16H333V23H335V14Z",
    fill: "#BCA059"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14H14V16H7V23H5V14Z",
    fill: "#BCA059"
  })]
}));
const Memo$S = memo(BgIcon5);
const BgIcon6 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 708 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M700 24H4.76837e-06V0H700V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M700 24V0H708V16.3636L700 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H703",
    stroke: "#D1A563"
  })]
}));
const Memo$R = memo(BgIcon6);
const BgIcon$2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 708 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M700 24H4.76837e-06V0H700V24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M700 24V0H708V16.3636L700 24Z",
    fill: "#E7C570"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 20H703",
    stroke: "#D1A563"
  })]
}));
const Memo$Q = memo(BgIcon$2);
const DotlineIcon2 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 177 1.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0H177",
    stroke: "#C8AB46",
    strokeWidth: 1.5,
    strokeDasharray: "2 2 2 2"
  })
}));
const Memo$P = memo(DotlineIcon2);
const DotlineIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 188 1.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0H188",
    stroke: "#C8AB46",
    strokeWidth: 1.5,
    strokeDasharray: "2 2 2 2"
  })
}));
const Memo$O = memo(DotlineIcon);
const Image_firearmIcon$2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 316 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    clipPath: "url(#clip0_274_14096)",
    children: /* @__PURE__ */ jsx("g", {
      filter: "url(#filter0_d_274_14096)",
      children: /* @__PURE__ */ jsx("path", {
        d: "M232.649 4.112C232.177 4.39922 231.94 5.67115 231.94 7.8731C231.926 9.81519 231.954 9.96564 232.302 10.6905C232.51 11.1145 232.677 11.5111 232.677 11.5658C232.677 11.6889 221.926 11.5521 219.158 11.4017L217.517 11.3196V10.8273C217.517 10.1161 217.239 9.6921 216.544 9.32283C215.765 8.89885 214.43 8.84415 213.456 9.21342C212.733 9.48695 211.954 10.2528 211.954 10.6905C211.954 10.8546 211.815 11.0051 211.578 11.1008C211.314 11.1965 207.392 11.2239 199.089 11.1829C188.282 11.1282 186.877 11.1008 185.945 10.8957C184.819 10.6358 182.635 10.6495 179.408 10.9367C178.532 11.0051 175.389 11.0735 172.426 11.0735L167.03 11.0871L166.835 10.6221C166.557 9.97931 166.181 9.80152 165.597 10.034C165.347 10.1434 164.735 10.2665 164.248 10.3212C163.4 10.4033 163.01 10.3486 161.912 10.0067C161.522 9.89725 161.411 9.91093 161.174 10.1434C161.035 10.2802 160.91 10.5537 160.91 10.7452V11.0871H147.461L147.308 10.7452C147.03 10.1434 147.113 9.82887 147.892 8.48855C148.573 7.31236 148.629 7.16191 148.434 6.95676C148.142 6.6422 146.529 5.82159 145.514 5.49335C144.318 5.09673 143.107 5.12408 143.107 5.53438C143.094 5.99939 142.843 6.09513 141.244 6.16351L139.644 6.2319L139.06 6.77896C138.337 7.4628 138.1 8.00987 138.1 8.93988C138.1 9.35019 138.059 9.97931 138.003 10.3349L137.92 10.9914L132.899 10.923C130.131 10.8683 127.794 10.8683 127.697 10.9093C127.349 11.0461 127.043 11.8941 126.278 14.7798L125.513 17.7203L122.314 17.8024C120.562 17.8571 110.882 17.9392 100.812 17.9939L82.5088 18.0896L82.0498 16.9681C81.4518 15.5047 80.9511 15.0123 79.7132 14.6431C77.6687 14.055 73.8022 13.8909 72.7173 14.3559C72.3835 14.4926 71.8411 14.6567 71.5212 14.7115L70.951 14.7935L70.8675 15.8466C70.8258 16.421 70.7562 17.6383 70.7145 18.5409C70.3946 25.475 70.033 30.4534 69.3932 36.6215C69.1011 39.3979 68.976 41.1622 69.0038 42.3658L69.0455 44.1164L69.6992 44.2121C70.0608 44.2532 70.5198 44.431 70.7284 44.5814C71.2152 44.9643 71.9663 45.0874 72.2722 44.8549C72.3974 44.7455 72.7034 44.2258 72.9538 43.7061C74.3863 40.6425 75.3321 36.7446 76.2779 30.0294C76.5421 28.0736 76.8342 26.3367 76.9037 26.1589C77.0706 25.7759 78.0025 24.6681 78.2111 24.586C78.4893 24.4903 123.844 24.7228 124.081 24.8322C124.22 24.8869 124.623 25.3383 124.971 25.8443C125.333 26.3367 126.181 27.4445 126.876 28.2788L128.128 29.8242H130.646C133.678 29.8242 134.79 29.961 135.221 30.3713C135.402 30.5354 135.973 30.8089 136.515 30.9731C137.043 31.1372 137.725 31.4381 138.031 31.6295C139.63 32.6279 140.84 34.9393 140.451 36.2933C140.242 37.0592 138.824 39.2612 134.067 46.1679C131.633 49.7238 129.547 52.7874 129.463 52.9926C129.324 53.2935 129.324 53.4302 129.505 53.7995C129.908 54.6064 130.896 55.5364 132.384 56.5075C133.914 57.5059 141.967 61.5542 142.426 61.5542C142.829 61.5542 143.107 60.8567 143.107 59.8446C143.107 59.3249 143.219 58.6274 143.372 58.1624C143.956 56.4528 149.074 45.8807 149.714 45.0464C150.048 44.6361 150.131 44.5951 150.854 44.5951C151.647 44.5951 152.454 44.9096 153.817 45.7576C154.359 46.0995 154.401 46.0995 157.322 46.0995C158.949 46.0858 161.077 46.0311 162.037 45.9764C164.109 45.8533 164.902 45.5251 165.528 44.554C165.862 44.0343 168.129 38.9329 168.56 37.743C168.727 37.2917 168.81 37.237 169.366 37.1549C170.368 37.0182 170.743 37.0592 170.841 37.2917C170.882 37.4011 170.827 38.126 170.716 38.8919C170.465 40.4784 170.521 40.9434 170.994 41.1485C171.258 41.2716 171.355 41.2443 171.55 41.0391C171.856 40.7109 172.412 38.9739 172.607 37.7157C172.704 37.1823 172.816 36.6763 172.871 36.6215C173.024 36.4574 174.666 36.6763 174.888 36.8951C174.999 36.9908 175.458 38.2628 175.931 39.7125C177.378 44.1848 179.617 50.7086 180.59 53.2114C183.873 61.7867 188.616 70.6629 191.342 73.3845C191.675 73.7265 192.051 74 192.176 74C192.315 74 192.885 73.7401 193.456 73.4393C194.763 72.7281 199.144 69.897 199.464 69.5414C199.687 69.2952 199.673 69.2405 199.283 68.4883C199.061 68.0506 198.421 66.9702 197.879 66.0949C194.318 60.378 192.148 56.1656 189.909 50.6128C188.226 46.4688 186.029 39.3979 185.305 35.8967L185.055 34.6384L185.389 33.6811C185.695 32.8194 185.709 32.669 185.542 32.1356C185.445 31.8073 185.222 31.3423 185.055 31.1235C184.791 30.7542 184.763 30.5628 184.791 29.1677C184.833 27.3898 184.999 26.8837 185.792 26.282C186.237 25.94 187.086 25.4477 187.239 25.4477C187.267 25.4477 187.336 26.4734 187.378 27.7317C187.447 29.9473 187.586 30.7269 187.934 30.9457C188.226 31.1235 189.186 31.0688 193.011 30.6448C202.051 29.6327 227.489 26.5418 229.729 26.1999C231.161 25.9674 231.259 25.94 232.01 25.3383C232.524 24.9416 232.538 24.9416 234.791 24.8596L237.058 24.7912L237.434 24.3672L237.823 23.9432L239.868 23.9296C241.008 23.9296 242.914 23.8749 244.124 23.8201C246.961 23.6971 246.919 23.7244 246.975 21.6182C247.031 20.1821 247.017 20.1138 246.683 19.7855C246.294 19.4026 245.779 19.3479 240.967 19.2248C239.284 19.1837 237.796 19.0743 237.656 19.0059C237.253 18.7871 237.323 17.8845 237.796 17.2827C238.157 16.7903 238.171 16.7493 238.171 14.8619C238.171 12.8514 238.074 12.4411 237.406 11.7026C237.211 11.4838 237.142 11.0598 237.072 9.71946C236.947 7.55854 236.683 6.39602 236.071 5.38394C235.292 4.112 235.195 4.0573 233.957 4.00259C233.373 3.98891 232.775 4.02994 232.649 4.112ZM156.654 38.7414C156.765 40.7656 157.002 41.6272 157.739 42.8581C158.059 43.3642 158.268 43.8155 158.226 43.8702C158.17 43.9112 157.391 43.8976 156.473 43.8155C154.818 43.6924 154.804 43.6787 153.678 43.0222C152.078 42.0649 151.592 41.6409 151.592 41.2032C151.592 41.0118 152.009 39.9997 152.523 38.9603L153.441 37.0729H156.557L156.654 38.7414ZM166.321 37.1549C166.557 37.2096 166.752 37.3054 166.752 37.3874C166.752 37.6063 165.25 41.258 164.777 42.2016C164.081 43.5693 163.845 43.7334 162.524 43.8292C161.912 43.8839 161.063 43.8702 160.66 43.8155L159.937 43.7061L159.297 42.2016C158.949 41.3674 158.629 40.3826 158.587 39.9997C158.407 38.4406 158.852 37.4285 159.798 37.2096C160.382 37.0866 165.695 37.0318 166.321 37.1549Z",
        fill: "#37311A"
      })
    })
  }), /* @__PURE__ */ jsxs("defs", {
    children: [/* @__PURE__ */ jsxs("filter", {
      id: "filter0_d_274_14096",
      x: 62,
      y: -3,
      width: 192,
      height: 84,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {}), /* @__PURE__ */ jsx("feGaussianBlur", {
        stdDeviation: 3.5
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_274_14096"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_274_14096",
        result: "shape"
      })]
    }), /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_14096",
      children: /* @__PURE__ */ jsx("rect", {
        width: 316,
        height: 78,
        fill: "white"
      })
    })]
  })]
}));
const Memo$N = memo(Image_firearmIcon$2);
const LineIcon$1 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 1 265",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0V265",
    stroke: "#C8AB46"
  })
}));
const Memo$M = memo(LineIcon$1);
const Textline___vgap9_Icon2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 350 93",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M0 1H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 10H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 19H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 28H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 37H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 46H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 55H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 64H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 73H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 82H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 91H350",
    stroke: "#E4CB71"
  })]
}));
const Memo$L = memo(Textline___vgap9_Icon2);
const Textline___vgap9_Icon3 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_274_14107)",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 1H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 10H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 19H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 28H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 37H153",
      stroke: "#E4CB71"
    })]
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_14107",
      children: /* @__PURE__ */ jsx("rect", {
        width: 153,
        height: 38,
        fill: "white"
      })
    })
  })]
}));
const Memo$K = memo(Textline___vgap9_Icon3);
const Textline___vgap9_Icon4 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_274_14117)",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 1H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 10H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 19H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 28H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 37H153",
      stroke: "#E4CB71"
    })]
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_14117",
      children: /* @__PURE__ */ jsx("rect", {
        width: 153,
        height: 38,
        fill: "white"
      })
    })
  })]
}));
const Memo$J = memo(Textline___vgap9_Icon4);
const Textline___vgap9_Icon5 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_274_14127)",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 1H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 10H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 19H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 28H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 37H153",
      stroke: "#E4CB71"
    })]
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_14127",
      children: /* @__PURE__ */ jsx("rect", {
        width: 153,
        height: 38,
        fill: "white"
      })
    })
  })]
}));
const Memo$I = memo(Textline___vgap9_Icon5);
const Textline___vgap9_Icon6 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 153 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsxs("g", {
    clipPath: "url(#clip0_274_14137)",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 1H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 10H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 19H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 28H153",
      stroke: "#E4CB71"
    }), /* @__PURE__ */ jsx("path", {
      d: "M0 37H153",
      stroke: "#E4CB71"
    })]
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsx("clipPath", {
      id: "clip0_274_14137",
      children: /* @__PURE__ */ jsx("rect", {
        width: 153,
        height: 38,
        fill: "white"
      })
    })
  })]
}));
const Memo$H = memo(Textline___vgap9_Icon6);
const Textline___vgap9_Icon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 350 93",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M0 1H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 10H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 19H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 28H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 37H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 46H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 55H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 64H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 73H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 82H350",
    stroke: "#E4CB71"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 91H350",
    stroke: "#E4CB71"
  })]
}));
const Memo$G = memo(Textline___vgap9_Icon);
const Vector129Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 1 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0V46.5",
    stroke: "#C8AB46"
  })
}));
const Memo$F = memo(Vector129Icon);
const AgentDetailOverview = memo(function AgentDetailOverview2(props = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa;
  const {
    agent
  } = props;
  const exp_min = 0;
  const exp_max = (_a = agent == null ? void 0 : agent.exp_cap) != null ? _a : 100;
  const exp_cur = (_b = agent == null ? void 0 : agent.level.exp) != null ? _b : 0;
  const exp_ratio = (exp_cur - exp_min) / (exp_max - exp_min);
  const graph_width = 300;
  const graph_right = Math.round(graph_width - graph_width * exp_ratio);
  const expProgressStyle = {
    right: graph_right
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${props.className || ""} ${classes_detailoverview.root}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.contributionInfo,
      children: [((_c = props.text) == null ? void 0 : _c.ptContribution) != null ? (_d = props.text) == null ? void 0 : _d.ptContribution : /* @__PURE__ */ jsx("div", {
        className: classes_detailoverview.ptContribution,
        children: "$ 700,000"
      }), /* @__PURE__ */ jsx(ItemTitle, {
        className: classes_detailoverview.itemTitle,
        swap: {
          bg: /* @__PURE__ */ jsx(Memo$Q, {
            className: classes_detailoverview.icon
          })
        },
        text: {
          title___BOLD4_: /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.title___BOLD4_,
            children: "\uAE30\uC5EC"
          })
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.resultsInfo,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes_detailoverview.result_Damage,
        children: [/* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.resultBar,
          children: [/* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.bar,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.positiveBar,
              style: {
                width: (_e = props.graphWidthDamageDone) != null ? _e : 0
              },
              children: /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.rectangle2
              })
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.negativeBar,
              children: /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.rectangle3
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.negativeValue___HGAP9,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.text_Type___BOLD3,
              children: "\uBC1B\uC740 \uD53C\uD574"
            }), ((_f = props.text) == null ? void 0 : _f.ptResultDamageTaken) != null ? (_g = props.text) == null ? void 0 : _g.ptResultDamageTaken : /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptResultDamageTaken,
              children: "8350"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.positiveValue___HGAP9_,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.text_Type___BOLD32,
              children: "\uC900 \uD53C\uD574"
            }), ((_h = props.text) == null ? void 0 : _h.ptResultDamageDone) != null ? (_i = props.text) == null ? void 0 : _i.ptResultDamageDone : /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptResultDamageDone,
              children: "12470"
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.itemTitle___HGAP2_,
          children: [/* @__PURE__ */ jsx(Icon_Result_Property1Damage, {}), /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.text_ResultType___BOLD4,
            children: "\uD53C\uD574"
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: classes_detailoverview.result_Mission,
        children: [/* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.resultBar2,
          children: [/* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.bar2,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.positiveBar2,
              style: {
                width: (_j = props.graphWidthWin) != null ? _j : 0
              },
              children: /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.rectangle4
              })
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.negativeBar2,
              children: /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.rectangle5
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.negativeValue___HGAP9_,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.text_Type___BOLD33,
              children: "\uC2E4\uD328"
            }), ((_k = props.text) == null ? void 0 : _k.ptResultMissionLose) != null ? (_l = props.text) == null ? void 0 : _l.ptResultMissionLose : /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptResultMissionLose,
              children: "0"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.positiveValue___HGAP9_2,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.text_Type___BOLD34,
              children: "\uC131\uACF5"
            }), ((_m = props.text) == null ? void 0 : _m.ptResultMissionWin) != null ? (_n = props.text) == null ? void 0 : _n.ptResultMissionWin : /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptResultMissionWin,
              children: "26"
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.itemTitle___HGAP2_2,
          children: [/* @__PURE__ */ jsx(Icon_Result_Property1Mission, {}), /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.text_ResultType___BOLD42,
            children: "\uC784\uBB34"
          })]
        })]
      }), /* @__PURE__ */ jsx(ItemTitle, {
        className: classes_detailoverview.itemTitle2,
        swap: {
          bg: /* @__PURE__ */ jsx(Memo$V, {
            className: classes_detailoverview.icon2
          })
        },
        text: {
          title___BOLD4_: /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.title___BOLD4_2,
            children: "\uD1B5\uACC4"
          })
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.modifierInfo,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes_detailoverview.textLine___VGAP9_,
        children: /* @__PURE__ */ jsx(Memo$G, {
          className: classes_detailoverview.icon13
        })
      }), !!((_o = agent == null ? void 0 : agent.modifier) == null ? void 0 : _o.length) ? /* @__PURE__ */ jsx(ContentArea_varDefault, {
        className: classes_detailoverview.cContentAreaTraits,
        tooltipHandlers: props.tooltipHandlers,
        ty: "modifier",
        items: agent.modifier
      }) : /* @__PURE__ */ jsx(ContentArea_varNoData, {}), /* @__PURE__ */ jsx(ItemTitle, {
        className: classes_detailoverview.itemTitle3,
        swap: {
          bg: /* @__PURE__ */ jsx(Memo$U, {
            className: classes_detailoverview.icon3
          })
        },
        text: {
          title___BOLD4_: /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.title___BOLD4_3,
            children: "\uC0C1\uD0DC \uBCC0\uD654"
          })
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.traitsInfo,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes_detailoverview.textLine___VGAP9_2,
        children: /* @__PURE__ */ jsx(Memo$L, {
          className: classes_detailoverview.icon14
        })
      }), !!((_p = agent == null ? void 0 : agent.traits) == null ? void 0 : _p.length) ? /* @__PURE__ */ jsx(ContentArea_varDefault, {
        className: classes_detailoverview.cContentAreaTraits,
        tooltipHandlers: props.tooltipHandlers,
        ty: "trait",
        items: agent.traits
      }) : /* @__PURE__ */ jsx(ContentArea_varNoData, {}), /* @__PURE__ */ jsx(ItemTitle, {
        className: classes_detailoverview.itemTitle4,
        swap: {
          bg: /* @__PURE__ */ jsx(Memo$T, {
            className: classes_detailoverview.icon4
          })
        },
        text: {
          title___BOLD4_: /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.title___BOLD4_4,
            children: "\uD2B9\uC131"
          })
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.equipmentInfo,
      children: [/* @__PURE__ */ jsx(Button_Equipments_varFoldnessF, {
        onClick: props.onAgentEquipPopupThrowable2,
        className: classes_detailoverview.cDropThrowableSlotB,
        swap: {
          icon_Equipment: props.throwableUnlocked2 ? /* @__PURE__ */ jsx(Icon_Equipment_Property1Grenad, {
            className: classes_detailoverview.icon_Equipment2
          }) : /* @__PURE__ */ jsx(Icon_Equipment_Property1Locked, {
            className: classes_detailoverview.icon_Equipment
          })
        },
        hide: {
          line: !props.throwableUnlocked2,
          firearm_Grade: true,
          firearm_Type: true
        },
        text: {
          ptDropFirearmName: props.throwableUnlocked2 ? /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.ptDropFirearmName2,
            children: (_q = props.text) == null ? void 0 : _q.ptDropFirearmName4
          }) : /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.ptDropFirearmName,
            children: "\uC7A0\uAE40"
          })
        }
      }), /* @__PURE__ */ jsx(Button_Equipments_varFoldnessF, {
        onClick: props.onAgentEquipPopupThrowable1,
        className: classes_detailoverview.cDropThrowableSlotA,
        swap: {
          icon_Equipment: props.throwableUnlocked1 ? /* @__PURE__ */ jsx(Icon_Equipment_Property1Grenad, {
            className: classes_detailoverview.icon_Equipment2
          }) : /* @__PURE__ */ jsx(Icon_Equipment_Property1Locked, {
            className: classes_detailoverview.icon_Equipment
          })
        },
        hide: {
          line: !props.throwableUnlocked1,
          firearm_Grade: true,
          firearm_Type: true
        },
        text: {
          ptDropFirearmName: props.throwableUnlocked1 ? /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.ptDropFirearmName2,
            children: (_r = props.text) == null ? void 0 : _r.ptDropFirearmName
          }) : /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.ptDropFirearmName,
            children: "\uC7A0\uAE40"
          })
        }
      }), /* @__PURE__ */ jsx(Button_Equipments_varFoldnessF, {
        onClick: props.onAgentEquipPopupEquipment,
        className: classes_detailoverview.cDropVest,
        swap: {
          icon_Equipment: /* @__PURE__ */ jsx(Icon_Equipment_Property1Bullet, {
            className: classes_detailoverview.icon_Equipment3
          })
        },
        hide: {
          firearm_Grade: true,
          firearm_Type: true
        },
        text: {
          ptDropFirearmName: ((_s = props.text) == null ? void 0 : _s.ptDropFirearmName2) || /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.ptDropFirearmName3,
            children: "Bullet Proof"
          }),
          ptDropFirearmStatCurr: (_t = props.text) == null ? void 0 : _t.ptDropFirearmStatCurr3,
          ptDropFirearmStatMax: (_u = props.text) == null ? void 0 : _u.ptDropFirearmStatMax3
        }
      }), /* @__PURE__ */ jsxs("div", {
        className: classes_detailoverview.firearmInfo,
        children: [/* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.firearmView,
          children: [/* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.bg,
            children: /* @__PURE__ */ jsx(Memo$S, {
              className: classes_detailoverview.icon15
            })
          }), /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.image_Firearm,
            children: ((_v = props.swap) == null ? void 0 : _v.image_Firearm) || /* @__PURE__ */ jsx(Memo$N, {
              className: classes_detailoverview.icon16
            })
          })]
        }), /* @__PURE__ */ jsx(Button_Equipments_varFoldnessF, {
          onClick: props.onAgentEquipPopupFirearm,
          className: classes_detailoverview.cDropFirearm,
          text: {
            ptDropFirearmRate: (_w = props.text) == null ? void 0 : _w.ptDropFirearmRate,
            ptDropFirearmType: (_x = props.text) == null ? void 0 : _x.ptDropFirearmType,
            ptDropFirearmName: (_y = props.text) == null ? void 0 : _y.ptDropFirearmName3,
            ptDropFirearmStatCurr: (_z = props.text) == null ? void 0 : _z.ptDropFirearmStatCurr4,
            ptDropFirearmStatMax: (_A = props.text) == null ? void 0 : _A.ptDropFirearmStatMax4
          }
        })]
      }), /* @__PURE__ */ jsx(ItemTitle, {
        className: classes_detailoverview.itemTitle5,
        swap: {
          bg: /* @__PURE__ */ jsx(Memo$R, {
            className: classes_detailoverview.icon5
          })
        },
        text: {
          title___BOLD4_: /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.title___BOLD4_5,
            children: "\uC7A5\uBE44"
          })
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes_detailoverview.baseInfo___HGAP12_,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes_detailoverview.profile,
        children: [/* @__PURE__ */ jsx(ItemBox, {
          className: classes_detailoverview.profileItem_Age,
          swap: {
            textLine___VGAP9_: ((_B = props.swap) == null ? void 0 : _B.textLine___VGAP9_) || /* @__PURE__ */ jsx(Memo$K, {
              className: classes_detailoverview.icon6
            })
          },
          text: {
            ptItemText: ((_C = props.text) == null ? void 0 : _C.ptItemText) || /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptItemText,
              children: "26"
            }),
            title___BOLD4_: /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.title___BOLD4_6,
              children: "\uB098\uC774"
            })
          }
        }), /* @__PURE__ */ jsx(ItemBox, {
          tooltipHandlers: props.tooltipHandlers,
          ty: "background",
          k: agent == null ? void 0 : agent.background.key,
          className: classes_detailoverview.profileItem_Background,
          swap: {
            textLine___VGAP9_: ((_D = props.swap) == null ? void 0 : _D.textLine___VGAP9_2) || /* @__PURE__ */ jsx(Memo$J, {
              className: classes_detailoverview.icon7
            })
          },
          text: {
            ptItemText: ((_E = props.text) == null ? void 0 : _E.ptItemText2) || /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptItemText2,
              children: "Soccer Player"
            }),
            title___BOLD4_: /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.title___BOLD4_7,
              children: "\uBC30\uACBD"
            })
          }
        }), /* @__PURE__ */ jsx(ItemBox, {
          className: classes_detailoverview.profileItem_Language,
          swap: {
            textLine___VGAP9_: ((_F = props.swap) == null ? void 0 : _F.textLine___VGAP9_3) || /* @__PURE__ */ jsx(Memo$I, {
              className: classes_detailoverview.icon8
            })
          },
          text: {
            ptItemText: ((_G = props.text) == null ? void 0 : _G.ptItemText3) || /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.ptItemText3,
              children: "English"
            }),
            title___BOLD4_: /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.title___BOLD4_8,
              children: "\uC5B8\uC5B4"
            })
          }
        }), /* @__PURE__ */ jsx(ItemBox, {
          className: classes_detailoverview.profileItem_Nation,
          swap: {
            textLine___VGAP9_: ((_H = props.swap) == null ? void 0 : _H.textLine___VGAP9_4) || /* @__PURE__ */ jsx(Memo$H, {
              className: classes_detailoverview.icon9
            })
          },
          text: {
            ptItemText: (_I = props.text) == null ? void 0 : _I.ptNation
          }
        }), /* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.agentPortrait,
          children: [/* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.bg5
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.portrait,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.frame
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.image_Portrait,
              children: props.portrait
            })]
          })]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: classes_detailoverview.line,
        children: /* @__PURE__ */ jsx(Memo$M, {
          className: classes_detailoverview.icon17
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: classes_detailoverview.levelGrade,
        children: [/* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.grade___HGAP13_,
          children: [/* @__PURE__ */ jsx(StatGrade, {
            text: {
              ptGradeName: (_J = props.text) == null ? void 0 : _J.ptGradeName,
              ptGradeValue: (_K = props.text) == null ? void 0 : _K.ptGradeValue
            }
          }), /* @__PURE__ */ jsx("div", {
            className: classes_detailoverview.vector129,
            children: /* @__PURE__ */ jsx(Memo$F, {
              className: classes_detailoverview.icon18
            })
          }), /* @__PURE__ */ jsx(StatGrade, {
            text: {
              ptGradeName: ((_L = props.text) == null ? void 0 : _L.ptGradeName2) || /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.ptGradeName,
                children: "\uC131\uC7A5\uC131"
              }),
              ptGradeValue: ((_M = props.text) == null ? void 0 : _M.ptGradeValue2) || /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.ptGradeValue,
                children: "D"
              })
            }
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.stat,
          children: [/* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.body___VGAP11_,
            children: [/* @__PURE__ */ jsx(AgentCardItem___HGAP14_, {
              className: classes_detailoverview.cLife___HGAP14_,
              swap: {
                dotLine: ((_N = props.swap) == null ? void 0 : _N.dotLine) || /* @__PURE__ */ jsx(Memo$O, {
                  className: classes_detailoverview.icon10
                })
              },
              text: {
                title___BOLD4: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.title___BOLD4,
                  children: "\uC0DD\uBA85\uB825"
                }),
                ptValue: ((_O = props.text) == null ? void 0 : _O.ptValue) || /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.ptValue,
                  children: "76"
                }),
                ptMax: (_P = props.text) == null ? void 0 : _P.ptMax
              }
            }), /* @__PURE__ */ jsx(AgentCardItem___HGAP14_, {
              className: classes_detailoverview.cOverall___HGAP14_,
              swap: {
                dotLine: ((_Q = props.swap) == null ? void 0 : _Q.dotLine2) || /* @__PURE__ */ jsx(Memo$P, {
                  className: classes_detailoverview.icon11
                })
              },
              text: {
                title___BOLD4: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.title___BOLD42,
                  children: "\uC804\uD22C\uB825"
                }),
                ptValue: ((_R = props.text) == null ? void 0 : _R.ptValue2) || /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.ptValue2,
                  children: "6.5"
                }),
                ptMax: ((_S = props.text) == null ? void 0 : _S.ptMax2) || /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.ptMax,
                  children: "/8"
                })
              }
            }), /* @__PURE__ */ jsx(AgentCardItem___HGAP14_, {
              className: classes_detailoverview.cOverall___HGAP14_,
              swap: {
                dotLine: ((_T = props.swap) == null ? void 0 : _T.dotLine2) || /* @__PURE__ */ jsx(Memo$P, {
                  className: classes_detailoverview.icon11
                })
              },
              text: {
                title___BOLD4: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.title___BOLD42,
                  children: "\uBB34\uAE30\uC801\uC131"
                }),
                ptValue: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.ptValue2,
                  children: agent == null ? void 0 : agent.vocation
                }),
                ptMax: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.ptMax
                })
              }
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.head___VGAP5_,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.grade___BOLD4,
              children: "\uB4F1\uAE09"
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.grade,
              children: ((_U = props.text) == null ? void 0 : _U.ptGrade) != null ? (_V = props.text) == null ? void 0 : _V.ptGrade : /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.ptGrade,
                children: "D"
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.head___VGAP4_,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.level___BOLD4,
              children: "\uB4F1\uAE09"
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.grade2,
              children: ((_W = props.text) == null ? void 0 : _W.ptGrade2) != null ? (_X = props.text) == null ? void 0 : _X.ptGrade2 : /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.ptGrade2,
                children: "D"
              })
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: classes_detailoverview.level,
          children: [/* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.body,
            children: [/* @__PURE__ */ jsxs("div", {
              className: classes_detailoverview.progressBar2,
              children: [/* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.frame2
              }), /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.bg6
              }), /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.progress2,
                style: expProgressStyle
              }), /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.shadow
              })]
            }), /* @__PURE__ */ jsx(AgentCardItem___HGAP14_, {
              className: classes_detailoverview.cExp___HGAP14_,
              swap: {
                dotLine: (_Y = props.swap) == null ? void 0 : _Y.dotLine4
              },
              text: {
                title___BOLD4: /* @__PURE__ */ jsx("div", {
                  className: classes_detailoverview.title___BOLD42,
                  children: "\uACBD\uD5D8\uCE58"
                }),
                ptValue: (_Z = props.text) == null ? void 0 : _Z.ptExpValue,
                ptMax: (__ = props.text) == null ? void 0 : __.ptMax4
              }
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: classes_detailoverview.head___VGAP3_,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.level___BOLD42,
              children: "\uB808\uBCA8"
            }), /* @__PURE__ */ jsx("div", {
              className: classes_detailoverview.grade3,
              children: ((_$ = props.text) == null ? void 0 : _$.ptLevelValue) != null ? (_aa = props.text) == null ? void 0 : _aa.ptLevelValue : /* @__PURE__ */ jsx("div", {
                className: classes_detailoverview.ptLevelValue,
                children: "7"
              })
            })]
          })]
        })]
      })]
    })]
  });
});
const agentDetailOverview = "_agentDetailOverview_1eeky_1";
const icon$g = "_icon_1eeky_5";
const icon2$7 = "_icon2_1eeky_9";
const icon3$4 = "_icon3_1eeky_13";
const icon4$3 = "_icon4_1eeky_17";
const icon5$2 = "_icon5_1eeky_21";
const rectangle$2 = "_rectangle_1eeky_25";
const agentDetailTabs = "_agentDetailTabs_1eeky_28";
const agentDetailTitle = "_agentDetailTitle_1eeky_32";
const icon6$2 = "_icon6_1eeky_36";
const root$n = "_root_1eeky_40";
const deco3 = "_deco3_1eeky_48";
const icon7$2 = "_icon7_1eeky_56";
const deco2 = "_deco2_1eeky_60";
const icon8$2 = "_icon8_1eeky_68";
const deco1 = "_deco1_1eeky_72";
const paper$1 = "_paper_1eeky_82";
const classes_agentdetail = {
  agentDetailOverview,
  icon: icon$g,
  icon2: icon2$7,
  icon3: icon3$4,
  icon4: icon4$3,
  icon5: icon5$2,
  rectangle: rectangle$2,
  agentDetailTabs,
  agentDetailTitle,
  icon6: icon6$2,
  root: root$n,
  deco3,
  icon7: icon7$2,
  deco2,
  icon8: icon8$2,
  deco1,
  paper: paper$1
};
const root$m = "_root_16oav_1";
const rectangle208Stroke = "_rectangle208Stroke_16oav_9";
const icon$f = "_icon_16oav_17";
const rectangle209 = "_rectangle209_16oav_21";
const icon2$6 = "_icon2_16oav_29";
const rectangle209Stroke = "_rectangle209Stroke_16oav_33";
const icon3$3 = "_icon3_16oav_41";
const intersect = "_intersect_16oav_45";
const icon4$2 = "_icon4_16oav_53";
const classes$k = {
  root: root$m,
  rectangle208Stroke,
  icon: icon$f,
  rectangle209,
  icon2: icon2$6,
  rectangle209Stroke,
  icon3: icon3$3,
  intersect,
  icon4: icon4$2
};
const IntersectIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M15 3.03047V0H11.9696L7.50001 4.46954L3.03047 0H0V3.03045L4.46955 7.5L0 11.9696V15H3.03047L7.50001 10.5305L11.9696 15H15V11.9695L10.5305 7.5L15 3.03047Z",
    fill: "#F0BB89"
  })
}));
const Memo$E = memo(IntersectIcon);
const Rectangle208StrokeIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0H24C26.7614 0 29 2.23858 29 5V24C29 26.7614 26.7614 29 24 29H5C2.23857 29 0 26.7614 0 24V5C0 2.23857 2.23858 0 5 0ZM5 1C2.79086 1 1 2.79086 1 5V24C1 26.2091 2.79086 28 5 28H24C26.2091 28 28 26.2091 28 24V5C28 2.79086 26.2091 1 24 1H5Z",
    fill: "#C5A85F"
  })
}));
const Memo$D = memo(Rectangle208StrokeIcon);
const Rectangle209Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H23C25.2091 0 27 1.79086 27 4V23C27 25.2091 25.2091 27 23 27H4C1.79086 27 0 25.2091 0 23V4Z",
    fill: "#BD6742"
  })
}));
const Memo$C = memo(Rectangle209Icon);
const Rectangle209StrokeIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 1H4C2.34315 1 1 2.34315 1 4V23C1 24.6569 2.34315 26 4 26H23C24.6569 26 26 24.6569 26 23V4C26 2.34315 24.6569 1 23 1ZM4 0C1.79086 0 0 1.79086 0 4V23C0 25.2091 1.79086 27 4 27H23C25.2091 27 27 25.2091 27 23V4C27 1.79086 25.2091 0 23 0H4Z",
    fill: "#A04F2B"
  })
}));
const Memo$B = memo(Rectangle209StrokeIcon);
const Button_Close_Property1Default = memo(function Button_Close_Property1Default2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$k.root}`,
    onClick: props.onClick,
    style: {
      opacity: props.onClick ? 1 : 0.3
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$k.rectangle208Stroke,
      children: /* @__PURE__ */ jsx(Memo$D, {
        className: classes$k.icon
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$k.rectangle209,
      children: /* @__PURE__ */ jsx(Memo$C, {
        className: classes$k.icon2
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$k.rectangle209Stroke,
      children: /* @__PURE__ */ jsx(Memo$B, {
        className: classes$k.icon3
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$k.intersect,
      children: /* @__PURE__ */ jsx(Memo$E, {
        className: classes$k.icon4
      })
    })]
  });
});
const union$3 = "_union_14egh_1";
const throwable_Info$1 = "_throwable_Info_14egh_5";
const throwable_Info2$1 = "_throwable_Info2_14egh_9";
const bulletProof_Info$1 = "_bulletProof_Info_14egh_13";
const firearm_Info$1 = "_firearm_Info_14egh_17";
const icon$e = "_icon_14egh_21";
const deco_Line$1 = "_deco_Line_14egh_25";
const image_AgentPotrait$1 = "_image_AgentPotrait_14egh_29";
const rectangle$1 = "_rectangle_14egh_32";
const icon2$5 = "_icon2_14egh_35";
const aC_state$4 = "_aC_state_14egh_39";
const union2 = "_union2_14egh_43";
const throwable_Info3 = "_throwable_Info3_14egh_47";
const throwable_Info4 = "_throwable_Info4_14egh_51";
const bulletProof_Info2 = "_bulletProof_Info2_14egh_55";
const firearm_Info2 = "_firearm_Info2_14egh_59";
const icon3$2 = "_icon3_14egh_63";
const deco_Line2 = "_deco_Line2_14egh_67";
const image_AgentPotrait2 = "_image_AgentPotrait2_14egh_71";
const rectangle2 = "_rectangle2_14egh_74";
const icon4$1 = "_icon4_14egh_77";
const union3 = "_union3_14egh_81";
const throwable_Info5 = "_throwable_Info5_14egh_85";
const throwable_Info6 = "_throwable_Info6_14egh_89";
const bulletProof_Info3 = "_bulletProof_Info3_14egh_93";
const firearm_Info3 = "_firearm_Info3_14egh_97";
const icon5$1 = "_icon5_14egh_101";
const deco_Line3 = "_deco_Line3_14egh_105";
const image_AgentPotrait3 = "_image_AgentPotrait3_14egh_109";
const rectangle3 = "_rectangle3_14egh_112";
const icon6$1 = "_icon6_14egh_115";
const button_Dropdown_Rearrange = "_button_Dropdown_Rearrange_14egh_119";
const button_Close = "_button_Close_14egh_123";
const root$l = "_root_14egh_128";
const agentList = "_agentList_14egh_136";
const paper = "_paper_14egh_144";
const icon7$1 = "_icon7_14egh_152";
const list = "_list_14egh_156";
const bg$4 = "_bg_14egh_164";
const icon8$1 = "_icon8_14egh_172";
const scrollBar = "_scrollBar_14egh_176";
const bg2$1 = "_bg2_14egh_185";
const scrollBar2 = "_scrollBar2_14egh_195";
const aL___HGAP7___VGAP7___WRAP = "_aL___HGAP7___VGAP7___WRAP_14egh_204";
const ScrollShadow___PEN = "_ScrollShadow___PEN_14egh_219";
const rectangle184 = "_rectangle184_14egh_228";
const rectangle185 = "_rectangle185_14egh_237";
const headInfo = "_headInfo_14egh_246";
const bg3$1 = "_bg3_14egh_258";
const icon9$1 = "_icon9_14egh_266";
const headInfo___HGAP16 = "_headInfo___HGAP16_14egh_270";
const totalAgent___HGAP7 = "_totalAgent___HGAP7_14egh_279";
const total___BOLD4 = "_total___BOLD4_14egh_285";
const ptTotalValue = "_ptTotalValue_14egh_296";
const line$1 = "_line_14egh_307";
const icon10$1 = "_icon10_14egh_312";
const currentFilter___HGAP7 = "_currentFilter___HGAP7_14egh_316";
const icon11$1 = "_icon11_14egh_322";
const icon12$1 = "_icon12_14egh_327";
const currentFilter___BOLD4 = "_currentFilter___BOLD4_14egh_331";
const filterType___BOLD6 = "_filterType___BOLD6_14egh_342";
const titleGroup = "_titleGroup_14egh_353";
const bg_File = "_bg_File_14egh_361";
const bg_File2 = "_bg_File2_14egh_369";
const icon13$1 = "_icon13_14egh_377";
const bg_File1 = "_bg_File1_14egh_381";
const icon14$1 = "_icon14_14egh_389";
const title = "_title_14egh_353";
const bg_Sticker = "_bg_Sticker_14egh_401";
const icon15$1 = "_icon15_14egh_409";
const deco_Clip = "_deco_Clip_14egh_413";
const icon16 = "_icon16_14egh_421";
const popupTitleArea = "_popupTitleArea_14egh_425";
const popupTitle = "_popupTitle_14egh_425";
const bgArea = "_bgArea_14egh_443";
const bg4 = "_bg4_14egh_452";
const title___BOLD4___PR = "_title___BOLD4___PR_14egh_462";
const classes$j = {
  union: union$3,
  throwable_Info: throwable_Info$1,
  throwable_Info2: throwable_Info2$1,
  bulletProof_Info: bulletProof_Info$1,
  firearm_Info: firearm_Info$1,
  icon: icon$e,
  deco_Line: deco_Line$1,
  image_AgentPotrait: image_AgentPotrait$1,
  rectangle: rectangle$1,
  icon2: icon2$5,
  aC_state: aC_state$4,
  union2,
  throwable_Info3,
  throwable_Info4,
  bulletProof_Info2,
  firearm_Info2,
  icon3: icon3$2,
  deco_Line2,
  image_AgentPotrait2,
  rectangle2,
  icon4: icon4$1,
  union3,
  throwable_Info5,
  throwable_Info6,
  bulletProof_Info3,
  firearm_Info3,
  icon5: icon5$1,
  deco_Line3,
  image_AgentPotrait3,
  rectangle3,
  icon6: icon6$1,
  button_Dropdown_Rearrange,
  button_Close,
  root: root$l,
  agentList,
  paper,
  icon7: icon7$1,
  list,
  bg: bg$4,
  icon8: icon8$1,
  scrollBar,
  bg2: bg2$1,
  scrollBar2,
  aL___HGAP7___VGAP7___WRAP,
  ScrollShadow___PEN,
  rectangle184,
  rectangle185,
  headInfo,
  bg3: bg3$1,
  icon9: icon9$1,
  headInfo___HGAP16,
  totalAgent___HGAP7,
  total___BOLD4,
  ptTotalValue,
  line: line$1,
  icon10: icon10$1,
  currentFilter___HGAP7,
  icon11: icon11$1,
  icon12: icon12$1,
  currentFilter___BOLD4,
  filterType___BOLD6,
  titleGroup,
  bg_File,
  bg_File2,
  icon13: icon13$1,
  bg_File1,
  icon14: icon14$1,
  title,
  bg_Sticker,
  icon15: icon15$1,
  deco_Clip,
  icon16,
  popupTitleArea,
  popupTitle,
  bgArea,
  bg4,
  title___BOLD4___PR
};
const Bg_file1Icon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 530 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M498 3C503.845 3 504.098 3.13279 507.5 7.76L522.5 28.16C524.594 30.8164 525.906 31.6432 528.5 32V37H496.5V3H498Z",
    fill: "#BC7F08"
  }), /* @__PURE__ */ jsx("path", {
    d: "M15 3H496.5V37H15V3Z",
    fill: "#BC7F08"
  }), /* @__PURE__ */ jsx("path", {
    d: "M3 13V37H15V3H14C14 3 14 3 14 3C6.49999 3 3 7.5 3 13Z",
    fill: "#BC7F08"
  })]
}));
const Memo$A = memo(Bg_file1Icon);
const Bg_file2Icon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 530 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.091 26.9478C525.08 28.2003 525.762 28.8566 526.388 29.2565C526.979 29.6334 527.649 29.8642 528.772 30.0187L530.5 30.2563V32H494.5V1.00001L498.129 1.00001C500.81 0.999791 502.854 0.999626 504.563 1.85718C506.274 2.71561 507.47 4.34271 509.022 6.45383C509.052 6.49412 509.081 6.53459 509.111 6.57523L524.091 26.9478Z",
    fill: "#D69A27"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498 1H13V37H498V1Z",
    fill: "#D69A27"
  }), /* @__PURE__ */ jsx("path", {
    d: "M1 13V37H17V1H14C9.84295 1 6.53992 2.25665 4.27328 4.52329C2.0153 6.78128 1 9.82822 1 13Z",
    fill: "#D69A27"
  })]
}));
const Memo$z = memo(Bg_file2Icon);
const Bg_stickerIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 481 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M0 4.76837e-07H481V32C481 35.3137 478.314 38 475 38H5.99999C2.68629 38 0 35.3137 0 32V4.76837e-07Z",
    fill: "#A5652A"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 4.76837e-07H481V31C481 34.3137 478.314 37 475 37H5.99999C2.68629 37 0 34.3137 0 31V4.76837e-07Z",
    fill: "#EEE3AC"
  }), /* @__PURE__ */ jsx("path", {
    d: "M6 30H441",
    stroke: "#DCC791"
  }), /* @__PURE__ */ jsx("path", {
    d: "M6 24H441",
    stroke: "#DCC791"
  }), /* @__PURE__ */ jsx("path", {
    d: "M6 18H441",
    stroke: "#DCC791"
  }), /* @__PURE__ */ jsx("path", {
    d: "M6 12H441",
    stroke: "#DCC791"
  }), /* @__PURE__ */ jsx("path", {
    d: "M6 6H441",
    stroke: "#DCC791"
  }), /* @__PURE__ */ jsx("rect", {
    opacity: 0.4,
    y: 476837e-12,
    width: 481,
    height: 2,
    fill: "white"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 4.76837e-07H6V37V37C2.68629 37 0 34.3137 0 31V4.76837e-07Z",
    fill: "#287570"
  })]
}));
const Memo$y = memo(Bg_stickerIcon);
const BgIcon2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 475 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M0 0H475V26H0V0Z",
    fill: "#F8DF89"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 0L475 4.12973e-05",
    stroke: "#C9A957"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 26L475 26",
    stroke: "#C9A957"
  })]
}));
const Memo$x = memo(BgIcon2);
const BgIcon$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 728 848",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M0 0H728V848H0V0Z",
    fill: "#DEBF70"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728 848L-1.7484e-07 848L0 846L728 846L728 848Z",
    fill: "#BA9840"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728 2L0 1.99994L1.73878e-07 0L728 6.32936e-05L728 2Z",
    fill: "#BA9840"
  })]
}));
const Memo$w = memo(BgIcon$1);
const Deco_clipIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M9.42448 5.41123C10.5545 1.45161 14.6796 -0.841996 18.6383 0.288308C20.5431 0.832197 22.0623 2.06976 23 3.64865C22.2445 3.64865 22.2445 3.64865 21.3458 3.64865C20.5832 2.69488 19.5274 1.9606 18.264 1.59984C15.0295 0.676307 11.659 2.55034 10.7357 5.78562L1.53397 38.0287C0.867332 40.3646 2.22007 42.7988 4.55539 43.4656C6.89072 44.1324 9.32428 42.7794 9.99092 40.4435L17.8914 12.76C18.3013 11.3234 17.4694 9.82642 16.0332 9.41634C14.597 9.00626 13.1004 9.83839 12.6905 11.2749L7.39251 29.8392L6.08131 29.4648L11.3793 10.9006C11.996 8.73966 14.2472 7.48796 16.4075 8.1048C18.5679 8.72165 19.8193 10.9734 19.2026 13.1343L11.3021 40.8178C10.4288 43.8781 7.24058 45.6507 4.1811 44.7772C1.12162 43.9036 -0.650585 40.7146 0.222767 37.6543L9.42448 5.41123Z",
    fill: "#968864"
  })
}));
const Memo$v = memo(Deco_clipIcon);
const LineIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 1 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.1365e-06 26L0 0L1 4.37114e-08L0.999999 26L-1.1365e-06 26Z",
    fill: "#C9A957"
  })
}));
const Memo$u = memo(LineIcon);
const PaperIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 751 907",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M13.524 906.643V898.143L681.524 898.643L13.524 906.643Z",
    fill: "#8B443A"
  }), /* @__PURE__ */ jsx("path", {
    d: "M750.524 19.643L642.524 16.643L740.524 432.643L750.524 19.643Z",
    fill: "#12887A"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 8.34302L737.953 -6.21937e-06L748.048 892.943L10.0953 901.286L0 8.34302Z",
    fill: "#8A4C1F"
  }), /* @__PURE__ */ jsx("path", {
    d: "M5.02405 7.14297H743.024V900.143H5.02405V7.14297Z",
    fill: "#FFE99D"
  })]
}));
const Memo$t = memo(PaperIcon);
const AgentList = memo(function AgentList2(props = {}) {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes$j.root}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: classes$j.agentList,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$j.paper,
        children: /* @__PURE__ */ jsx(Memo$t, {
          className: classes$j.icon7
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$j.list,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$j.bg,
          children: /* @__PURE__ */ jsx(Memo$w, {
            className: classes$j.icon8
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$j.scrollBar,
          children: [/* @__PURE__ */ jsx("div", {
            className: classes$j.bg2
          }), /* @__PURE__ */ jsx("div", {
            className: classes$j.scrollBar2
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: classes$j.aL___HGAP7___VGAP7___WRAP,
          children: props.children
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$j.ScrollShadow___PEN,
          children: [/* @__PURE__ */ jsx("div", {
            className: classes$j.rectangle184
          }), /* @__PURE__ */ jsx("div", {
            className: classes$j.rectangle185
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$j.headInfo,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$j.bg3,
          children: /* @__PURE__ */ jsx(Memo$x, {
            className: classes$j.icon9
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$j.headInfo___HGAP16,
          children: [/* @__PURE__ */ jsxs("div", {
            className: classes$j.totalAgent___HGAP7,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes$j.total___BOLD4,
              children: "\uCD1D\uC6D0:"
            }), ((_a = props.text) == null ? void 0 : _a.ptTotalValue) != null ? (_b = props.text) == null ? void 0 : _b.ptTotalValue : /* @__PURE__ */ jsx("div", {
              className: classes$j.ptTotalValue,
              children: "30"
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: classes$j.line,
            children: /* @__PURE__ */ jsx(Memo$u, {
              className: classes$j.icon10
            })
          })]
        }), props.filter]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$j.titleGroup,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes$j.bg_File,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$j.bg_File2,
          children: /* @__PURE__ */ jsx(Memo$z, {
            className: classes$j.icon13
          })
        }), /* @__PURE__ */ jsx("div", {
          className: classes$j.bg_File1,
          children: /* @__PURE__ */ jsx(Memo$A, {
            className: classes$j.icon14
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$j.title,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$j.bg_Sticker,
          children: /* @__PURE__ */ jsx(Memo$y, {
            className: classes$j.icon15
          })
        }), /* @__PURE__ */ jsx(Button_Close_Property1Default, {
          className: classes$j.button_Close,
          onClick: props.onClickClose
        }), /* @__PURE__ */ jsx("div", {
          className: classes$j.deco_Clip,
          children: /* @__PURE__ */ jsx(Memo$v, {
            className: classes$j.icon16
          })
        }), /* @__PURE__ */ jsx("div", {
          className: classes$j.popupTitleArea,
          children: /* @__PURE__ */ jsxs("div", {
            className: classes$j.popupTitle,
            children: [/* @__PURE__ */ jsx("div", {
              className: classes$j.bgArea,
              children: /* @__PURE__ */ jsx("div", {
                className: classes$j.bg4
              })
            }), /* @__PURE__ */ jsx("div", {
              className: classes$j.title___BOLD4___PR,
              children: (_d = (_c = props.text) == null ? void 0 : _c.title) != null ? _d : "\uC694\uC6D0"
            })]
          })
        })]
      })]
    })]
  });
});
const root$k = "_root_1iqo1_1";
const bg$3 = "_bg_1iqo1_7";
const deco$1 = "_deco_1iqo1_16";
const text_TabMenu$1 = "_text_TabMenu_1iqo1_26";
const text_TabMenu___BOLD4$2 = "_text_TabMenu___BOLD4_1iqo1_34";
const classes_on = {
  root: root$k,
  bg: bg$3,
  deco: deco$1,
  text_TabMenu: text_TabMenu$1,
  text_TabMenu___BOLD4: text_TabMenu___BOLD4$2
};
const root$j = "_root_pblkb_1";
const bg$2 = "_bg_pblkb_7";
const deco = "_deco_pblkb_16";
const text_TabMenu = "_text_TabMenu_pblkb_27";
const text_TabMenu___BOLD4$1 = "_text_TabMenu___BOLD4_pblkb_35";
const classes_off = {
  root: root$j,
  bg: bg$2,
  deco,
  text_TabMenu,
  text_TabMenu___BOLD4: text_TabMenu___BOLD4$1
};
const Button_TabMenu_Property1TabOn = memo(function Button_TabMenu_Property1TabOn2(props = {}) {
  const classes2 = props.selected ? classes_on : classes_off;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes2.root}`,
    onClick: () => props.onClick && props.onClick(),
    children: [/* @__PURE__ */ jsx("div", {
      className: classes2.bg
    }), /* @__PURE__ */ jsx("div", {
      className: classes2.deco
    }), /* @__PURE__ */ jsx("div", {
      className: classes2.text_TabMenu,
      children: /* @__PURE__ */ jsx("div", {
        className: classes2.text_TabMenu___BOLD4,
        children: props.name
      })
    })]
  });
});
const text_TabMenu___BOLD4 = "_text_TabMenu___BOLD4_1gyrg_1";
const text_TabMenu___BOLD42 = "_text_TabMenu___BOLD42_1gyrg_16";
const text_TabMenu___BOLD43 = "_text_TabMenu___BOLD43_1gyrg_31";
const root$i = "_root_1gyrg_46";
const bg$1 = "_bg_1gyrg_54";
const tabButtonGroup___HGAP2_ = "_tabButtonGroup___HGAP2__1gyrg_62";
const frame188 = "_frame188_1gyrg_71";
const classes$i = {
  text_TabMenu___BOLD4,
  text_TabMenu___BOLD42,
  text_TabMenu___BOLD43,
  root: root$i,
  bg: bg$1,
  tabButtonGroup___HGAP2_,
  frame188
};
const AgentDetailTabs = memo(function AgentDetailTabs2(props) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$i.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$i.bg
    }), /* @__PURE__ */ jsx("div", {
      className: classes$i.tabButtonGroup___HGAP2_,
      children: props.tabs && props.tabs.map((tab) => {
        return /* @__PURE__ */ jsx(Button_TabMenu_Property1TabOn, {
          selected: tab === props.tab_selected,
          name: tab,
          onClick: () => props.onTabSelected && props.onTabSelected(tab)
        }, tab);
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$i.frame188
    })]
  });
});
const root$h = "_root_5ivmb_1";
const off$1 = "_off_5ivmb_9";
const icon$d = "_icon_5ivmb_17";
const classes$h = {
  root: root$h,
  off: off$1,
  icon: icon$d
};
const OffIcon$5 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_i_274_14169)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M23 21.6621V0H0V21.6621L11.5 31.6489L23 21.6621Z",
      fill: "#DFC874"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M13.048 10.8472L11.3137 6.49997L9.57942 10.8472L4.93605 11.1641L8.50755 14.1678L7.37211 18.7108L11.3137 16.22L15.2553 18.7108L14.1199 14.1678L17.6914 11.1641L13.048 10.8472Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H21V20.75L11.5 29L2 20.75V2ZM19.1372 13.25C19.1372 17.5992 15.6345 21.125 11.3137 21.125C6.99289 21.125 3.49017 17.5992 3.49017 13.25C3.49017 8.90074 6.99289 5.37498 11.3137 5.37498C15.6345 5.37498 19.1372 8.90074 19.1372 13.25Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_i_274_14169",
      x: 0,
      y: 0,
      width: 23,
      height: 31.6489,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 2
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_274_14169"
      })]
    })
  })]
}));
const Memo$s = memo(OffIcon$5);
const Button_CheckBox_Bookmark_Prope = memo(function Button_CheckBox_Bookmark_Prope2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$h.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$h.off,
      children: ((_a = props.swap) == null ? void 0 : _a.off) || /* @__PURE__ */ jsx(Memo$s, {
        className: classes$h.icon
      })
    })
  });
});
const icon$c = "_icon_17hoy_1";
const root$g = "_root_17hoy_5";
const on = "_on_17hoy_11";
const icon2$4 = "_icon2_17hoy_19";
const classes$g = {
  icon: icon$c,
  root: root$g,
  on,
  icon2: icon2$4
};
const OffIcon$4 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_i_274_13687)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M23 21.6621V0H0V21.6621L11.5 31.6489L23 21.6621Z",
      fill: "#DFC874"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M13.048 10.8472L11.3137 6.49997L9.57942 10.8472L4.93605 11.1641L8.50755 14.1678L7.37211 18.7108L11.3137 16.22L15.2553 18.7108L14.1199 14.1678L17.6914 11.1641L13.048 10.8472Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H21V20.75L11.5 29L2 20.75V2ZM19.1372 13.25C19.1372 17.5992 15.6345 21.125 11.3137 21.125C6.99289 21.125 3.49017 17.5992 3.49017 13.25C3.49017 8.90074 6.99289 5.37498 11.3137 5.37498C15.6345 5.37498 19.1372 8.90074 19.1372 13.25Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_i_274_13687",
      x: 0,
      y: 0,
      width: 23,
      height: 31.6489,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 2
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_274_13687"
      })]
    })
  })]
}));
const Memo$r = memo(OffIcon$4);
const OnIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 19 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M11.048 8.84719L9.31373 4.49997L7.57942 8.84719L2.93605 9.16411L6.50755 12.1678L5.37211 16.7108L9.31373 14.22L13.2553 16.7108L12.1199 12.1678L15.6914 9.16411L11.048 8.84719Z",
    fill: "#332715"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H19V18.75L9.5 27L0 18.75V0ZM17.1372 11.25C17.1372 15.5992 13.6345 19.125 9.3137 19.125C4.99289 19.125 1.49017 15.5992 1.49017 11.25C1.49017 6.90074 4.99289 3.37498 9.3137 3.37498C13.6345 3.37498 17.1372 6.90074 17.1372 11.25Z",
    fill: "#332715"
  })]
}));
const Memo$q = memo(OnIcon);
const Bookmark_Stauts_Property1Check = memo(function Bookmark_Stauts_Property1Check2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes$g.root}`,
    children: [/* @__PURE__ */ jsx(Button_CheckBox_Bookmark_Prope, {
      swap: {
        off: ((_a = props.swap) == null ? void 0 : _a.off) || /* @__PURE__ */ jsx(Memo$r, {
          className: classes$g.icon
        })
      }
    }), /* @__PURE__ */ jsx("div", {
      className: classes$g.on,
      children: /* @__PURE__ */ jsx(Memo$q, {
        className: classes$g.icon2
      })
    })]
  });
});
const icon$b = "_icon_1yl08_1";
const root$f = "_root_1yl08_5";
const line = "_line_1yl08_13";
const contractInfo___HGAP4_ = "_contractInfo___HGAP4__1yl08_23";
const contractInfo = "_contractInfo_1yl08_23";
const contractInfo___BOLD4___PR = "_contractInfo___BOLD4___PR_1yl08_38";
const remaining___BOLD4 = "_remaining___BOLD4_1yl08_50";
const agentName___HGAP9_ = "_agentName___HGAP9__1yl08_63";
const name = "_name_1yl08_72";
const ptAgentName = "_ptAgentName_1yl08_79";
const button_Edit = "_button_Edit_1yl08_91";
const roundedRectangle = "_roundedRectangle_1yl08_97";
const union$2 = "_union_1yl08_109";
const icon2$3 = "_icon2_1yl08_117";
const line2 = "_line2_1yl08_121";
const icon3$1 = "_icon3_1yl08_126";
const classes$f = {
  icon: icon$b,
  root: root$f,
  line,
  contractInfo___HGAP4_,
  contractInfo,
  contractInfo___BOLD4___PR,
  remaining___BOLD4,
  agentName___HGAP9_,
  name,
  ptAgentName,
  button_Edit,
  roundedRectangle,
  union: union$2,
  icon2: icon2$3,
  line2,
  icon3: icon3$1
};
const OffIcon$3 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_i_274_14003)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M23 21.6621V0H0V21.6621L11.5 31.6489L23 21.6621Z",
      fill: "#DFC874"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M13.048 10.8472L11.3137 6.49997L9.57942 10.8472L4.93605 11.1641L8.50755 14.1678L7.37211 18.7108L11.3137 16.22L15.2553 18.7108L14.1199 14.1678L17.6914 11.1641L13.048 10.8472Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H21V20.75L11.5 29L2 20.75V2ZM19.1372 13.25C19.1372 17.5992 15.6345 21.125 11.3137 21.125C6.99289 21.125 3.49017 17.5992 3.49017 13.25C3.49017 8.90074 6.99289 5.37498 11.3137 5.37498C15.6345 5.37498 19.1372 8.90074 19.1372 13.25Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_i_274_14003",
      x: 0,
      y: 0,
      width: 23,
      height: 31.6489,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 2
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_274_14003"
      })]
    })
  })]
}));
const Memo$p = memo(OffIcon$3);
const AgentDetailTitle = memo(function AgentDetailTitle2(props = {}) {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$f.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$f.line
    }), props.expiryValue ? /* @__PURE__ */ jsxs("div", {
      className: classes$f.contractInfo___HGAP4_,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$f.contractInfo,
        children: /* @__PURE__ */ jsx("div", {
          className: classes$f.contractInfo___BOLD4___PR,
          children: props.expiryLabel
        })
      }), /* @__PURE__ */ jsx("div", {
        className: classes$f.remaining___BOLD4,
        children: props.expiryValue
      })]
    }) : null, /* @__PURE__ */ jsxs("div", {
      className: classes$f.agentName___HGAP9_,
      children: [/* @__PURE__ */ jsx(Bookmark_Stauts_Property1Check, {
        swap: {
          off: ((_b = props.swap) == null ? void 0 : _b.off) || /* @__PURE__ */ jsx(Memo$p, {
            className: classes$f.icon
          })
        }
      }), /* @__PURE__ */ jsx("div", {
        className: classes$f.name,
        children: ((_c = props.text) == null ? void 0 : _c.ptAgentName) != null ? (_d = props.text) == null ? void 0 : _d.ptAgentName : /* @__PURE__ */ jsx("div", {
          className: classes$f.ptAgentName,
          children: "Rodrigo \u201CPartner\u201D Varga"
        })
      })]
    })]
  });
});
const Deco2Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 109 417",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M108.524 3.64298L0.524048 0.642981L98.524 416.643L108.524 3.64298Z",
    fill: "#12887A"
  })
}));
const Memo$o = memo(Deco2Icon);
const Deco3Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 669 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0.524048 8.64301V0.143005L668.524 0.643005L0.524048 8.64301Z",
    fill: "#8B443A"
  })
}));
const Memo$n = memo(Deco3Icon);
const OffIcon$2 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 23 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_i_274_13052)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M23 21.6621V0H0V21.6621L11.5 31.6489L23 21.6621Z",
      fill: "#DFC874"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M13.048 10.8472L11.3137 6.49997L9.57942 10.8472L4.93605 11.1641L8.50755 14.1678L7.37211 18.7108L11.3137 16.22L15.2553 18.7108L14.1199 14.1678L17.6914 11.1641L13.048 10.8472Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H21V20.75L11.5 29L2 20.75V2ZM19.1372 13.25C19.1372 17.5992 15.6345 21.125 11.3137 21.125C6.99289 21.125 3.49017 17.5992 3.49017 13.25C3.49017 8.90074 6.99289 5.37498 11.3137 5.37498C15.6345 5.37498 19.1372 8.90074 19.1372 13.25Z",
    fill: "#CBB35E"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_i_274_13052",
      x: 0,
      y: 0,
      width: 23,
      height: 31.6489,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 2
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_274_13052"
      })]
    })
  })]
}));
const Memo$m = memo(OffIcon$2);
const AgentDetail = memo(function AgentDetail2(props = {}) {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes_agentdetail.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes_agentdetail.deco3,
      children: /* @__PURE__ */ jsx(Memo$n, {
        className: classes_agentdetail.icon7
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes_agentdetail.deco2,
      children: /* @__PURE__ */ jsx(Memo$o, {
        className: classes_agentdetail.icon8
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes_agentdetail.deco1
    }), /* @__PURE__ */ jsx("div", {
      className: classes_agentdetail.paper
    }), /* @__PURE__ */ jsx(AgentDetailTabs, {
      tabs: props.tabs,
      tab_selected: props.tab_selected,
      onTabSelected: props.onTabSelected,
      className: classes_agentdetail.agentDetailTabs
    }), /* @__PURE__ */ jsx(AgentDetailTitle, {
      expiryLabel: (_a = props.text) == null ? void 0 : _a.expiryLabel,
      expiryValue: (_b = props.text) == null ? void 0 : _b.expiryValue,
      className: classes_agentdetail.agentDetailTitle,
      swap: {
        off: ((_c = props.swap) == null ? void 0 : _c.off) || /* @__PURE__ */ jsx(Memo$m, {
          className: classes_agentdetail.icon6
        })
      },
      text: {
        ptAgentName: (_d = props.text) == null ? void 0 : _d.ptAgentName
      }
    }), props.body]
  });
});
const root$e = "_root_1uk1g_1";
const classes$e = {
  root: root$e
};
const AC_state_varStateDefault = memo(function AC_state_varStateDefault2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$e.root}`
  });
});
const aC_state$3 = "_aC_state_zkk8k_1";
const root$d = "_root_zkk8k_5";
const press = "_press_zkk8k_13";
const icon$a = "_icon_zkk8k_21";
const classes$d = {
  aC_state: aC_state$3,
  root: root$d,
  press,
  icon: icon$a
};
const PressIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 344 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    opacity: 0.3,
    d: "M342 0H118.266L115.5 2.79187H12.237L2 13.0289V117H0V143H2V145V161H344V2.79187H342V0Z",
    fill: "black"
  })
}));
const Memo$l = memo(PressIcon);
const AC_mouse_varMousePress = memo(function AC_mouse_varMousePress2(props = {}) {
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes$d.root}`,
    children: [/* @__PURE__ */ jsx(AC_state_varStateDefault, {
      className: classes$d.aC_state
    }), /* @__PURE__ */ jsx("div", {
      className: classes$d.press,
      children: /* @__PURE__ */ jsx(Memo$l, {
        className: classes$d.icon
      })
    })]
  });
});
const root$c = "_root_1ob7s_1";
const Dim = "_Dim_1ob7s_9";
const icon$9 = "_icon_1ob7s_17";
const killedInAction = "_killedInAction_1ob7s_21";
const rectangle299 = "_rectangle299_1ob7s_31";
const rectangle300 = "_rectangle300_1ob7s_41";
const vector157 = "_vector157_1ob7s_51";
const icon2$2 = "_icon2_1ob7s_61";
const kIA___BOLD6 = "_kIA___BOLD6_1ob7s_65";
const classes$c = {
  root: root$c,
  Dim,
  icon: icon$9,
  killedInAction,
  rectangle299,
  rectangle300,
  vector157,
  icon2: icon2$2,
  kIA___BOLD6
};
const DimIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 344 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    opacity: 0.4,
    d: "M342 0H118.266L115.5 2.79187H12.237L2 13.0289V117H0V143H2V145V161H344V2.79187H342V0Z",
    fill: "#281906"
  })
}));
const Memo$k = memo(DimIcon);
const Vector157Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 219 1",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0L219 0",
    stroke: "#931B13"
  })
}));
const Memo$j = memo(Vector157Icon);
const AC_state_varStateKiiledInActio = memo(function AC_state_varStateKiiledInActio2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$c.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$c.Dim,
      children: /* @__PURE__ */ jsx(Memo$k, {
        className: classes$c.icon
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$c.killedInAction,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$c.rectangle299
      }), /* @__PURE__ */ jsx("div", {
        className: classes$c.rectangle300
      }), /* @__PURE__ */ jsx("div", {
        className: classes$c.vector157,
        children: /* @__PURE__ */ jsx(Memo$j, {
          className: classes$c.icon2
        })
      }), /* @__PURE__ */ jsx("div", {
        className: classes$c.kIA___BOLD6,
        children: "\uC804\uC0AC\uD568"
      })]
    })]
  });
});
const root$b = "_root_1kh2s_1";
const vector$2 = "_vector_1kh2s_9";
const icon$8 = "_icon_1kh2s_18";
const classes$b = {
  root: root$b,
  vector: vector$2,
  icon: icon$8
};
const VectorIcon$2 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 15 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M12.4359 5.77418L12.9487 0L10.5128 0.64516L10.3846 5.64515C9.75973 7.02873 8.32269 7.30882 7.49855 7.32206C6.67393 7.30821 5.23953 7.02716 4.61539 5.6452L4.48719 0.645207L2.05129 4.75645e-05L2.56411 5.77423C2.22223 6.76347 1.28205 8.74196 0 9.25809V11.8388H0.769222V13.3872H0V15.7096H0.769269V17.258H0V19.3226L1.53846 21L13.4615 21L15 19.3225V17.258H14.1027V15.7096H15V13.3871H14.1027V11.8388H15V9.25804C13.7179 8.74192 12.7778 6.76343 12.4359 5.77418Z",
    fill: "#2E240B"
  })
}));
const Memo$i = memo(VectorIcon$2);
const Icon_Equipments_Property1Bulle = memo(function Icon_Equipments_Property1Bulle2(props = {}) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$b.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$b.vector,
      children: /* @__PURE__ */ jsx(Memo$i, {
        className: classes$b.icon
      })
    })
  });
});
const root$a = "_root_1mkf5_1";
const durability___HGAP2_ = "_durability___HGAP2__1mkf5_14";
const bulletProof___BOLD6 = "_bulletProof___BOLD6_1mkf5_26";
const full___BOLD4 = "_full___BOLD4_1mkf5_40";
const classes$a = {
  root: root$a,
  durability___HGAP2_,
  bulletProof___BOLD6,
  full___BOLD4
};
const BulletProof_Info_Property1Defa = memo(function BulletProof_Info_Property1Defa2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$a.root}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: classes$a.durability___HGAP2_,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$a.bulletProof___BOLD6,
        children: props.armor
      }), /* @__PURE__ */ jsx("div", {
        className: classes$a.full___BOLD4
      })]
    }), /* @__PURE__ */ jsx(Icon_Equipments_Property1Bulle, {})]
  });
});
const root$9 = "_root_4d5b7_1";
const frame34$1 = "_frame34_4d5b7_9";
const icon$7 = "_icon_4d5b7_17";
const classes$9 = {
  root: root$9,
  frame34: frame34$1,
  icon: icon$7
};
const Frame34Icon$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    opacity: 0.3,
    width: 26,
    height: 26,
    rx: 5,
    fill: "#615845"
  }), /* @__PURE__ */ jsx("path", {
    d: "M14.2256 18.26H11.1856V13.92H7.20559V11H11.1856V6.86001H14.2256V11H18.4056V13.92H14.2256V18.26Z",
    fill: "#37311A"
  })]
}));
const Memo$h = memo(Frame34Icon$1);
const BulletProof_Info_Property1Equi = memo(function BulletProof_Info_Property1Equi2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$9.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$9.frame34,
      children: /* @__PURE__ */ jsx(Memo$h, {
        className: classes$9.icon
      })
    })
  });
});
const root$8 = "_root_ppgxo_1";
const off = "_off_ppgxo_7";
const icon$6 = "_icon_ppgxo_15";
const classes$8 = {
  root: root$8,
  off,
  icon: icon$6
};
const OffIcon$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 17 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_di_274_13871)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M17 16V9.53674e-06H0V16L8.5 23.5429L17 16Z",
      fill: "#030201"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M9.72214 7.88115L8.35294 4.49998L6.98375 7.88115L3.31794 8.12764L6.13754 10.4638L5.24114 13.9973L8.35294 12.06L11.4647 13.9973L10.5683 10.4638L13.3879 8.12764L9.72214 7.88115Z",
    fill: "#38321D"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H16V15.5833L8.5 22L1 15.5833V1ZM14.5294 9.74998C14.5294 13.1327 11.7641 15.875 8.35292 15.875C4.94175 15.875 2.17645 13.1327 2.17645 9.74998C2.17645 6.36724 4.94175 3.62498 8.35292 3.62498C11.7641 3.62498 14.5294 6.36724 14.5294 9.74998Z",
    fill: "#38321D"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_di_274_13871",
      x: 0,
      y: 953674e-11,
      width: 17,
      height: 24.5429,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 1
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.395833 0 0 0 0 0.317976 0 0 0 0 0.219358 0 0 0 1 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_274_13871"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_274_13871",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 1
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect2_innerShadow_274_13871"
      })]
    })
  })]
}));
const Memo$g = memo(OffIcon$1);
const Button_CheckBox_AgentCard_Prop = memo(function Button_CheckBox_AgentCard_Prop2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$8.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$8.off,
      children: ((_a = props.swap) == null ? void 0 : _a.off) || /* @__PURE__ */ jsx(Memo$g, {
        className: classes$8.icon
      })
    })
  });
});
const root$7 = "_root_1s504_1";
const image_Firearm = "_image_Firearm_1s504_9";
const icon$5 = "_icon_1s504_17";
const firearm___HGAP3_ = "_firearm___HGAP3__1s504_21";
const firearm_Grade = "_firearm_Grade_1s504_30";
const frame185 = "_frame185_1s504_36";
const icon2$1 = "_icon2_1s504_44";
const ptFirearmGrade = "_ptFirearmGrade_1s504_48";
const firearm_Type = "_firearm_Type_1s504_64";
const ptFirearmType = "_ptFirearmType_1s504_71";
const ptFirearmName = "_ptFirearmName_1s504_81";
const classes$7 = {
  root: root$7,
  image_Firearm,
  icon: icon$5,
  firearm___HGAP3_,
  firearm_Grade,
  frame185,
  icon2: icon2$1,
  ptFirearmGrade,
  firearm_Type,
  ptFirearmType,
  ptFirearmName
};
const Frame185Icon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 24 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2L22 7.74977V19.2502L12 25L2 19.2502V7.74977L12 2Z",
    fill: "#341D10"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.269714L23.5 6.88195V20.118L12 26.7303L0.5 20.118V6.88195L12 0.269714ZM22 7.74976L12 1.99999L2 7.74976V19.2502L12 25L22 19.2502V7.74976Z",
    fill: "#E57710"
  })]
}));
const Memo$f = memo(Frame185Icon);
const Image_firearmIcon$1 = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 110 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_d_274_13744)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M96.0991 3.0624C95.8388 3.22242 95.7086 3.93107 95.7086 5.15787C95.701 6.23989 95.7163 6.32371 95.9077 6.72757C96.0226 6.96378 96.1145 7.18476 96.1145 7.21524C96.1145 7.28382 90.1953 7.20762 88.6715 7.1238L87.7679 7.07808V6.80377C87.7679 6.40753 87.6147 6.17131 87.2319 5.96558C86.8031 5.72936 86.0679 5.69888 85.5319 5.90462C85.1337 6.05702 84.7049 6.48373 84.7049 6.72757C84.7049 6.819 84.6283 6.90282 84.4982 6.95616C84.3527 7.0095 82.1933 7.02474 77.6218 7.00188C71.672 6.9714 70.8986 6.95616 70.3856 6.84186C69.7653 6.69709 68.5631 6.70471 66.7866 6.86472C66.3042 6.90282 64.5736 6.94092 62.9426 6.94092L59.9715 6.94854L59.8643 6.68947C59.7111 6.33133 59.5044 6.23227 59.1828 6.36181C59.0449 6.42277 58.708 6.49135 58.44 6.52183C57.9729 6.56755 57.7585 6.53707 57.1536 6.34657C56.9392 6.28561 56.8779 6.29323 56.7477 6.42277C56.6711 6.49897 56.6022 6.65137 56.6022 6.75805V6.94854H49.1975L49.1133 6.75805C48.9601 6.42277 49.0061 6.24751 49.4349 5.50077C49.8101 4.84546 49.8407 4.76164 49.7335 4.64734C49.5727 4.47208 48.6845 4.01489 48.1255 3.83201C47.4669 3.61103 46.8008 3.62627 46.8008 3.85487C46.7931 4.11395 46.6553 4.16729 45.7747 4.20539L44.8941 4.24348L44.5724 4.54828C44.1743 4.92927 44.0441 5.23407 44.0441 5.75222C44.0441 5.98082 44.0211 6.33133 43.9905 6.52945L43.9445 6.8952L41.1802 6.8571C39.6564 6.82662 38.3699 6.82662 38.3163 6.84948C38.1249 6.92568 37.9564 7.39812 37.5353 9.00591L37.1141 10.6442L35.3529 10.6899C34.3881 10.7204 29.0585 10.7661 23.5146 10.7966L13.4374 10.8499L13.1847 10.2251C12.8555 9.40976 12.5798 9.13545 11.8983 8.92971C10.7726 8.60206 8.64389 8.51062 8.04661 8.76969C7.86283 8.84589 7.56419 8.93733 7.38807 8.96781L7.07412 9.01353L7.02818 9.60026C7.0052 9.9203 6.96692 10.5985 6.94394 11.1014C6.76782 14.9647 6.56873 17.7383 6.21649 21.1749C6.05568 22.7217 5.98677 23.7047 6.00208 24.3752L6.02505 25.3506L6.38495 25.4039C6.58405 25.4268 6.83674 25.5258 6.9516 25.6096C7.21961 25.823 7.63311 25.8916 7.80157 25.762C7.87049 25.7011 8.03895 25.4115 8.17679 25.122C8.9655 23.4151 9.4862 21.2434 10.0069 17.5021C10.1524 16.4124 10.3132 15.4447 10.3515 15.3457C10.4434 15.1323 10.9564 14.5151 11.0713 14.4694C11.2244 14.416 36.1952 14.5456 36.3254 14.6065C36.402 14.637 36.6241 14.8885 36.8155 15.1704C37.0146 15.4447 37.4817 16.0619 37.8646 16.5267L38.5537 17.3878H39.9397C41.609 17.3878 42.2216 17.464 42.459 17.6926C42.5585 17.784 42.8725 17.9364 43.1711 18.0279C43.4621 18.1193 43.8373 18.2869 44.0058 18.3936C44.8864 18.9499 45.5526 20.2376 45.3382 20.992C45.2233 21.4187 44.4423 22.6455 41.8234 26.4935C40.4834 28.4747 39.3348 30.1816 39.2888 30.2959C39.2123 30.4635 39.2123 30.5397 39.3118 30.7454C39.5339 31.195 40.0775 31.7132 40.8969 32.2542C41.7392 32.8104 46.1728 35.0659 46.4255 35.0659C46.6476 35.0659 46.8008 34.6773 46.8008 34.1134C46.8008 33.8239 46.862 33.4353 46.9462 33.1762C47.2679 32.2237 50.0858 26.3335 50.438 25.8687C50.6218 25.6401 50.6677 25.6173 51.0659 25.6173C51.5024 25.6173 51.9465 25.7925 52.697 26.2649C52.9956 26.4554 53.0186 26.4554 54.6266 26.4554C55.5225 26.4478 56.6941 26.4173 57.2225 26.3869C58.3634 26.3183 58.7999 26.1354 59.1445 25.5944C59.3283 25.3048 60.5764 22.4626 60.8138 21.7997C60.9057 21.5482 60.9516 21.5178 61.2579 21.472C61.8093 21.3958 62.016 21.4187 62.0696 21.5482C62.0926 21.6092 62.062 22.013 62.0007 22.4398C61.8629 23.3237 61.8935 23.5827 62.1539 23.697C62.2993 23.7656 62.3529 23.7504 62.4602 23.6361C62.6286 23.4532 62.9349 22.4855 63.0421 21.7845C63.0957 21.4873 63.157 21.2053 63.1876 21.1749C63.2718 21.0834 64.1754 21.2053 64.2979 21.3273C64.3592 21.3806 64.6119 22.0892 64.8722 22.897C65.6686 25.3887 66.9014 29.0233 67.4375 30.4178C69.2446 35.1954 71.8558 40.1407 73.3566 41.6571C73.5404 41.8476 73.7472 42 73.8161 42C73.8927 42 74.2066 41.8552 74.5206 41.6876C75.2404 41.2914 77.6525 39.714 77.8286 39.5159C77.9511 39.3788 77.9434 39.3483 77.729 38.9292C77.6065 38.6854 77.2543 38.0834 76.9556 37.5957C74.9953 34.4106 73.8008 32.0637 72.5679 28.97C71.6414 26.6612 70.4315 22.7217 70.0333 20.771L69.8955 20.07L70.0793 19.5366C70.2477 19.0565 70.2554 18.9727 70.1635 18.6755C70.1099 18.4927 69.9874 18.2336 69.8955 18.1117C69.75 17.9059 69.7347 17.7993 69.75 17.022C69.773 16.0314 69.8649 15.7495 70.3013 15.4142C70.5464 15.2237 71.0135 14.9494 71.0977 14.9494C71.113 14.9494 71.1513 15.5209 71.1743 16.2219C71.2126 17.4564 71.2891 17.8907 71.4806 18.0126C71.6414 18.1117 72.1697 18.0812 74.2755 17.845C79.2528 17.2811 93.2582 15.559 94.4911 15.3685C95.2798 15.239 95.3334 15.2237 95.7469 14.8885C96.0302 14.6675 96.0379 14.6675 97.2784 14.6218L98.5265 14.5837L98.7333 14.3474L98.9477 14.1112L100.073 14.1036C100.701 14.1036 101.75 14.0731 102.417 14.0427C103.979 13.9741 103.956 13.9893 103.986 12.8159C104.017 12.0158 104.009 11.9777 103.825 11.7948C103.611 11.5814 103.328 11.551 100.678 11.4824C99.7517 11.4595 98.9324 11.3986 98.8558 11.3605C98.6337 11.2385 98.672 10.7356 98.9324 10.4003C99.1315 10.126 99.1391 10.1032 99.1391 9.05163C99.1391 7.93151 99.0855 7.70291 98.718 7.29144C98.6108 7.16952 98.5725 6.9333 98.5342 6.18655C98.4653 4.98261 98.3198 4.33492 97.9829 3.77105C97.5541 3.0624 97.5005 3.03192 96.8189 3.00144C96.4973 2.99382 96.1681 3.01668 96.0991 3.0624ZM54.2591 22.3559C54.3203 23.4837 54.4505 23.9637 54.8563 24.6495C55.0325 24.9315 55.1473 25.1829 55.1244 25.2134C55.0937 25.2363 54.6649 25.2286 54.1595 25.1829C53.2483 25.1143 53.2406 25.1067 52.6204 24.741C51.7398 24.2076 51.4718 23.9714 51.4718 23.7275C51.4718 23.6208 51.7015 23.057 51.9848 22.4779L52.4902 21.4263H54.2055L54.2591 22.3559ZM59.581 21.472C59.7111 21.5025 59.8183 21.5559 59.8183 21.6016C59.8183 21.7235 58.9913 23.758 58.731 24.2838C58.3481 25.0458 58.2179 25.1372 57.4905 25.1905C57.1536 25.221 56.6865 25.2134 56.4644 25.1829L56.0662 25.122L55.714 24.2838C55.5225 23.819 55.3464 23.2703 55.3234 23.057C55.2239 22.1883 55.4689 21.6244 55.9896 21.5025C56.3113 21.4339 59.2364 21.4035 59.581 21.472Z",
      fill: "#2E240B"
    })
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_d_274_13744",
      x: -1,
      y: -4,
      width: 112,
      height: 53,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {}), /* @__PURE__ */ jsx("feGaussianBlur", {
        stdDeviation: 3.5
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_274_13744"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_274_13744",
        result: "shape"
      })]
    })
  })]
}));
const Memo$e = memo(Image_firearmIcon$1);
const Firearm_Info_varFirearmVarFire = memo(function Firearm_Info_varFirearmVarFire2(props = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$7.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$7.image_Firearm,
      children: ((_b = props.swap) == null ? void 0 : _b.image_Firearm) || /* @__PURE__ */ jsx(Memo$e, {
        className: classes$7.icon
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$7.firearm___HGAP3_,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes$7.firearm_Grade,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$7.frame185,
          children: /* @__PURE__ */ jsx(Memo$f, {
            className: classes$7.icon2
          })
        }), ((_c = props.text) == null ? void 0 : _c.ptFirearmGrade) != null ? (_d = props.text) == null ? void 0 : _d.ptFirearmGrade : /* @__PURE__ */ jsx("div", {
          className: classes$7.ptFirearmGrade,
          children: "2"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: classes$7.firearm_Type,
        children: ((_e = props.text) == null ? void 0 : _e.ptFirearmType) != null ? (_f = props.text) == null ? void 0 : _f.ptFirearmType : /* @__PURE__ */ jsx("div", {
          className: classes$7.ptFirearmType,
          children: "SG"
        })
      }), ((_g = props.text) == null ? void 0 : _g.ptFirearmName) != null ? (_h = props.text) == null ? void 0 : _h.ptFirearmName : /* @__PURE__ */ jsx("div", {
        className: classes$7.ptFirearmName,
        children: "PH-M82"
      })]
    })]
  });
});
const root$6 = "_root_h5wmw_1";
const vector$1 = "_vector_h5wmw_9";
const icon$4 = "_icon_h5wmw_18";
const classes$6 = {
  root: root$6,
  vector: vector$1,
  icon: icon$4
};
const VectorIcon$1 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 17 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.809334 11.8007C0.985795 8.72628 2.66926 6.47758 4.95108 5.66788V4.293H4.94702L2.8599 3.01834V0H11.5389C13.3887 2.02023 15.3886 7.06881 16.1574 10.2976C15.8186 10.4218 15.5813 10.5742 14.9911 10.6944C14.3299 8.52388 12.2955 4.07054 11.1292 3.01834L9.07658 4.293H9.07054V5.7701C11.2165 6.65595 12.7742 8.84854 12.9446 11.8007H13.7538V14.5304H12.9446C12.7255 18.4206 10.0908 21 6.87795 21C3.66312 21 1.02839 18.4206 0.809334 14.5304H0V11.8007H0.809334Z",
    fill: "#2E240B"
  })
}));
const Memo$d = memo(VectorIcon$1);
const Icon_Equipments_Property1Throw = memo(function Icon_Equipments_Property1Throw2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$6.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$6.vector,
      children: /* @__PURE__ */ jsx(Memo$d, {
        className: classes$6.icon
      })
    })
  });
});
const icon_Equipments = "_icon_Equipments_akcvf_1";
const root$5 = "_root_akcvf_8";
const Grenade1___BOLD6 = "_Grenade1___BOLD6_akcvf_16";
const classes$5 = {
  icon_Equipments,
  root: root$5,
  Grenade1___BOLD6
};
const Throwable_Info_Property1Defaul = memo(function Throwable_Info_Property1Defaul2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$5.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$5.Grenade1___BOLD6,
      children: "1"
    }), /* @__PURE__ */ jsx(Icon_Equipments_Property1Throw, {
      className: classes$5.icon_Equipments
    })]
  });
});
const Frame34Icon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    opacity: 0.3,
    x: -12207e-8,
    width: 26,
    height: 26,
    rx: 5,
    fill: "#615845"
  }), /* @__PURE__ */ jsx("path", {
    d: "M14.2255 18.26H11.1855V13.92H7.20547V11H11.1855V6.86001H14.2255V11H18.4055V13.92H14.2255V18.26Z",
    fill: "#37311A"
  })]
}));
const Memo$c = memo(Frame34Icon);
const root$4 = "_root_1qse8_1";
const frame34 = "_frame34_1qse8_9";
const icon$3 = "_icon_1qse8_17";
const classes$4 = {
  root: root$4,
  frame34,
  icon: icon$3
};
const Throwable_Info_Property1Equipp = memo(function Throwable_Info_Property1Equipp2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$4.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$4.frame34,
      children: /* @__PURE__ */ jsx(Memo$c, {
        className: classes$4.icon
      })
    })
  });
});
const root$3 = "_root_1cry1_1";
const union$1 = "_union_1cry1_13";
const icon$2 = "_icon_1cry1_22";
const classes$3 = {
  root: root$3,
  union: union$1,
  icon: icon$2
};
const UnionIcon$1 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7H0V18H13V7H11V4.5C11 2.01472 8.98528 0 6.5 0C4.01472 0 2 2.01472 2 4.5V7ZM4.5 7H8.5V4.5C8.5 3.39543 7.60457 2.5 6.5 2.5C5.39543 2.5 4.5 3.39543 4.5 4.5V7Z",
    fill: "#A1916E"
  })
}));
const Memo$b = memo(UnionIcon$1);
const Throwable_Info_Property1Locked = memo(function Throwable_Info_Property1Locked2(props = {}) {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$3.root}`,
    children: /* @__PURE__ */ jsx("div", {
      className: classes$3.union,
      children: /* @__PURE__ */ jsx(Memo$b, {
        className: classes$3.icon
      })
    })
  });
});
const throwable_Info = "_throwable_Info_lh7zh_1";
const throwable_Info2 = "_throwable_Info2_lh7zh_13";
const bulletProof_Info = "_bulletProof_Info_lh7zh_25";
const firearm_Info = "_firearm_Info_lh7zh_37";
const icon$1 = "_icon_lh7zh_49";
const iconDoing = "_iconDoing_lh7zh_53";
const icon2 = "_icon2_lh7zh_59";
const icon3 = "_icon3_lh7zh_63";
const icon4 = "_icon4_lh7zh_67";
const icon5 = "_icon5_lh7zh_71";
const icon6 = "_icon6_lh7zh_75";
const aC_state$2 = "_aC_state_lh7zh_79";
const root$2 = "_root_lh7zh_83";
const vector = "_vector_lh7zh_89";
const icon7 = "_icon7_lh7zh_97";
const vector2 = "_vector2_lh7zh_101";
const icon8 = "_icon8_lh7zh_109";
const vector3 = "_vector3_lh7zh_113";
const icon9 = "_icon9_lh7zh_121";
const gridBG = "_gridBG_lh7zh_125";
const rectangle315 = "_rectangle315_lh7zh_133";
const centerInfo = "_centerInfo_lh7zh_142";
const union = "_union_lh7zh_150";
const icon10 = "_icon10_lh7zh_166";
const deco_Line = "_deco_Line_lh7zh_170";
const icon11 = "_icon11_lh7zh_188";
const grade = "_grade_lh7zh_192";
const ptGradeBg = "_ptGradeBg_lh7zh_200";
const ptGradeFg = "_ptGradeFg_lh7zh_213";
const portrait = "_portrait_lh7zh_226";
const image_AgentPotrait = "_image_AgentPotrait_lh7zh_235";
const stat___HGAP7_ = "_stat___HGAP7__lh7zh_246";
const life___VGAP2_ = "_life___VGAP2__lh7zh_255";
const life___BOLD4 = "_life___BOLD4_lh7zh_263";
const ptLifeValue = "_ptLifeValue_lh7zh_277";
const frame181 = "_frame181_lh7zh_289";
const icon12 = "_icon12_lh7zh_294";
const overall___VGAP2_ = "_overall___VGAP2__lh7zh_298";
const overall___BOLD4 = "_overall___BOLD4_lh7zh_306";
const ptOverallValue = "_ptOverallValue_lh7zh_319";
const frame182 = "_frame182_lh7zh_331";
const icon13 = "_icon13_lh7zh_336";
const physical___VGAP2_ = "_physical___VGAP2__lh7zh_340";
const physical___BOLD4 = "_physical___BOLD4_lh7zh_348";
const ptPhysicalValue = "_ptPhysicalValue_lh7zh_361";
const status = "_status_lh7zh_373";
const nation = "_nation_lh7zh_381";
const rectangle = "_rectangle_lh7zh_133";
const rectangle318 = "_rectangle318_lh7zh_401";
const base = "_base_lh7zh_410";
const bg = "_bg_lh7zh_418";
const perk___HGAP4_ = "_perk___HGAP4__lh7zh_426";
const perk = "_perk_lh7zh_426";
const icon14 = "_icon14_lh7zh_440";
const perk___VGAP1_ = "_perk___VGAP1__lh7zh_444";
const ptPerkpoint = "_ptPerkpoint_lh7zh_451";
const frame183 = "_frame183_lh7zh_461";
const agentName___HGAP6_ = "_agentName___HGAP6__lh7zh_470";
const name___HGAP2_ = "_name___HGAP2__lh7zh_479";
const ptName = "_ptName_lh7zh_485";
const ptAge = "_ptAge_lh7zh_496";
const level = "_level_lh7zh_507";
const bg2 = "_bg2_lh7zh_515";
const icon15 = "_icon15_lh7zh_523";
const ptLevel = "_ptLevel_lh7zh_527";
const exp = "_exp_lh7zh_543";
const progressBar = "_progressBar_lh7zh_551";
const frame = "_frame_lh7zh_289";
const bg3 = "_bg3_lh7zh_567";
const progress = "_progress_lh7zh_551";
const shadow = "_shadow_lh7zh_583";
const exp___BOLD6 = "_exp___BOLD6_lh7zh_592";
const classes$2 = {
  throwable_Info,
  throwable_Info2,
  bulletProof_Info,
  firearm_Info,
  icon: icon$1,
  iconDoing,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  aC_state: aC_state$2,
  root: root$2,
  vector,
  icon7,
  vector2,
  icon8,
  vector3,
  icon9,
  gridBG,
  rectangle315,
  centerInfo,
  union,
  icon10,
  deco_Line,
  icon11,
  grade,
  ptGradeBg,
  ptGradeFg,
  portrait,
  image_AgentPotrait,
  stat___HGAP7_,
  life___VGAP2_,
  life___BOLD4,
  ptLifeValue,
  frame181,
  icon12,
  overall___VGAP2_,
  overall___BOLD4,
  ptOverallValue,
  frame182,
  icon13,
  physical___VGAP2_,
  physical___BOLD4,
  ptPhysicalValue,
  status,
  nation,
  rectangle,
  rectangle318,
  base,
  bg,
  perk___HGAP4_,
  perk,
  icon14,
  perk___VGAP1_,
  ptPerkpoint,
  frame183,
  agentName___HGAP6_,
  name___HGAP2_,
  ptName,
  ptAge,
  level,
  bg2,
  icon15,
  ptLevel,
  exp,
  progressBar,
  frame,
  bg3,
  progress,
  shadow,
  exp___BOLD6
};
const BgIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 26 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 26,
    fill: "#8E2802"
  }), /* @__PURE__ */ jsx("rect", {
    width: 24,
    height: 26,
    fill: "#E35200"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 0H24L0 26V0Z",
    fill: "#D84301"
  })]
}));
const Memo$a = memo(BgIcon);
const Deco_lineIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 1 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 0L2.71011e-06 62",
    stroke: "#AD8E7D",
    strokeLinecap: "round"
  })
}));
const Memo$9 = memo(Deco_lineIcon);
const Frame181Icon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M4.86374e-05 1.5524L1.06071 0.491745L6.50828 5.93931L11.9559 0.491745L13.0165 1.5524L7.56894 6.99998L13.0166 12.4476L11.9559 13.5083L6.50828 8.06064L1.06066 13.5083L0 12.4476L5.44762 6.99998L4.86374e-05 1.5524Z",
    fill: "#574A35"
  })
}));
const Memo$8 = memo(Frame181Icon);
const Image_firearmIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 110 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_d_274_13945)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M96.0991 3.0624C95.8388 3.22242 95.7086 3.93107 95.7086 5.15787C95.701 6.23989 95.7163 6.32371 95.9077 6.72757C96.0226 6.96378 96.1145 7.18476 96.1145 7.21524C96.1145 7.28382 90.1953 7.20762 88.6715 7.1238L87.7679 7.07808V6.80377C87.7679 6.40753 87.6147 6.17131 87.2319 5.96558C86.8031 5.72936 86.0679 5.69888 85.5319 5.90462C85.1337 6.05702 84.7049 6.48373 84.7049 6.72757C84.7049 6.819 84.6283 6.90282 84.4982 6.95616C84.3527 7.0095 82.1933 7.02474 77.6218 7.00188C71.672 6.9714 70.8986 6.95616 70.3856 6.84186C69.7653 6.69709 68.5631 6.70471 66.7866 6.86472C66.3042 6.90282 64.5736 6.94092 62.9426 6.94092L59.9715 6.94854L59.8643 6.68947C59.7111 6.33133 59.5044 6.23227 59.1828 6.36181C59.0449 6.42277 58.708 6.49135 58.44 6.52183C57.9729 6.56755 57.7585 6.53707 57.1536 6.34657C56.9392 6.28561 56.8779 6.29323 56.7477 6.42277C56.6711 6.49897 56.6022 6.65137 56.6022 6.75805V6.94854H49.1975L49.1133 6.75805C48.9601 6.42277 49.0061 6.24751 49.4349 5.50077C49.8101 4.84546 49.8407 4.76164 49.7335 4.64734C49.5727 4.47208 48.6845 4.01489 48.1255 3.83201C47.4669 3.61103 46.8008 3.62627 46.8008 3.85487C46.7931 4.11395 46.6553 4.16729 45.7747 4.20539L44.8941 4.24348L44.5724 4.54828C44.1743 4.92927 44.0441 5.23407 44.0441 5.75222C44.0441 5.98082 44.0211 6.33133 43.9905 6.52945L43.9445 6.8952L41.1802 6.8571C39.6564 6.82662 38.3699 6.82662 38.3163 6.84948C38.1249 6.92568 37.9564 7.39812 37.5353 9.00591L37.1141 10.6442L35.3529 10.6899C34.3881 10.7204 29.0585 10.7661 23.5146 10.7966L13.4374 10.8499L13.1847 10.2251C12.8555 9.40976 12.5798 9.13545 11.8983 8.92971C10.7726 8.60206 8.64389 8.51062 8.04661 8.76969C7.86283 8.84589 7.56419 8.93733 7.38807 8.96781L7.07412 9.01353L7.02818 9.60026C7.0052 9.9203 6.96692 10.5985 6.94394 11.1014C6.76782 14.9647 6.56873 17.7383 6.21649 21.1749C6.05568 22.7217 5.98677 23.7047 6.00208 24.3752L6.02505 25.3506L6.38495 25.4039C6.58405 25.4268 6.83674 25.5258 6.9516 25.6096C7.21961 25.823 7.63311 25.8916 7.80157 25.762C7.87049 25.7011 8.03895 25.4115 8.17679 25.122C8.9655 23.4151 9.4862 21.2434 10.0069 17.5021C10.1524 16.4124 10.3132 15.4447 10.3515 15.3457C10.4434 15.1323 10.9564 14.5151 11.0713 14.4694C11.2244 14.416 36.1952 14.5456 36.3254 14.6065C36.402 14.637 36.6241 14.8885 36.8155 15.1704C37.0146 15.4447 37.4817 16.0619 37.8646 16.5267L38.5537 17.3878H39.9397C41.609 17.3878 42.2216 17.464 42.459 17.6926C42.5585 17.784 42.8725 17.9364 43.1711 18.0279C43.4621 18.1193 43.8373 18.2869 44.0058 18.3936C44.8864 18.9499 45.5526 20.2376 45.3382 20.992C45.2233 21.4187 44.4423 22.6455 41.8234 26.4935C40.4834 28.4747 39.3348 30.1816 39.2888 30.2959C39.2123 30.4635 39.2123 30.5397 39.3118 30.7454C39.5339 31.195 40.0775 31.7132 40.8969 32.2542C41.7392 32.8104 46.1728 35.0659 46.4255 35.0659C46.6476 35.0659 46.8008 34.6773 46.8008 34.1134C46.8008 33.8239 46.862 33.4353 46.9462 33.1762C47.2679 32.2237 50.0858 26.3335 50.438 25.8687C50.6218 25.6401 50.6677 25.6173 51.0659 25.6173C51.5024 25.6173 51.9465 25.7925 52.697 26.2649C52.9956 26.4554 53.0186 26.4554 54.6266 26.4554C55.5225 26.4478 56.6941 26.4173 57.2225 26.3869C58.3634 26.3183 58.7999 26.1354 59.1445 25.5944C59.3283 25.3048 60.5764 22.4626 60.8138 21.7997C60.9057 21.5482 60.9516 21.5178 61.2579 21.472C61.8093 21.3958 62.016 21.4187 62.0696 21.5482C62.0926 21.6092 62.062 22.013 62.0007 22.4398C61.8629 23.3237 61.8935 23.5827 62.1539 23.697C62.2993 23.7656 62.3529 23.7504 62.4602 23.6361C62.6286 23.4532 62.9349 22.4855 63.0421 21.7845C63.0957 21.4873 63.157 21.2053 63.1876 21.1749C63.2718 21.0834 64.1754 21.2053 64.2979 21.3273C64.3592 21.3806 64.6119 22.0892 64.8722 22.897C65.6686 25.3887 66.9014 29.0233 67.4375 30.4178C69.2446 35.1954 71.8558 40.1407 73.3566 41.6571C73.5404 41.8476 73.7472 42 73.8161 42C73.8927 42 74.2066 41.8552 74.5206 41.6876C75.2404 41.2914 77.6525 39.714 77.8286 39.5159C77.9511 39.3788 77.9434 39.3483 77.729 38.9292C77.6065 38.6854 77.2543 38.0834 76.9556 37.5957C74.9953 34.4106 73.8008 32.0637 72.5679 28.97C71.6414 26.6612 70.4315 22.7217 70.0333 20.771L69.8955 20.07L70.0793 19.5366C70.2477 19.0565 70.2554 18.9727 70.1635 18.6755C70.1099 18.4927 69.9874 18.2336 69.8955 18.1117C69.75 17.9059 69.7347 17.7993 69.75 17.022C69.773 16.0314 69.8649 15.7495 70.3013 15.4142C70.5464 15.2237 71.0135 14.9494 71.0977 14.9494C71.113 14.9494 71.1513 15.5209 71.1743 16.2219C71.2126 17.4564 71.2891 17.8907 71.4806 18.0126C71.6414 18.1117 72.1697 18.0812 74.2755 17.845C79.2528 17.2811 93.2582 15.559 94.4911 15.3685C95.2798 15.239 95.3334 15.2237 95.7469 14.8885C96.0302 14.6675 96.0379 14.6675 97.2784 14.6218L98.5265 14.5837L98.7333 14.3474L98.9477 14.1112L100.073 14.1036C100.701 14.1036 101.75 14.0731 102.417 14.0427C103.979 13.9741 103.956 13.9893 103.986 12.8159C104.017 12.0158 104.009 11.9777 103.825 11.7948C103.611 11.5814 103.328 11.551 100.678 11.4824C99.7517 11.4595 98.9324 11.3986 98.8558 11.3605C98.6337 11.2385 98.672 10.7356 98.9324 10.4003C99.1315 10.126 99.1391 10.1032 99.1391 9.05163C99.1391 7.93151 99.0855 7.70291 98.718 7.29144C98.6108 7.16952 98.5725 6.9333 98.5342 6.18655C98.4653 4.98261 98.3198 4.33492 97.9829 3.77105C97.5541 3.0624 97.5005 3.03192 96.8189 3.00144C96.4973 2.99382 96.1681 3.01668 96.0991 3.0624ZM54.2591 22.3559C54.3203 23.4837 54.4505 23.9637 54.8563 24.6495C55.0325 24.9315 55.1473 25.1829 55.1244 25.2134C55.0937 25.2363 54.6649 25.2286 54.1595 25.1829C53.2483 25.1143 53.2406 25.1067 52.6204 24.741C51.7398 24.2076 51.4718 23.9714 51.4718 23.7275C51.4718 23.6208 51.7015 23.057 51.9848 22.4779L52.4902 21.4263H54.2055L54.2591 22.3559ZM59.581 21.472C59.7111 21.5025 59.8183 21.5559 59.8183 21.6016C59.8183 21.7235 58.9913 23.758 58.731 24.2838C58.3481 25.0458 58.2179 25.1372 57.4905 25.1905C57.1536 25.221 56.6865 25.2134 56.4644 25.1829L56.0662 25.122L55.714 24.2838C55.5225 23.819 55.3464 23.2703 55.3234 23.057C55.2239 22.1883 55.4689 21.6244 55.9896 21.5025C56.3113 21.4339 59.2364 21.4035 59.581 21.472Z",
      fill: "#2E240B"
    })
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_d_274_13945",
      x: -1,
      y: -4,
      width: 112,
      height: 53,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {}), /* @__PURE__ */ jsx("feGaussianBlur", {
        stdDeviation: 3.5
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_274_13945"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_274_13945",
        result: "shape"
      })]
    })
  })]
}));
const Memo$7 = memo(Image_firearmIcon);
const OffIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 17 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("g", {
    filter: "url(#filter0_di_274_13960)",
    children: /* @__PURE__ */ jsx("path", {
      d: "M17 16V9.53674e-06H0V16L8.5 23.5429L17 16Z",
      fill: "#030201"
    })
  }), /* @__PURE__ */ jsx("path", {
    d: "M9.72214 7.88115L8.35294 4.49998L6.98375 7.88115L3.31794 8.12764L6.13754 10.4638L5.24114 13.9973L8.35294 12.06L11.4647 13.9973L10.5683 10.4638L13.3879 8.12764L9.72214 7.88115Z",
    fill: "#413921"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H16V15.5833L8.5 22L1 15.5833V1ZM14.5294 9.74998C14.5294 13.1327 11.7641 15.875 8.35292 15.875C4.94175 15.875 2.17645 13.1327 2.17645 9.74998C2.17645 6.36724 4.94175 3.62498 8.35292 3.62498C11.7641 3.62498 14.5294 6.36724 14.5294 9.74998Z",
    fill: "#413921"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("filter", {
      id: "filter0_di_274_13960",
      x: 0,
      y: 953674e-11,
      width: 17,
      height: 24.5429,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/* @__PURE__ */ jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 1
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.395833 0 0 0 0 0.317976 0 0 0 0 0.219358 0 0 0 1 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_274_13960"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_274_13960",
        result: "shape"
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */ jsx("feOffset", {
        dy: 1
      }), /* @__PURE__ */ jsx("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: -1,
        k3: 1
      }), /* @__PURE__ */ jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /* @__PURE__ */ jsx("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect2_innerShadow_274_13960"
      })]
    })
  })]
}));
const Memo$6 = memo(OffIcon);
const PerkIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M9.06601 8.549H8.29602V5.52499H9.06601C9.64001 5.52499 9.97601 5.86101 9.97601 6.435V7.63901C9.97601 8.213 9.64001 8.549 9.06601 8.549Z",
    fill: "#EDA000"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07837 0.125L0 7.20337V9.99503L6.87997 16.875H10.0685L16.75 10.1934V7.00496L9.87006 0.125H7.07837ZM6.81201 4.125V13.925H8.29602V9.94901H9.13602C10.55 9.94901 11.46 9.02499 11.46 7.61099V6.463C11.46 5.049 10.55 4.125 9.13602 4.125H6.81201Z",
    fill: "#EDA000"
  })]
}));
const Memo$5 = memo(PerkIcon);
const UnionIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 362 83",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.792 9.17056V0.670532H299.792V9.17056L307.792 9.17056V0.670532H308.792V9.17056H316.792V0.670532H317.792V9.17056L325.792 9.17056V0.670532H326.792V9.17056L334.792 9.17056V0.670532H335.792V9.17056L343.792 9.17056V0.670534L344.792 0.670534V9.17056H352.792V0.670535L353.792 0.670535V9.17056L361.792 9.17056V10.1706L353.792 10.1706V18.1706H361.792V19.1706H353.792V27.1706H361.792V28.1706H353.792V36.1706H361.792V37.1706H353.792L353.792 45.1706H361.792V46.1706H353.792V54.1706H361.792V55.1706H353.792V63.1706H361.792V64.1706H353.792V72.1706H361.792V73.1706H353.792V82.6705H352.792V73.1706H344.792V82.6705H343.792V73.1706H335.792V82.6705H334.792V73.1706H326.792V82.6705H325.792V73.1706H317.792V82.6705H316.792V73.1706L308.792 73.1706V82.6705H307.792V73.1706H299.792V82.6705H298.792V73.1706H290.792V82.6705H289.792V73.1706H281.792V82.6705H280.792V73.1706H272.792V82.6705H271.792V73.1706H263.792V82.6705H262.792V73.1706H254.792V82.6705H253.792V73.1706H245.792V82.6705H244.792V73.1706H236.792V82.6705H235.792V73.1706H227.792V82.6705H226.792V73.1706L218.792 73.1705V82.6705H217.792V73.1705H209.792V82.6705H208.792V73.1705H200.792V82.6705H199.792V73.1705H191.792V82.6705H190.792V73.1705H182.792V82.6705H181.792V73.1705H173.792V82.6705H172.792V73.1705H164.792V82.6705H163.792V73.1705H155.792V82.6705H154.792V73.1705H146.792V82.6705H145.792V73.1705H137.792V82.6705H136.792V73.1705L128.792 73.1705V82.6705H127.792V73.1705H119.792V82.6705H118.792V73.1705H110.792V82.6705H109.792V73.1705H101.792V82.6705H100.792V73.1705H92.7919V82.6705H91.7919V73.1705H83.7919V82.6705H82.7919V73.1705H74.7919V82.6705H73.7919V73.1705H65.7919V82.6705H64.7919L64.7919 73.1705H56.7919L56.7919 82.6705H55.7919L55.7919 73.1705H47.7919L47.7919 82.6705H46.7919L46.7919 73.1705L38.7919 73.1705L38.7919 82.6705H37.7919L37.7919 73.1705H29.7919L29.7919 82.6705H28.7919L28.7919 73.1705H20.7919L20.7919 82.6705H19.7919L19.7919 73.1705H11.792L11.792 82.6705H10.792L10.792 73.1705H0.791992V72.1705H10.792L10.792 64.1705H0.791992V63.1705H10.792L10.792 55.1705H0.791992V54.1705H10.792L10.792 46.1705H0.791992V45.1705H10.792L10.792 37.1705H0.791992V36.1705H10.792L10.792 28.1705H0.791992V27.1705H10.792L10.792 19.1705H0.791992V18.1705H10.792L10.792 10.1705L0.791992 10.1705V9.17053L10.792 9.17054L10.792 0.670535L11.792 0.670535L11.792 9.17054L19.792 9.17054L19.792 0.670535L20.792 0.670535L20.792 9.17054H28.792L28.792 0.670535L29.792 0.670535L29.792 9.17054L37.792 9.17054L37.792 0.670535L38.792 0.670535L38.792 9.17054L46.792 9.17054L46.792 0.670535L47.792 0.670535L47.792 9.17054H55.792L55.792 0.670535L56.792 0.670535L56.792 9.17054L64.792 9.17054L64.792 0.670535L65.792 0.670535V9.17054L73.792 9.17054V0.670535L74.792 0.670535V9.17054L82.792 9.17054V0.670535L83.792 0.670535V9.17054H91.792V0.670535L92.792 0.670535V9.17054L100.792 9.17054V0.670535L101.792 0.670535V9.17054L109.792 9.17054V0.670535L110.792 0.670535V9.17054H118.792V0.670535L119.792 0.670535V9.17054H127.792V0.670535L128.792 0.670535V9.17054L136.792 9.17054V0.670535L137.792 0.670535V9.17054L145.792 9.17055V0.670535L146.792 0.670535V9.17055H154.792V0.670535L155.792 0.670535V9.17055L163.792 9.17055V0.670535L164.792 0.670535V9.17055L172.792 9.17055V0.670535L173.792 0.670535V9.17055L181.792 9.17055V0.670535L182.792 0.670535V9.17055H190.792V0.670535L191.792 0.670535V9.17055L199.792 9.17055V0.670535L200.792 0.670535V9.17055L208.792 9.17055V0.670535L209.792 0.670535V9.17055H217.792V0.670535L218.792 0.670535V9.17055H226.792V0.670535L227.792 0.670535V9.17055L235.792 9.17055V0.670535L236.792 0.670535V9.17055L244.792 9.17055V0.670535L245.792 0.670535V9.17055H253.792V0.670535L254.792 0.670535V9.17055L262.792 9.17055V0.670535L263.792 0.670535V9.17055L271.792 9.17056V0.670535L272.792 0.670535V9.17056H280.792V0.670535L281.792 0.670535V9.17056H289.792V0.670535L290.792 0.670535V9.17056L298.792 9.17056ZM298.792 10.1706L290.792 10.1706V18.1706H298.792V10.1706ZM298.792 19.1706H290.792V27.1706H298.792V19.1706ZM299.792 27.1706V19.1706L307.792 19.1706V27.1706L299.792 27.1706ZM298.792 28.1706H290.792V36.1706L298.792 36.1706V28.1706ZM299.792 36.1706V28.1706L307.792 28.1706V36.1706H299.792ZM298.792 37.1706L290.792 37.1706L290.792 45.1706L298.792 45.1706L298.792 37.1706ZM299.792 45.1706L299.792 37.1706H307.792L307.792 45.1706H299.792ZM298.792 46.1706L290.792 46.1706V54.1706L298.792 54.1706V46.1706ZM299.792 54.1706V46.1706H307.792V54.1706H299.792ZM298.792 55.1706L290.792 55.1706V63.1706L298.792 63.1706V55.1706ZM299.792 63.1706V55.1706H307.792V63.1706H299.792ZM298.792 64.1706L290.792 64.1706V72.1706H298.792V64.1706ZM299.792 72.1706V64.1706H307.792V72.1706H299.792ZM308.792 72.1706L316.792 72.1706V64.1706H308.792V72.1706ZM308.792 63.1706H316.792V55.1706H308.792V63.1706ZM308.792 54.1706H316.792V46.1706H308.792V54.1706ZM308.792 45.1706H316.792L316.792 37.1706H308.792L308.792 45.1706ZM308.792 36.1706H316.792V28.1706H308.792V36.1706ZM308.792 27.1706H316.792V19.1706H308.792V27.1706ZM308.792 18.1706H316.792V10.1706H308.792V18.1706ZM307.792 10.1706L299.792 10.1706V18.1706L307.792 18.1706V10.1706ZM317.792 10.1706V18.1706L325.792 18.1706V10.1706L317.792 10.1706ZM326.792 10.1706V18.1706H334.792V10.1706L326.792 10.1706ZM335.792 10.1706V18.1706H343.792V10.1706L335.792 10.1706ZM344.792 10.1706V18.1706L352.792 18.1706V10.1706H344.792ZM352.792 19.1706L344.792 19.1706V27.1706L352.792 27.1706V19.1706ZM352.792 28.1706L344.792 28.1706V36.1706H352.792V28.1706ZM352.792 37.1706H344.792L344.792 45.1706H352.792L352.792 37.1706ZM352.792 46.1706H344.792V54.1706H352.792V46.1706ZM352.792 55.1706H344.792V63.1706H352.792V55.1706ZM352.792 64.1706H344.792V72.1706H352.792V64.1706ZM343.792 72.1706V64.1706L335.792 64.1706V72.1706H343.792ZM334.792 72.1706V64.1706H326.792V72.1706H334.792ZM325.792 72.1706V64.1706H317.792V72.1706H325.792ZM317.792 63.1706H325.792V55.1706H317.792V63.1706ZM317.792 54.1706H325.792V46.1706H317.792V54.1706ZM317.792 45.1706H325.792L325.792 37.1706H317.792L317.792 45.1706ZM317.792 36.1706H325.792V28.1706L317.792 28.1706V36.1706ZM317.792 27.1706L325.792 27.1706V19.1706L317.792 19.1706V27.1706ZM326.792 19.1706V27.1706H334.792V19.1706H326.792ZM335.792 19.1706V27.1706H343.792V19.1706H335.792ZM343.792 28.1706H335.792V36.1706L343.792 36.1706V28.1706ZM343.792 37.1706L335.792 37.1706L335.792 45.1706L343.792 45.1706L343.792 37.1706ZM343.792 46.1706L335.792 46.1706V54.1706L343.792 54.1706V46.1706ZM343.792 55.1706L335.792 55.1706V63.1706L343.792 63.1706V55.1706ZM334.792 63.1706V55.1706H326.792V63.1706H334.792ZM326.792 54.1706H334.792V46.1706H326.792V54.1706ZM326.792 45.1706H334.792L334.792 37.1706H326.792L326.792 45.1706ZM326.792 36.1706H334.792V28.1706H326.792V36.1706ZM289.792 72.1706V64.1706H281.792V72.1706H289.792ZM280.792 72.1706V64.1706H272.792V72.1706H280.792ZM271.792 72.1706V64.1706H263.792V72.1706H271.792ZM262.792 72.1706V64.1706H254.792V72.1706H262.792ZM253.792 72.1706V64.1706L245.792 64.1706V72.1706H253.792ZM244.792 72.1706V64.1706H236.792V72.1706H244.792ZM235.792 72.1706V64.1706H227.792V72.1706H235.792ZM226.792 72.1706V64.1706H218.792V72.1705L226.792 72.1706ZM217.792 72.1705V64.1706H209.792V72.1705H217.792ZM208.792 72.1705V64.1706L200.792 64.1705V72.1705H208.792ZM199.792 72.1705V64.1705H191.792V72.1705H199.792ZM190.792 72.1705V64.1705H182.792V72.1705H190.792ZM181.792 72.1705V64.1705H173.792V72.1705H181.792ZM172.792 72.1705V64.1705H164.792V72.1705H172.792ZM163.792 72.1705V64.1705L155.792 64.1705V72.1705H163.792ZM154.792 72.1705V64.1705H146.792V72.1705H154.792ZM145.792 72.1705V64.1705H137.792V72.1705H145.792ZM136.792 72.1705V64.1705H128.792V72.1705L136.792 72.1705ZM127.792 72.1705V64.1705H119.792V72.1705H127.792ZM118.792 72.1705V64.1705L110.792 64.1705V72.1705H118.792ZM109.792 72.1705V64.1705H101.792V72.1705H109.792ZM100.792 72.1705V64.1705H92.7919V72.1705H100.792ZM91.7919 72.1705V64.1705H83.7919V72.1705H91.7919ZM82.7919 72.1705V64.1705H74.7919V72.1705H82.7919ZM73.7919 72.1705V64.1705L65.7919 64.1705V72.1705H73.7919ZM64.7919 72.1705L64.7919 64.1705H56.7919L56.7919 72.1705H64.7919ZM55.7919 72.1705L55.7919 64.1705H47.7919L47.7919 72.1705H55.7919ZM46.7919 72.1705L46.7919 64.1705H38.7919L38.7919 72.1705L46.7919 72.1705ZM37.7919 72.1705L37.7919 64.1705H29.7919L29.7919 72.1705H37.7919ZM28.7919 72.1705L28.7919 64.1705L20.7919 64.1705L20.7919 72.1705H28.7919ZM19.7919 72.1705L19.7919 64.1705H11.792L11.792 72.1705H19.7919ZM11.792 63.1705H19.7919L19.7919 55.1705H11.792L11.792 63.1705ZM11.792 54.1705H19.7919L19.7919 46.1705H11.792L11.792 54.1705ZM11.792 45.1705H19.7919L19.792 37.1705H11.792L11.792 45.1705ZM11.792 36.1705H19.792L19.792 28.1705L11.792 28.1705L11.792 36.1705ZM11.792 27.1705L19.792 27.1705L19.792 19.1705L11.792 19.1705L11.792 27.1705ZM11.792 18.1705L19.792 18.1705L19.792 10.1705L11.792 10.1705L11.792 18.1705ZM20.792 10.1705L20.792 18.1705H28.792L28.792 10.1705H20.792ZM29.792 10.1705L29.792 18.1705L37.792 18.1705L37.792 10.1705L29.792 10.1705ZM38.792 10.1705L38.792 18.1705H46.792L46.792 10.1705L38.792 10.1705ZM47.792 10.1705L47.792 18.1705H55.792L55.792 10.1705H47.792ZM56.792 10.1705L56.792 18.1705L64.792 18.1705L64.792 10.1705L56.792 10.1705ZM65.792 10.1705L65.792 18.1705H73.792L73.792 10.1705L65.792 10.1705ZM74.792 10.1705L74.792 18.1705H82.792L82.792 10.1705L74.792 10.1705ZM83.792 10.1705L83.792 18.1705L91.792 18.1705L91.792 10.1705H83.792ZM92.792 10.1705L92.792 18.1705H100.792L100.792 10.1705L92.792 10.1705ZM101.792 10.1705L101.792 18.1705L109.792 18.1705L109.792 10.1705L101.792 10.1705ZM110.792 10.1705L110.792 18.1705H118.792L118.792 10.1705H110.792ZM119.792 10.1705L119.792 18.1705H127.792L127.792 10.1705H119.792ZM128.792 10.1705L128.792 18.1705L136.792 18.1705V10.1705L128.792 10.1705ZM137.792 10.1705V18.1705H145.792V10.1705L137.792 10.1705ZM146.792 10.1705V18.1705H154.792V10.1705H146.792ZM155.792 10.1705V18.1705L163.792 18.1705V10.1705L155.792 10.1705ZM164.792 10.1705V18.1705H172.792V10.1705L164.792 10.1705ZM173.792 10.1705V18.1705L181.792 18.1705V10.1705L173.792 10.1705ZM182.792 10.1705V18.1705H190.792V10.1705H182.792ZM191.792 10.1705V18.1705H199.792V10.1705L191.792 10.1705ZM200.792 10.1705V18.1705L208.792 18.1706V10.1706L200.792 10.1705ZM209.792 10.1706V18.1706H217.792V10.1706H209.792ZM218.792 10.1706V18.1706H226.792V10.1706H218.792ZM227.792 10.1706V18.1706L235.792 18.1706V10.1706L227.792 10.1706ZM236.792 10.1706V18.1706H244.792V10.1706L236.792 10.1706ZM245.792 10.1706V18.1706L253.792 18.1706V10.1706H245.792ZM254.792 10.1706V18.1706H262.792V10.1706L254.792 10.1706ZM263.792 10.1706V18.1706H271.792V10.1706L263.792 10.1706ZM272.792 10.1706V18.1706L280.792 18.1706V10.1706H272.792ZM281.792 10.1706V18.1706H289.792V10.1706H281.792ZM289.792 19.1706H281.792V27.1706H289.792V19.1706ZM289.792 28.1706H281.792V36.1706H289.792V28.1706ZM289.792 37.1706H281.792L281.792 45.1706H289.792L289.792 37.1706ZM289.792 46.1706H281.792V54.1706H289.792V46.1706ZM289.792 55.1706H281.792V63.1706H289.792V55.1706ZM280.792 63.1706V55.1706H272.792V63.1706H280.792ZM271.792 63.1706V55.1706H263.792V63.1706H271.792ZM262.792 63.1706V55.1706H254.792L254.792 63.1706H262.792ZM253.792 63.1706L253.792 55.1706L245.792 55.1706L245.792 63.1706L253.792 63.1706ZM244.792 63.1706L244.792 55.1706H236.792L236.792 63.1706H244.792ZM235.792 63.1706L235.792 55.1706H227.792L227.792 63.1706H235.792ZM226.792 63.1706L226.792 55.1706H218.792L218.792 63.1706H226.792ZM217.792 63.1706L217.792 55.1706H209.792L209.792 63.1706H217.792ZM208.792 63.1706L208.792 55.1706L200.792 55.1705L200.792 63.1705L208.792 63.1706ZM199.792 63.1705L199.792 55.1705H191.792L191.792 63.1705H199.792ZM190.792 63.1705L190.792 55.1705H182.792L182.792 63.1705H190.792ZM181.792 63.1705L181.792 55.1705H173.792L173.792 63.1705H181.792ZM172.792 63.1705L172.792 55.1705H164.792L164.792 63.1705H172.792ZM163.792 63.1705L163.792 55.1705L155.792 55.1705L155.792 63.1705L163.792 63.1705ZM154.792 63.1705L154.792 55.1705H146.792L146.792 63.1705H154.792ZM145.792 63.1705L145.792 55.1705H137.792L137.792 63.1705H145.792ZM136.792 63.1705L136.792 55.1705H128.792V63.1705H136.792ZM127.792 63.1705V55.1705H119.792V63.1705H127.792ZM118.792 63.1705V55.1705L110.792 55.1705V63.1705L118.792 63.1705ZM109.792 63.1705V55.1705H101.792V63.1705H109.792ZM100.792 63.1705V55.1705H92.7919V63.1705H100.792ZM91.7919 63.1705V55.1705H83.7919V63.1705H91.7919ZM82.7919 63.1705V55.1705H74.7919V63.1705H82.7919ZM73.7919 63.1705V55.1705L65.7919 55.1705V63.1705L73.7919 63.1705ZM64.7919 63.1705L64.7919 55.1705H56.7919L56.7919 63.1705H64.7919ZM55.7919 63.1705L55.7919 55.1705H47.7919L47.7919 63.1705H55.7919ZM46.7919 63.1705L46.7919 55.1705H38.7919L38.7919 63.1705H46.7919ZM37.7919 63.1705L37.7919 55.1705H29.7919L29.7919 63.1705H37.7919ZM28.7919 63.1705L28.7919 55.1705L20.7919 55.1705L20.7919 63.1705L28.7919 63.1705ZM20.7919 54.1705L28.7919 54.1705L28.7919 46.1705L20.7919 46.1705L20.7919 54.1705ZM20.7919 45.1705L28.7919 45.1705L28.792 37.1705L20.792 37.1705L20.7919 45.1705ZM20.792 36.1705L28.792 36.1705L28.792 28.1705H20.792L20.792 36.1705ZM20.792 27.1705H28.792L28.792 19.1705H20.792L20.792 27.1705ZM29.792 19.1705L29.792 27.1705L37.792 27.1705L37.792 19.1705L29.792 19.1705ZM38.792 19.1705L38.792 27.1705H46.792L46.792 19.1705H38.792ZM47.792 19.1705L47.792 27.1705H55.792L55.792 19.1705H47.792ZM56.792 19.1705L56.792 27.1705L64.792 27.1705L64.792 19.1705L56.792 19.1705ZM65.792 19.1705V27.1705H73.792V19.1705H65.792ZM74.792 19.1705V27.1705H82.792V19.1705H74.792ZM83.792 19.1705V27.1705L91.792 27.1705V19.1705L83.792 19.1705ZM92.792 19.1705V27.1705H100.792V19.1705H92.792ZM101.792 19.1705V27.1705L109.792 27.1705V19.1705L101.792 19.1705ZM110.792 19.1705V27.1705H118.792V19.1705H110.792ZM119.792 19.1705V27.1705H127.792V19.1705H119.792ZM128.792 19.1705V27.1705L136.792 27.1705L136.792 19.1705L128.792 19.1705ZM137.792 19.1705L137.792 27.1705H145.792L145.792 19.1705H137.792ZM146.792 19.1705L146.792 27.1705H154.792L154.792 19.1705H146.792ZM155.792 19.1705L155.792 27.1705L163.792 27.1705L163.792 19.1705L155.792 19.1705ZM164.792 19.1705L164.792 27.1705H172.792L172.792 19.1705H164.792ZM173.792 19.1705L173.792 27.1705L181.792 27.1705L181.792 19.1705L173.792 19.1705ZM182.792 19.1705L182.792 27.1705H190.792L190.792 19.1705H182.792ZM191.792 19.1705L191.792 27.1705H199.792L199.792 19.1705H191.792ZM200.792 19.1705L200.792 27.1705L208.792 27.1706L208.792 19.1706L200.792 19.1705ZM209.792 19.1706L209.792 27.1706H217.792L217.792 19.1706H209.792ZM218.792 19.1706L218.792 27.1706H226.792L226.792 19.1706H218.792ZM227.792 19.1706L227.792 27.1706L235.792 27.1706L235.792 19.1706L227.792 19.1706ZM236.792 19.1706L236.792 27.1706H244.792L244.792 19.1706H236.792ZM245.792 19.1706L245.792 27.1706L253.792 27.1706L253.792 19.1706L245.792 19.1706ZM254.792 19.1706L254.792 27.1706H262.792V19.1706H254.792ZM263.792 19.1706V27.1706H271.792V19.1706H263.792ZM272.792 19.1706V27.1706L280.792 27.1706V19.1706L272.792 19.1706ZM280.792 28.1706L272.792 28.1706V36.1706H280.792V28.1706ZM280.792 37.1706H272.792L272.792 45.1706H280.792L280.792 37.1706ZM280.792 46.1706H272.792V54.1706H280.792V46.1706ZM271.792 54.1706V46.1706H263.792V54.1706H271.792ZM262.792 54.1706V46.1706H254.792V54.1706H262.792ZM253.792 54.1706V46.1706L245.792 46.1706V54.1706L253.792 54.1706ZM244.792 54.1706V46.1706H236.792V54.1706H244.792ZM235.792 54.1706V46.1706H227.792V54.1706H235.792ZM226.792 54.1706V46.1706H218.792V54.1706H226.792ZM217.792 54.1706V46.1706H209.792V54.1706H217.792ZM208.792 54.1706V46.1706L200.792 46.1705V54.1705L208.792 54.1706ZM199.792 54.1705V46.1705H191.792V54.1705H199.792ZM190.792 54.1705V46.1705H182.792V54.1705H190.792ZM181.792 54.1705V46.1705H173.792V54.1705H181.792ZM172.792 54.1705V46.1705H164.792V54.1705H172.792ZM163.792 54.1705V46.1705L155.792 46.1705V54.1705L163.792 54.1705ZM154.792 54.1705V46.1705H146.792V54.1705H154.792ZM145.792 54.1705V46.1705H137.792V54.1705H145.792ZM136.792 54.1705V46.1705H128.792L128.792 54.1705H136.792ZM127.792 54.1705L127.792 46.1705H119.792L119.792 54.1705H127.792ZM118.792 54.1705L118.792 46.1705L110.792 46.1705L110.792 54.1705L118.792 54.1705ZM109.792 54.1705L109.792 46.1705H101.792L101.792 54.1705H109.792ZM100.792 54.1705L100.792 46.1705H92.7919L92.7919 54.1705H100.792ZM91.7919 54.1705L91.7919 46.1705H83.7919L83.7919 54.1705H91.7919ZM82.7919 54.1705L82.7919 46.1705H74.7919L74.7919 54.1705H82.7919ZM73.7919 54.1705L73.7919 46.1705L65.7919 46.1705L65.7919 54.1705L73.7919 54.1705ZM64.7919 54.1705L64.7919 46.1705H56.7919L56.7919 54.1705H64.7919ZM55.7919 54.1705L55.7919 46.1705H47.7919L47.7919 54.1705H55.7919ZM46.7919 54.1705L46.7919 46.1705H38.7919L38.7919 54.1705H46.7919ZM37.7919 54.1705L37.7919 46.1705H29.7919L29.7919 54.1705H37.7919ZM29.7919 45.1705H37.7919L37.792 37.1705H29.792L29.7919 45.1705ZM29.792 36.1705H37.792L37.792 28.1705L29.792 28.1705L29.792 36.1705ZM38.792 28.1705L38.792 36.1705H46.792L46.792 28.1705H38.792ZM47.792 28.1705L47.792 36.1705H55.792L55.792 28.1705H47.792ZM56.792 28.1705L56.792 36.1705H64.792L64.792 28.1705L56.792 28.1705ZM65.792 28.1705L65.7919 36.1705L73.7919 36.1705L73.792 28.1705H65.792ZM74.792 28.1705L74.7919 36.1705H82.7919L82.792 28.1705H74.792ZM83.792 28.1705L83.7919 36.1705H91.7919L91.792 28.1705L83.792 28.1705ZM92.792 28.1705L92.7919 36.1705H100.792L100.792 28.1705H92.792ZM101.792 28.1705L101.792 36.1705H109.792L109.792 28.1705L101.792 28.1705ZM110.792 28.1705L110.792 36.1705L118.792 36.1705L118.792 28.1705H110.792ZM119.792 28.1705L119.792 36.1705H127.792L127.792 28.1705H119.792ZM128.792 28.1705L128.792 36.1705H136.792V28.1705L128.792 28.1705ZM137.792 28.1705V36.1705H145.792V28.1705H137.792ZM146.792 28.1705V36.1705H154.792V28.1705H146.792ZM155.792 28.1705V36.1705L163.792 36.1705V28.1705L155.792 28.1705ZM164.792 28.1705V36.1705H172.792V28.1705H164.792ZM173.792 28.1705V36.1705H181.792V28.1705L173.792 28.1705ZM182.792 28.1705V36.1705H190.792V28.1705H182.792ZM191.792 28.1705V36.1705H199.792V28.1705H191.792ZM200.792 28.1705V36.1705L208.792 36.1706V28.1706L200.792 28.1705ZM209.792 28.1706V36.1706H217.792V28.1706H209.792ZM218.792 28.1706V36.1706H226.792V28.1706H218.792ZM227.792 28.1706V36.1706H235.792V28.1706L227.792 28.1706ZM236.792 28.1706V36.1706H244.792V28.1706H236.792ZM245.792 28.1706V36.1706L253.792 36.1706V28.1706L245.792 28.1706ZM254.792 28.1706V36.1706H262.792V28.1706H254.792ZM263.792 28.1706V36.1706H271.792V28.1706H263.792ZM271.792 37.1706H263.792L263.792 45.1706H271.792L271.792 37.1706ZM262.792 45.1706L262.792 37.1706H254.792V45.1706H262.792ZM253.792 45.1706V37.1706L245.792 37.1706V45.1706L253.792 45.1706ZM244.792 45.1706V37.1706H236.792V45.1706H244.792ZM235.792 45.1706V37.1706H227.792V45.1706H235.792ZM226.792 45.1706V37.1706H218.792V45.1706H226.792ZM217.792 45.1706V37.1706H209.792V45.1706H217.792ZM208.792 45.1706V37.1706L200.792 37.1705V45.1705L208.792 45.1706ZM199.792 45.1705V37.1705H191.792V45.1705H199.792ZM190.792 45.1705V37.1705H182.792V45.1705H190.792ZM181.792 45.1705V37.1705H173.792V45.1705H181.792ZM172.792 45.1705V37.1705H164.792V45.1705H172.792ZM163.792 45.1705V37.1705L155.792 37.1705V45.1705L163.792 45.1705ZM154.792 45.1705V37.1705H146.792V45.1705H154.792ZM145.792 45.1705V37.1705H137.792V45.1705H145.792ZM136.792 45.1705V37.1705H128.792V45.1705H136.792ZM127.792 45.1705V37.1705H119.792V45.1705H127.792ZM118.792 45.1705V37.1705L110.792 37.1705V45.1705L118.792 45.1705ZM109.792 45.1705V37.1705H101.792V45.1705H109.792ZM100.792 45.1705V37.1705H92.7919V45.1705H100.792ZM91.7919 45.1705V37.1705H83.7919V45.1705H91.7919ZM82.7919 45.1705V37.1705H74.7919V45.1705H82.7919ZM73.7919 45.1705V37.1705L65.7919 37.1705V45.1705L73.7919 45.1705ZM64.7919 45.1705L64.792 37.1705H56.792L56.7919 45.1705H64.7919ZM55.7919 45.1705L55.792 37.1705H47.792L47.7919 45.1705H55.7919ZM46.7919 45.1705L46.792 37.1705H38.792L38.7919 45.1705H46.7919Z",
    fill: "black"
  })
}));
const Memo$4 = memo(UnionIcon);
const VectorIcon2 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 342 159",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M0 11.0289L10.237 0.79187H342V159H0V11.0289Z",
    fill: "#634135"
  })
}));
const Memo$3 = memo(VectorIcon2);
const VectorIcon3 = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 337 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    d: "M112.964 0H337V158H0V45H68.3088L112.964 0Z",
    fill: "#281906"
  })
}));
const Memo$2 = memo(VectorIcon3);
const VectorIcon = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 346 163",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: /* @__PURE__ */ jsx("path", {
    opacity: 0.2,
    d: "M11.4086 0.79187L0 12.2004V163H346V0.79187H11.4086Z",
    fill: "black"
  })
}));
const Memo$1 = memo(VectorIcon);
const AgentCard___PR_ = memo(function AgentCard___PR_2(props = {}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${((_a = props.classes) == null ? void 0 : _a.root) || ""} ${props.className || ""} ${classes$2.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes$2.vector,
      children: /* @__PURE__ */ jsx(Memo$1, {
        className: classes$2.icon7
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$2.vector2,
      children: /* @__PURE__ */ jsx(Memo$3, {
        className: classes$2.icon8
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$2.vector3,
      children: /* @__PURE__ */ jsx(Memo$2, {
        className: classes$2.icon9
      })
    }), /* @__PURE__ */ jsx("div", {
      className: classes$2.gridBG,
      children: /* @__PURE__ */ jsx("div", {
        className: classes$2.rectangle315
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$2.centerInfo,
      children: [/* @__PURE__ */ jsx("div", {
        className: `${((_b = props.classes) == null ? void 0 : _b.union) || ""} ${classes$2.union}`,
        children: /* @__PURE__ */ jsx(Memo$4, {
          className: classes$2.icon10
        })
      }), props.throwableState1 === "locked" ? /* @__PURE__ */ jsx(Throwable_Info_Property1Locked, {
        className: classes$2.throwable_Info2
      }) : props.throwableState1 === "none" ? /* @__PURE__ */ jsx(Throwable_Info_Property1Equipp, {
        className: classes$2.throwable_Info2
      }) : /* @__PURE__ */ jsx(Throwable_Info_Property1Defaul, {
        className: classes$2.throwable_Info2
      }), props.throwableState2 === "locked" ? /* @__PURE__ */ jsx(Throwable_Info_Property1Locked, {
        className: classes$2.throwable_Info
      }) : props.throwableState2 === "none" ? /* @__PURE__ */ jsx(Throwable_Info_Property1Equipp, {
        className: classes$2.throwable_Info
      }) : /* @__PURE__ */ jsx(Throwable_Info_Property1Defaul, {
        className: classes$2.throwable_Info
      }), props.vestState === "none" ? /* @__PURE__ */ jsx(BulletProof_Info_Property1Equi, {
        className: classes$2.bulletProof_Info
      }) : /* @__PURE__ */ jsx(BulletProof_Info_Property1Defa, {
        className: classes$2.bulletProof_Info,
        armor: (_c = props.vestArmor) == null ? void 0 : _c.toFixed(0)
      }), /* @__PURE__ */ jsx(Firearm_Info_varFirearmVarFire, {
        className: `${((_d = props.classes) == null ? void 0 : _d.firearm_Info) || ""} ${classes$2.firearm_Info}`,
        swap: {
          image_Firearm: ((_e = props.swap) == null ? void 0 : _e.image_Firearm) || /* @__PURE__ */ jsx(Memo$7, {
            className: classes$2.icon
          })
        },
        text: {
          ptFirearmGrade: (_f = props.text) == null ? void 0 : _f.ptFirearmGrade,
          ptFirearmType: (_g = props.text) == null ? void 0 : _g.ptFirearmType,
          ptFirearmName: (_h = props.text) == null ? void 0 : _h.ptFirearmName
        }
      }), /* @__PURE__ */ jsx("div", {
        className: `${((_i = props.classes) == null ? void 0 : _i.deco_Line) || ""} ${classes$2.deco_Line}`,
        children: /* @__PURE__ */ jsx(Memo$9, {
          className: classes$2.icon11
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$2.grade,
      children: [((_j = props.text) == null ? void 0 : _j.ptGradeBg) != null ? (_k = props.text) == null ? void 0 : _k.ptGradeBg : /* @__PURE__ */ jsx("div", {
        className: classes$2.ptGradeBg,
        children: "D"
      }), ((_l = props.text) == null ? void 0 : _l.ptGradeFg) != null ? (_m = props.text) == null ? void 0 : _m.ptGradeFg : /* @__PURE__ */ jsx("div", {
        className: classes$2.ptGradeFg,
        children: "D"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: classes$2.portrait,
      children: props.portrait
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$2.stat___HGAP7_,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes$2.life___VGAP2_,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$2.life___BOLD4,
          children: "\uC0DD\uBA85\uB825"
        }), ((_n = props.text) == null ? void 0 : _n.ptLifeValue) != null ? (_o = props.text) == null ? void 0 : _o.ptLifeValue : /* @__PURE__ */ jsx("div", {
          className: classes$2.ptLifeValue,
          children: "65"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: classes$2.frame181,
        children: /* @__PURE__ */ jsx(Memo$8, {
          className: classes$2.icon12
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$2.overall___VGAP2_,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$2.overall___BOLD4,
          children: "\uC804\uD22C\uB825"
        }), ((_p = props.text) == null ? void 0 : _p.ptOverallValue) != null ? (_q = props.text) == null ? void 0 : _q.ptOverallValue : /* @__PURE__ */ jsx("div", {
          className: classes$2.ptOverallValue,
          children: "5.8"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$2.base,
      children: [/* @__PURE__ */ jsx("div", {
        className: classes$2.bg
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$2.perk___HGAP4_,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$2.perk,
          children: /* @__PURE__ */ jsx(Memo$5, {
            className: classes$2.icon14
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$2.perk___VGAP1_,
          children: [((_r = props.text) == null ? void 0 : _r.ptPerkpoint) != null ? (_s = props.text) == null ? void 0 : _s.ptPerkpoint : /* @__PURE__ */ jsx("div", {
            className: classes$2.ptPerkpoint,
            children: "1"
          }), /* @__PURE__ */ jsx("div", {
            className: classes$2.frame183
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$2.agentName___HGAP6_,
        children: [/* @__PURE__ */ jsx(Button_CheckBox_AgentCard_Prop, {
          swap: {
            off: ((_t = props.swap) == null ? void 0 : _t.off) || /* @__PURE__ */ jsx(Memo$6, {
              className: classes$2.icon6
            })
          }
        }), /* @__PURE__ */ jsxs("div", {
          className: classes$2.name___HGAP2_,
          children: [((_u = props.text) == null ? void 0 : _u.ptName) != null ? (_v = props.text) == null ? void 0 : _v.ptName : /* @__PURE__ */ jsx("div", {
            className: classes$2.ptName,
            children: "Rodrigo \u201CPartner\u201D Varga"
          }), ((_w = props.text) == null ? void 0 : _w.ptAge) != null ? (_x = props.text) == null ? void 0 : _x.ptAge : /* @__PURE__ */ jsx("div", {
            className: classes$2.ptAge,
            children: "(23)"
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: classes$2.level,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$2.bg2,
          children: /* @__PURE__ */ jsx(Memo$a, {
            className: classes$2.icon15
          })
        }), ((_y = props.text) == null ? void 0 : _y.ptLevel) != null ? (_z = props.text) == null ? void 0 : _z.ptLevel : /* @__PURE__ */ jsx("div", {
          className: classes$2.ptLevel,
          children: "7"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: classes$2.exp,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes$2.progressBar,
        children: [/* @__PURE__ */ jsx("div", {
          className: classes$2.frame
        }), /* @__PURE__ */ jsx("div", {
          className: classes$2.bg3
        }), /* @__PURE__ */ jsx("div", {
          className: classes$2.progress,
          style: (_A = props.expProgressStyle) != null ? _A : {}
        }), /* @__PURE__ */ jsx("div", {
          className: classes$2.shadow
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: classes$2.exp___BOLD6,
        children: "EXP"
      })]
    }), ((_B = props.swap) == null ? void 0 : _B.aC_mouse) || /* @__PURE__ */ jsx(AC_mouse_varMousePress, {}), ((_C = props.swap) == null ? void 0 : _C.aC_state) || /* @__PURE__ */ jsx(AC_state_varStateKiiledInActio, {
      className: classes$2.aC_state
    })]
  });
});
const aC_state$1 = "_aC_state_ldrum_1";
const root$1 = "_root_ldrum_5";
const classes$1 = {
  aC_state: aC_state$1,
  root: root$1
};
const AC_mouse_varMouseDefault = memo(function AC_mouse_varMouseDefault2(props = {}) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$1.root}`,
    children: /* @__PURE__ */ jsx(AC_state_varStateDefault, {
      className: classes$1.aC_state
    })
  });
});
const aC_state = "_aC_state_dbge6_1";
const root = "_root_dbge6_5";
const selected = "_selected_dbge6_13";
const icon = "_icon_dbge6_20";
const classes = {
  aC_state,
  root,
  selected,
  icon
};
const SelectedIcon = (props) => /* @__PURE__ */ jsxs("svg", __spreadProps(__spreadValues({
  preserveAspectRatio: "none",
  viewBox: "0 0 352 170",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {
  children: [/* @__PURE__ */ jsx("path", {
    d: "M4 15.5V3.5H16L4 15.5Z",
    fill: "white"
  }), /* @__PURE__ */ jsx("rect", {
    width: 352,
    height: 170,
    stroke: "white",
    strokeWidth: 4
  })]
}));
const Memo = memo(SelectedIcon);
const AC_mouse_varMouseSelected = memo(function AC_mouse_varMouseSelected2(props = {}) {
  return /* @__PURE__ */ jsxs("div", {
    className: `${resets.storybrainResets} ${classes.root}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: classes.selected,
      children: /* @__PURE__ */ jsx(Memo, {
        className: classes.icon
      })
    }), /* @__PURE__ */ jsx(AC_state_varStateDefault, {
      className: classes.aC_state
    })]
  });
});
const AgentCardWrapper = function(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const {
    onAgentDetail
  } = props;
  const a = props.agent;
  const {
    selected: selected2
  } = a;
  const selectedSwap = selected2 ? /* @__PURE__ */ jsx(AC_mouse_varMouseSelected, {}) : /* @__PURE__ */ jsx(AC_mouse_varMouseDefault, {});
  const exp_min = 0;
  const exp_max = a.exp_cap;
  const exp_cur = a.level.exp;
  const exp_ratio = (exp_cur - exp_min) / (exp_max - exp_min);
  const graph_width = 300;
  const graph_right = Math.round(graph_width - graph_width * exp_ratio);
  const expProgressStyle = {
    right: graph_right
  };
  const {
    throwable_unlocked_1,
    throwable_unlocked_2,
    throwables
  } = a;
  const throwableState1 = throwable_unlocked_1 ? ((_b = (_a = throwables[0]) == null ? void 0 : _a.throwable_name) == null ? void 0 : _b.toLowerCase()) !== "none" ? "grenade" : "none" : "locked";
  const throwableState2 = throwable_unlocked_2 ? ((_d = (_c = throwables[1]) == null ? void 0 : _c.throwable_name) == null ? void 0 : _d.toLowerCase()) !== "none" ? "grenade" : "none" : "locked";
  const vestState = ((_f = (_e = a.equipment) == null ? void 0 : _e.vest_name) == null ? void 0 : _f.toLowerCase()) === "none" ? "none" : "vest";
  const vestArmor = (_h = (_g = a.equipment) == null ? void 0 : _g.vest_armor) != null ? _h : 0;
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      onClick: () => onAgentDetail && onAgentDetail(a),
      style: {
        position: "relative",
        width: 352,
        height: 170
      },
      children: /* @__PURE__ */ jsx(AgentCard___PR_, {
        portrait: a.portrait,
        expProgressStyle,
        throwableState1,
        throwableState2,
        vestState,
        vestArmor,
        className: classes$C.agentCard___PR_Instance,
        swap: {
          aC_mouse: selectedSwap,
          aC_state: /* @__PURE__ */ jsx(AC_state_varStateDefault, {
            className: classes$C.aC_state6
          }),
          image_Firearm: a.firearm_shape
        },
        text: {
          ptFirearmGrade: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptFirearmGrade,
            children: (_i = a.firearm) == null ? void 0 : _i.firearm_rate
          }),
          ptFirearmType: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptFirearmType,
            children: (_j = a.firearm) == null ? void 0 : _j.firearm_ty.toUpperCase()
          }),
          ptFirearmName: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptFirearmName,
            children: (_k = a.firearm) == null ? void 0 : _k.firearm_name
          }),
          ptGradeBg: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptGradeBg,
            children: a.grade
          }),
          ptGradeFg: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptGradeFg,
            children: a.grade
          }),
          ptLifeValue: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptLifeValue,
            children: a.life.toFixed(0)
          }),
          ptOverallValue: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptOverallValue,
            children: a.overall.toFixed(1)
          }),
          ptPhysicalValue: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptPhysicalValue,
            children: a.physical.toFixed(1)
          }),
          ptPerkpoint: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptPerkpoint,
            children: a.perks_point_total
          }),
          ptName: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptName,
            children: a.name
          }),
          ptAge: /* @__PURE__ */ jsxs("div", {
            className: classes$C.ptAge,
            children: ["(", a.age, ")"]
          }),
          ptLevel: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptLevel,
            children: a.level.cur
          })
        }
      })
    })
  });
};
const AgentListWrapper = function(props) {
  const {
    title: title2,
    agents,
    onAgentDetail,
    name: name2,
    expiryLabel,
    expiryValue,
    body: body2
  } = props;
  const {
    tabs,
    tab_selected,
    onTabSelected
  } = props;
  const agent_cards = agents.map((a) => /* @__PURE__ */ jsx(AgentCardWrapper, {
    agent: a,
    onAgentDetail
  }, a.name));
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs("div", {
      className: `${resets.storybrainResets} ${classes$C.root}`,
      children: [/* @__PURE__ */ jsx(AgentDetailBg, {}), /* @__PURE__ */ jsx(AgentList, {
        onClickClose: props.onClickClose,
        filter: props.filter,
        text: {
          ptTotalValue: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptTotalValue,
            children: agents.length
          }),
          title: title2
        },
        children: agent_cards
      }), /* @__PURE__ */ jsx(AgentDetail, {
        tabs,
        tab_selected,
        onTabSelected,
        body: body2,
        text: {
          ptAgentName: /* @__PURE__ */ jsx("div", {
            className: classes$C.ptAgentName,
            children: name2
          }),
          expiryLabel,
          expiryValue
        }
      })]
    })
  });
};
const AgentDetailWrapper = function(props) {
  const {
    name: name2,
    tabs,
    tab_selected,
    onTabSelected,
    body: body2
  } = props;
  return /* @__PURE__ */ jsx(AgentDetail, {
    tabs,
    tab_selected,
    onTabSelected,
    body: body2,
    text: {
      ptAgentName: name2 ? /* @__PURE__ */ jsx("div", {
        className: classes$C.ptAgentName,
        children: name2
      }) : null
    }
  });
};
const AgentDetailOverviewPlaceholder = function(props) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes_agentdetail.agentDetailOverview} ${classes_detailoverview.root}`,
    children: props.body
  });
};
function damage_avg(arr) {
  if (!arr || arr.length === 0) {
    return 0;
  }
  const sample_size = 5;
  const samples = arr.slice(-sample_size);
  const len = samples.length;
  const sum = samples.reduce((a, b) => a + b, 0);
  const avg = sum / len;
  return avg;
}
function numbers_to_widths(num1, num2, total_width) {
  const half1 = Math.round(total_width / 2);
  const half2 = total_width - half1;
  const default_ = {
    width1: half1,
    width2: half2
  };
  if (num1 < 0 || num2 < 0) {
    return default_;
  }
  if (num1 === 0 && num2 === 0) {
    return default_;
  }
  const width1 = Math.round(num1 / (num1 + num2) * total_width);
  const width2 = total_width - width1;
  return {
    width1,
    width2
  };
}
const AgentDetailOverviewWrapper = function(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const {
    agent
  } = props;
  const graph_width = 570;
  const damage_done = damage_avg(agent.mission_stats.damage_done);
  const damage_taken = damage_avg(agent.mission_stats.damage_taken);
  const {
    width1: damage_done_width,
    width2: damage_taken_width
  } = numbers_to_widths(damage_done, damage_taken, graph_width);
  const {
    width1: win_width,
    width2: lose_width
  } = numbers_to_widths(agent.mission_stats.wins, agent.mission_stats.loses, graph_width);
  return /* @__PURE__ */ jsx(AgentDetailOverview, {
    agent: props.agent,
    graphWidthDamageDone: damage_done_width,
    graphWidthDamageTaken: damage_taken_width,
    graphWidthWin: win_width,
    graphWidthLose: lose_width,
    tooltipHandlers: props.tooltipHandlers,
    onAgentEquipPopupFirearm: props.onAgentEquipPopupFirearm,
    onAgentEquipPopupThrowable1: props.onAgentEquipPopupThrowable1,
    onAgentEquipPopupThrowable2: props.onAgentEquipPopupThrowable2,
    onAgentEquipPopupEquipment: props.onAgentEquipPopupEquipment,
    throwableUnlocked1: props.throwableUnlocked1,
    throwableUnlocked2: props.throwableUnlocked2,
    className: classes_agentdetail.agentDetailOverview,
    portrait: agent.portrait,
    text: {
      ptContribution: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptContribution,
        children: "$ " + agent.contribution.toLocaleString("en-US")
      }),
      ptResultDamageTaken: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptResultDamageTaken,
        children: damage_taken.toFixed(0)
      }),
      ptResultDamageDone: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptResultDamageDone,
        children: damage_done.toFixed(0)
      }),
      ptResultMissionLose: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptResultMissionLose,
        children: agent.mission_stats.loses
      }),
      ptResultMissionWin: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptResultMissionWin,
        children: agent.mission_stats.wins
      }),
      ptItemText: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptItemText,
        children: agent.age
      }),
      ptItemText2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptItemText2,
        children: agent.background.name
      }),
      ptItemText3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptItemText3,
        children: agent.language
      }),
      ptNation: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptNation,
        children: agent.nationality.nation
      }),
      ptGradeName: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeName,
        children: "\uC131\uC7A5 \uD55C\uACC4"
      }),
      ptGradeValue: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeValue,
        children: agent.growth_grade
      }),
      ptGradeName2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeName2,
        children: "\uC131\uC7A5\uC131"
      }),
      ptGradeValue2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeValue2,
        children: agent.grade
      }),
      ptGradeName3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeName3,
        children: "Physical"
      }),
      ptGradeValue3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGradeValue3,
        children: agent.physical_grade
      }),
      ptValue: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptValue,
        children: agent.life.toFixed(0)
      }),
      ptMax: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptMax,
        children: "/" + agent.life_max.toFixed(0)
      }),
      ptValue2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptValue2,
        children: agent.overall.toFixed(1)
      }),
      ptMax2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptMax2,
        children: "/" + agent.overall_cap.toFixed(1)
      }),
      ptValue3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptValue3,
        children: agent.physical
      }),
      ptMax3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptMax3,
        children: "/" + agent.physical_cap.toFixed(1)
      }),
      ptGrade: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGrade,
        children: agent.grade
      }),
      ptGrade2: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptGrade2,
        children: agent.grade
      }),
      ptExpValue: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptExpValue,
        children: agent.level.exp.toFixed(0)
      }),
      ptMax4: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptMax4,
        children: "/" + agent.exp_cap
      }),
      ptLevelValue: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptLevelValue,
        children: agent.level.cur
      }),
      ptDropFirearmName3: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptDropFirearmName,
        children: (_a = agent.firearm) == null ? void 0 : _a.firearm_name
      }),
      ptDropFirearmType: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptDropFirearmType,
        children: (_b = agent.firearm) == null ? void 0 : _b.firearm_ty.toUpperCase()
      }),
      ptDropFirearmRate: /* @__PURE__ */ jsx("div", {
        className: classes$C.ptDropFirearmRate,
        children: (_c = agent.firearm) == null ? void 0 : _c.firearm_rate
      }),
      ptDropFirearmName2: /* @__PURE__ */ jsxs("div", {
        className: classes$C.ptDropFirearmName3,
        children: [(_d = agent.equipment) == null ? void 0 : _d.vest_name, ((_e = agent.equipment) == null ? void 0 : _e.vest_armor) && ((_f = agent.equipment) == null ? void 0 : _f.vest_armor) > 0 ? ` / ${(_g = agent.equipment) == null ? void 0 : _g.vest_armor}` : ""]
      }),
      ptDropFirearmName: /* @__PURE__ */ jsxs(Fragment, {
        children: [(_h = agent.throwables[0]) == null ? void 0 : _h.throwable_name, " ", ((_i = agent.throwables[0]) == null ? void 0 : _i.throwable_rate) > 0 ? `(${(_j = agent.throwables[0]) == null ? void 0 : _j.throwable_rate})` : ""]
      }),
      ptDropFirearmName4: /* @__PURE__ */ jsxs(Fragment, {
        children: [(_k = agent.throwables[1]) == null ? void 0 : _k.throwable_name, " ", ((_l = agent.throwables[1]) == null ? void 0 : _l.throwable_rate) > 0 ? `(${(_m = agent.throwables[1]) == null ? void 0 : _m.throwable_rate})` : ""]
      })
    },
    swap: {
      image_Firearm: props.firearmShape
    }
  });
};
const MercenariesAgentFull = AgentListWrapper;
const MercenariesAgentDetail = AgentDetailWrapper;
const MercenariesAgentDetailOverview = AgentDetailOverviewWrapper;
const MercenariesAgentDetailPlaceholder = AgentDetailOverviewPlaceholder;
const ResetRoot = function(props) {
  return /* @__PURE__ */ jsx("div", {
    className: `${resets.storybrainResets} ${classes$D.root} ${props.className}`,
    style: props.style,
    children: props.children
  });
};
const App = function(props) {
  const {
    agents
  } = props;
  const agent = agents[0];
  useState("OVERVIEW");
  const tabs = ["\uAC1C\uC694", "\uC2A4\uD0EF"];
  const body2 = /* @__PURE__ */ jsx(AgentDetailOverviewWrapper, {
    agent
  });
  return /* @__PURE__ */ jsxs("ol", {
    children: [/* @__PURE__ */ jsxs("li", {
      children: [/* @__PURE__ */ jsx("p", {
        children: "AgentDetailWrapper"
      }), /* @__PURE__ */ jsx(ResetRoot, {
        children: /* @__PURE__ */ jsx(AgentListWrapper, {
          agents,
          tabs,
          tab_selected: tabs[0],
          name: "Foo",
          expiryLabel: "Bar",
          expiryValue: "Baz",
          onTabSelected: () => {
          },
          body: body2
        })
      })]
    }), /* @__PURE__ */ jsxs("li", {
      children: [/* @__PURE__ */ jsx("p", {
        children: "\uADF8\uB0E5 \uBE48 \uD53C\uADF8\uB9C8 \uB8E8\uD2B8"
      }), /* @__PURE__ */ jsx(ResetRoot, {})]
    })]
  });
};
export {
  App,
  MercenariesAgentDetail,
  MercenariesAgentDetailOverview,
  MercenariesAgentDetailPlaceholder,
  MercenariesAgentFull,
  ResetRoot
};
